export interface GPU {
  id: number;
  name: string;
  price?: number;
  g2d: number;
  dx9: number;
  dx10: number;
  dx11: number;
  dx12: number;
  overallSpeed: number;
  pricePerG3D?: number;
}

export const gpus: GPU[] = [
  {
    id: 5,
    name: "15FF",
    g2d: 538,
    dx9: 143,
    dx10: 89,
    dx11: 154,
    dx12: 32,
    overallSpeed: 8229,
  },
  {
    id: 33,
    name: "Barco MXRT 5450",
    g2d: 478,
    price: 59.99,
    dx9: 29,
    dx10: 11,
    dx11: 25,
    dx12: 0,
    overallSpeed: 1079,
    pricePerG3D: 17.99,
  },
  {
    id: 40,
    name: "CARRIZO 9874",
    g2d: 69,
    dx9: 4,
    dx10: 1,
    dx11: 6,
    dx12: 1,
    overallSpeed: 247,
  },
  {
    id: 47,
    name: "EG PARK",
    g2d: 7,
    dx9: 8,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 141,
  },
  {
    id: 48,
    name: "EIZO Quadro MED-XN51LP",
    g2d: 812,
    dx9: 81,
    dx10: 47,
    dx11: 80,
    dx12: 21,
    overallSpeed: 4955,
  },
  {
    id: 49,
    name: "Embedded Radeon E9173",
    g2d: 309,
    dx9: 30,
    dx10: 10,
    dx11: 27,
    dx12: 7,
    overallSpeed: 1546,
  },
  {
    id: 79,
    name: "FirePro 2270",
    g2d: 230,
    price: 129,
    dx9: 7,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 154,
    pricePerG3D: 1.2,
  },
  {
    id: 81,
    name: "FirePro 2460",
    g2d: 352,
    price: 83.99,
    dx9: 7,
    dx10: 2,
    dx11: 3,
    dx12: 0,
    overallSpeed: 170,
    pricePerG3D: 2.03,
  },
  {
    id: 85,
    name: "FirePro 3D V4800",
    g2d: 324,
    price: 159.99,
    dx9: 23,
    dx10: 8,
    dx11: 19,
    dx12: 0,
    overallSpeed: 854,
    pricePerG3D: 5.33,
  },
  {
    id: 87,
    name: "FirePro 3D V5800",
    g2d: 339,
    price: 199,
    dx9: 33,
    dx10: 11,
    dx11: 25,
    dx12: 0,
    overallSpeed: 1232,
    pricePerG3D: 6.19,
  },
  {
    id: 94,
    name: "FirePro M2000",
    g2d: 206,
    dx9: 9,
    dx10: 3,
    dx11: 10,
    dx12: 0,
    overallSpeed: 401,
  },
  {
    id: 95,
    name: "FirePro M4000",
    g2d: 400,
    price: 72.83,
    dx9: 31,
    dx10: 12,
    dx11: 23,
    dx12: 8,
    overallSpeed: 1584,
    pricePerG3D: 21.75,
  },
  {
    id: 96,
    name: "FirePro M4000 Mobility Pro",
    g2d: 477,
    dx9: 34,
    dx10: 13,
    dx11: 21,
    dx12: 8,
    overallSpeed: 1620,
  },
  {
    id: 99,
    name: "FirePro M4150",
    g2d: 216,
    dx9: 18,
    dx10: 9,
    dx11: 13,
    dx12: 4,
    overallSpeed: 973,
  },
  {
    id: 100,
    name: "FirePro M4170",
    g2d: 290,
    dx9: 23,
    dx10: 9,
    dx11: 16,
    dx12: 5,
    overallSpeed: 1067,
  },
  {
    id: 105,
    name: "FirePro M6000 Mobility Pro",
    g2d: 333,
    dx9: 30,
    dx10: 12,
    dx11: 21,
    dx12: 7,
    overallSpeed: 1623,
  },
  {
    id: 106,
    name: "FirePro M6100",
    g2d: 419,
    dx9: 52,
    dx10: 20,
    dx11: 29,
    dx12: 10,
    overallSpeed: 2094,
  },
  {
    id: 107,
    name: "FirePro M6100 FireGL V",
    g2d: 519,
    dx9: 58,
    dx10: 18,
    dx11: 36,
    dx12: 11,
    overallSpeed: 2656,
  },
  {
    id: 115,
    name: "FirePro S9050",
    g2d: 10,
    dx9: 82,
    dx10: 51,
    dx11: 62,
    dx12: 0,
    overallSpeed: 3912,
  },
  {
    id: 116,
    name: "FirePro V3800",
    g2d: 191,
    price: 125,
    dx9: 8,
    dx10: 2,
    dx11: 8,
    dx12: 0,
    overallSpeed: 323,
    pricePerG3D: 2.58,
  },
  {
    id: 117,
    name: "FirePro V3900",
    g2d: 245,
    price: 238.44,
    dx9: 16,
    dx10: 5,
    dx11: 17,
    dx12: 0,
    overallSpeed: 672,
    pricePerG3D: 2.82,
  },
  {
    id: 118,
    name: "FirePro V4900",
    g2d: 325,
    price: 59,
    dx9: 24,
    dx10: 9,
    dx11: 22,
    dx12: 0,
    overallSpeed: 984,
    pricePerG3D: 16.68,
  },
  {
    id: 120,
    name: "FirePro V5800",
    g2d: 420,
    price: 69,
    dx9: 32,
    dx10: 11,
    dx11: 26,
    dx12: 0,
    overallSpeed: 1267,
    pricePerG3D: 18.36,
  },
  {
    id: 121,
    name: "FirePro V5900",
    g2d: 357,
    price: 99,
    dx9: 40,
    dx10: 14,
    dx11: 28,
    dx12: 0,
    overallSpeed: 1279,
    pricePerG3D: 12.92,
  },
  {
    id: 123,
    name: "FirePro V7800",
    g2d: 384,
    price: 185,
    dx9: 48,
    dx10: 27,
    dx11: 31,
    dx12: 0,
    overallSpeed: 2030,
    pricePerG3D: 10.97,
  },
  {
    id: 124,
    name: "FirePro V7900",
    g2d: 480,
    price: 125,
    dx9: 67,
    dx10: 32,
    dx11: 39,
    dx12: 0,
    overallSpeed: 2297,
    pricePerG3D: 18.38,
  },
  {
    id: 126,
    name: "FirePro V8800",
    g2d: 375,
    price: 199,
    dx9: 49,
    dx10: 29,
    dx11: 38,
    dx12: 0,
    overallSpeed: 2267,
    pricePerG3D: 11.39,
  },
  {
    id: 128,
    name: "FirePro W2100",
    g2d: 331,
    price: 59,
    dx9: 17,
    dx10: 5,
    dx11: 17,
    dx12: 4,
    overallSpeed: 876,
    pricePerG3D: 14.84,
  },
  {
    id: 129,
    name: "FirePro W4100",
    g2d: 533,
    price: 252,
    dx9: 30,
    dx10: 12,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1533,
    pricePerG3D: 6.08,
  },
  {
    id: 130,
    name: "FirePro W4170M",
    g2d: 226,
    dx9: 24,
    dx10: 8,
    dx11: 13,
    dx12: 4,
    overallSpeed: 912,
  },
  {
    id: 131,
    name: "Firepro W4190M",
    g2d: 205,
    dx9: 23,
    dx10: 9,
    dx11: 18,
    dx12: 5,
    overallSpeed: 1113,
  },
  {
    id: 132,
    name: "FirePro W4300",
    g2d: 762,
    price: 239.99,
    dx9: 48,
    dx10: 18,
    dx11: 44,
    dx12: 12,
    overallSpeed: 2734,
    pricePerG3D: 11.39,
  },
  {
    id: 133,
    name: "FirePro W5000",
    g2d: 575,
    price: 99.99,
    dx9: 64,
    dx10: 20,
    dx11: 54,
    dx12: 12,
    overallSpeed: 2971,
    pricePerG3D: 29.71,
  },
  {
    id: 134,
    name: "FirePro W5100",
    g2d: 494,
    price: 285,
    dx9: 50,
    dx10: 19,
    dx11: 47,
    dx12: 18,
    overallSpeed: 2835,
    pricePerG3D: 9.95,
  },
  {
    id: 135,
    name: "FirePro W5130M",
    g2d: 346,
    dx9: 32,
    dx10: 10,
    dx11: 23,
    dx12: 6,
    overallSpeed: 1428,
  },
  {
    id: 136,
    name: "Firepro W5170M",
    g2d: 441,
    dx9: 39,
    dx10: 13,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1673,
  },
  {
    id: 137,
    name: "FirePro W600",
    g2d: 631,
    price: 355,
    dx9: 35,
    dx10: 13,
    dx11: 29,
    dx12: 8,
    overallSpeed: 1752,
    pricePerG3D: 4.93,
  },
  {
    id: 138,
    name: "FirePro W6150M",
    g2d: 314,
    dx9: 59,
    dx10: 21,
    dx11: 19,
    dx12: 5,
    overallSpeed: 1515,
  },
  {
    id: 139,
    name: "FirePro W7000",
    g2d: 585,
    price: 339,
    dx9: 75,
    dx10: 35,
    dx11: 74,
    dx12: 22,
    overallSpeed: 4340,
    pricePerG3D: 12.8,
  },
  {
    id: 140,
    name: "FirePro W7000 Adapter",
    g2d: 692,
    dx9: 71,
    dx10: 35,
    dx11: 76,
    dx12: 21,
    overallSpeed: 4340,
  },
  {
    id: 141,
    name: "FirePro W7100",
    g2d: 609,
    price: 739,
    dx9: 86,
    dx10: 44,
    dx11: 74,
    dx12: 24,
    overallSpeed: 4775,
    pricePerG3D: 6.46,
  },
  {
    id: 142,
    name: "FirePro W7170M",
    g2d: 438,
    dx9: 47,
    dx10: 38,
    dx11: 54,
    dx12: 19,
    overallSpeed: 3849,
  },
  {
    id: 143,
    name: "FirePro W8000",
    g2d: 613,
    price: 568,
    dx9: 45,
    dx10: 48,
    dx11: 80,
    dx12: 27,
    overallSpeed: 3454,
    pricePerG3D: 6.08,
  },
  {
    id: 144,
    name: "FirePro W8100",
    g2d: 732,
    price: 699,
    dx9: 121,
    dx10: 82,
    dx11: 113,
    dx12: 35,
    overallSpeed: 7234,
    pricePerG3D: 10.35,
  },
  {
    id: 145,
    name: "FirePro W9000",
    g2d: 720,
    price: 840,
    dx9: 97,
    dx10: 62,
    dx11: 88,
    dx12: 33,
    overallSpeed: 6138,
    pricePerG3D: 7.31,
  },
  {
    id: 146,
    name: "FirePro W9100",
    g2d: 884,
    price: 2050,
    dx9: 133,
    dx10: 89,
    dx11: 132,
    dx12: 36,
    overallSpeed: 7750,
    pricePerG3D: 3.78,
  },
  {
    id: 153,
    name: "GeForce 210",
    g2d: 47,
    price: 56.98,
    dx9: 4,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 97,
    pricePerG3D: 1.7,
  },
  {
    id: 157,
    name: "GeForce 310",
    g2d: 75,
    price: 108.35,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 121,
    pricePerG3D: 1.12,
  },
  {
    id: 158,
    name: "GeForce 310M",
    g2d: 30,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 113,
  },
  {
    id: 159,
    name: "GeForce 315",
    g2d: 97,
    price: 32.99,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 163,
    pricePerG3D: 4.95,
  },
  {
    id: 160,
    name: "GeForce 315M",
    g2d: 64,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 119,
  },
  {
    id: 161,
    name: "GeForce 320M",
    g2d: 85,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 202,
  },
  {
    id: 162,
    name: "GeForce 405",
    g2d: 72,
    price: 24.64,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 122,
    pricePerG3D: 4.95,
  },
  {
    id: 163,
    name: "GeForce 410M",
    g2d: 135,
    dx9: 5,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 246,
  },
  {
    id: 165,
    name: "GeForce 510",
    g2d: 211,
    price: 69.99,
    dx9: 6,
    dx10: 2,
    dx11: 6,
    dx12: 1,
    overallSpeed: 253,
    pricePerG3D: 3.61,
  },
  {
    id: 166,
    name: "GeForce 605",
    g2d: 192,
    price: 136.83,
    dx9: 8,
    dx10: 2,
    dx11: 7,
    dx12: 1,
    overallSpeed: 309,
    pricePerG3D: 2.26,
  },
  {
    id: 172,
    name: "GeForce 610M",
    g2d: 105,
    dx9: 6,
    dx10: 2,
    dx11: 6,
    dx12: 0,
    overallSpeed: 288,
  },
  {
    id: 173,
    name: "GeForce 615",
    g2d: 412,
    dx9: 14,
    dx10: 5,
    dx11: 11,
    dx12: 2,
    overallSpeed: 552,
  },
  {
    id: 181,
    name: "GeForce 6200 TurboCache",
    g2d: 78,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 46,
  },
  {
    id: 183,
    name: "GeForce 6200SE TurboCache",
    g2d: 146,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 37,
  },
  {
    id: 185,
    name: "GeForce 6600",
    g2d: 108,
    price: 259,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 88,
    pricePerG3D: 0.34,
  },
  {
    id: 186,
    name: "GeForce 6600 GT",
    g2d: 108,
    price: 64.95,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 111,
    pricePerG3D: 1.71,
  },
  {
    id: 191,
    name: "GeForce 6800 GS",
    g2d: 121,
    dx9: 6,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 195,
  },
  {
    id: 197,
    name: "GeForce 6800 XT",
    g2d: 197,
    dx9: 4,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 135,
  },
  {
    id: 202,
    name: "GeForce 7050 / nForce 620i",
    g2d: 129,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 39,
  },
  {
    id: 207,
    name: "GeForce 7100 / nForce 630i",
    g2d: 81,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 36,
  },
  {
    id: 208,
    name: "GeForce 7100 GS",
    g2d: 133,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 52,
  },
  {
    id: 209,
    name: "GeForce 710A",
    g2d: 364,
    dx9: 13,
    dx10: 3,
    dx11: 12,
    dx12: 0,
    overallSpeed: 487,
  },
  {
    id: 210,
    name: "GeForce 710M",
    g2d: 112,
    dx9: 10,
    dx10: 4,
    dx11: 9,
    dx12: 0,
    overallSpeed: 443,
  },
  {
    id: 215,
    name: "GeForce 7300 GS",
    g2d: 64,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 80,
  },
  {
    id: 216,
    name: "GeForce 7300 GT",
    g2d: 47,
    price: 149.99,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 138,
    pricePerG3D: 0.92,
  },
  {
    id: 219,
    name: "GeForce 7300 SE/7200 GS",
    g2d: 46,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 53,
  },
  {
    id: 220,
    name: "GeForce 730A",
    g2d: 215,
    dx9: 16,
    dx10: 4,
    dx11: 15,
    dx12: 4,
    overallSpeed: 773,
  },
  {
    id: 222,
    name: "GeForce 7500 LE",
    g2d: 108,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 66,
  },
  {
    id: 223,
    name: "GeForce 7600 GS",
    g2d: 55,
    price: 175,
    dx9: 4,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 167,
    pricePerG3D: 0.95,
  },
  {
    id: 224,
    name: "GeForce 7600 GT",
    g2d: 101,
    price: 199,
    dx9: 5,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 204,
    pricePerG3D: 1.02,
  },
  {
    id: 228,
    name: "GeForce 7800 GT",
    g2d: 273,
    price: 80,
    dx9: 7,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 244,
    pricePerG3D: 3.05,
  },
  {
    id: 229,
    name: "GeForce 7800 GTX",
    g2d: 196,
    dx9: 9,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 291,
  },
  {
    id: 230,
    name: "GeForce 7900 GS",
    g2d: 133,
    dx9: 8,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 292,
  },
  {
    id: 233,
    name: "GeForce 7900 GTX",
    g2d: 165,
    dx9: 10,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 388,
  },
  {
    id: 234,
    name: "GeForce 7950 GT",
    g2d: 189,
    price: 198,
    dx9: 9,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 344,
    pricePerG3D: 1.74,
  },
  {
    id: 238,
    name: "GeForce 800M",
    g2d: 388,
    dx9: 12,
    dx10: 2,
    dx11: 11,
    dx12: 0,
    overallSpeed: 468,
  },
  {
    id: 240,
    name: "GeForce 810A",
    g2d: 319,
    dx9: 14,
    dx10: 3,
    dx11: 13,
    dx12: 3,
    overallSpeed: 622,
  },
  {
    id: 241,
    name: "GeForce 810M",
    g2d: 71,
    dx9: 7,
    dx10: 3,
    dx11: 9,
    dx12: 2,
    overallSpeed: 398,
  },
  {
    id: 242,
    name: "GeForce 8200",
    g2d: 163,
    dx9: 2,
    dx10: 10,
    dx11: 0,
    dx12: 0,
    overallSpeed: 153,
  },
  {
    id: 243,
    name: "GeForce 8200M G",
    g2d: 72,
    dx9: 1,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 72,
  },
  {
    id: 244,
    name: "GeForce 820A",
    g2d: 162,
    dx9: 14,
    dx10: 4,
    dx11: 15,
    dx12: 0,
    overallSpeed: 568,
  },
  {
    id: 245,
    name: "GeForce 820M",
    g2d: 113,
    dx9: 11,
    dx10: 4,
    dx11: 13,
    dx12: 1,
    overallSpeed: 517,
  },
  {
    id: 246,
    name: "GeForce 825M",
    g2d: 293,
    dx9: 14,
    dx10: 4,
    dx11: 15,
    dx12: 4,
    overallSpeed: 769,
  },
  {
    id: 250,
    name: "GeForce 830M",
    g2d: 135,
    dx9: 16,
    dx10: 7,
    dx11: 15,
    dx12: 6,
    overallSpeed: 1010,
  },
  {
    id: 251,
    name: "GeForce 8400",
    g2d: 160,
    price: 589.99,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 81,
    pricePerG3D: 0.14,
  },
  {
    id: 252,
    name: "GeForce 8400 GS",
    g2d: 37,
    price: 86.09,
    dx9: 2,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 128,
    pricePerG3D: 1.49,
  },
  {
    id: 255,
    name: "GeForce 8400M GS",
    g2d: 47,
    price: 78.2,
    dx9: 1,
    dx10: 8,
    dx11: 0,
    dx12: 0,
    overallSpeed: 98,
    pricePerG3D: 1.25,
  },
  {
    id: 256,
    name: "GeForce 8400M GT",
    g2d: 68,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 64,
  },
  {
    id: 257,
    name: "GeForce 840A",
    g2d: 266,
    dx9: 20,
    dx10: 8,
    dx11: 19,
    dx12: 7,
    overallSpeed: 1180,
  },
  {
    id: 258,
    name: "GeForce 840M",
    g2d: 147,
    dx9: 18,
    dx10: 7,
    dx11: 15,
    dx12: 6,
    overallSpeed: 1061,
  },
  {
    id: 259,
    name: "GeForce 845M",
    g2d: 233,
    dx9: 26,
    dx10: 11,
    dx11: 24,
    dx12: 8,
    overallSpeed: 1430,
  },
  {
    id: 260,
    name: "GeForce 8500 GT",
    g2d: 41,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 106,
  },
  {
    id: 261,
    name: "GeForce 8600 GS",
    g2d: 111,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 93,
  },
  {
    id: 262,
    name: "GeForce 8600 GT",
    g2d: 74,
    price: 159,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 117,
    pricePerG3D: 0.74,
  },
  {
    id: 263,
    name: "GeForce 8600 GTS",
    g2d: 43,
    price: 239,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 158,
    pricePerG3D: 0.66,
  },
  {
    id: 264,
    name: "GeForce 8600M GS",
    g2d: 74,
    dx9: 4,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 78,
  },
  {
    id: 265,
    name: "GeForce 8600M GT",
    g2d: 58,
    price: 108.1,
    dx9: 4,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 84,
    pricePerG3D: 0.78,
  },
  {
    id: 266,
    name: "GeForce 8700M GT",
    g2d: 120,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 125,
  },
  {
    id: 267,
    name: "GeForce 8800 GS",
    g2d: 255,
    dx9: 17,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 398,
  },
  {
    id: 268,
    name: "GeForce 8800 GT",
    g2d: 116,
    price: 165,
    dx9: 20,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 517,
    pricePerG3D: 3.14,
  },
  {
    id: 269,
    name: "GeForce 8800 GTS",
    g2d: 65,
    price: 139,
    dx9: 18,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 444,
    pricePerG3D: 3.19,
  },
  {
    id: 270,
    name: "GeForce 8800 GTS 512",
    g2d: 186,
    dx9: 21,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 607,
  },
  {
    id: 271,
    name: "GeForce 8800 GTX",
    g2d: 118,
    price: 199.99,
    dx9: 20,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 596,
    pricePerG3D: 2.98,
  },
  {
    id: 272,
    name: "GeForce 8800 Ultra",
    g2d: 372,
    dx9: 14,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 639,
  },
  {
    id: 273,
    name: "GeForce 8800M GTS",
    g2d: 159,
    dx9: 15,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 382,
  },
  {
    id: 274,
    name: "GeForce 8800M GTX",
    g2d: 175,
    dx9: 18,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 462,
  },
  {
    id: 276,
    name: "GeForce 9100M G",
    g2d: 78,
    dx9: 2,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 79,
  },
  {
    id: 277,
    name: "GeForce 910M",
    g2d: 150,
    dx9: 10,
    dx10: 3,
    dx11: 12,
    dx12: 3,
    overallSpeed: 578,
  },
  {
    id: 278,
    name: "GeForce 9200",
    g2d: 52,
    dx9: 2,
    dx10: 7,
    dx11: 0,
    dx12: 0,
    overallSpeed: 145,
  },
  {
    id: 279,
    name: "GeForce 9200M GE",
    g2d: 79,
    dx9: 2,
    dx10: 8,
    dx11: 0,
    dx12: 0,
    overallSpeed: 157,
  },
  {
    id: 280,
    name: "GeForce 9200M GS",
    g2d: 71,
    dx9: 2,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 100,
  },
  {
    id: 281,
    name: "GeForce 920A",
    g2d: 277,
    dx9: 16,
    dx10: 5,
    dx11: 17,
    dx12: 4,
    overallSpeed: 879,
  },
  {
    id: 282,
    name: "GeForce 920M",
    g2d: 120,
    dx9: 12,
    dx10: 4,
    dx11: 14,
    dx12: 4,
    overallSpeed: 727,
  },
  {
    id: 283,
    name: "GeForce 920MX",
    g2d: 152,
    dx9: 17,
    dx10: 8,
    dx11: 18,
    dx12: 6,
    overallSpeed: 1086,
  },
  {
    id: 286,
    name: "GeForce 9300 GE",
    g2d: 99,
    price: 22.99,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 69,
    pricePerG3D: 3.02,
  },
  {
    id: 287,
    name: "GeForce 9300 GS",
    g2d: 118,
    price: 59.95,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 71,
    pricePerG3D: 1.19,
  },
  {
    id: 291,
    name: "GeForce 9300M GS",
    g2d: 43,
    price: 43.42,
    dx9: 3,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 91,
    pricePerG3D: 2.09,
  },
  {
    id: 293,
    name: "GeForce 930M",
    g2d: 156,
    dx9: 15,
    dx10: 7,
    dx11: 15,
    dx12: 7,
    overallSpeed: 1022,
  },
  {
    id: 294,
    name: "GeForce 930MX",
    g2d: 193,
    dx9: 20,
    dx10: 10,
    dx11: 20,
    dx12: 8,
    overallSpeed: 1323,
  },
  {
    id: 295,
    name: "GeForce 9400",
    g2d: 118,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 87,
  },
  {
    id: 296,
    name: "GeForce 9400 GT",
    g2d: 65,
    price: 155,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 90,
    pricePerG3D: 0.58,
  },
  {
    id: 297,
    name: "GeForce 9400M",
    g2d: 150,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 88,
  },
  {
    id: 298,
    name: "GeForce 9400M G",
    g2d: 82,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 70,
  },
  {
    id: 299,
    name: "GeForce 940A",
    g2d: 348,
    dx9: 20,
    dx10: 8,
    dx11: 20,
    dx12: 7,
    overallSpeed: 1145,
  },
  {
    id: 300,
    name: "GeForce 940M",
    g2d: 154,
    dx9: 19,
    dx10: 8,
    dx11: 17,
    dx12: 7,
    overallSpeed: 1106,
  },
  {
    id: 301,
    name: "GeForce 940MX",
    g2d: 171,
    dx9: 23,
    dx10: 14,
    dx11: 25,
    dx12: 8,
    overallSpeed: 1524,
  },
  {
    id: 304,
    name: "GeForce 945M",
    g2d: 275,
    dx9: 40,
    dx10: 22,
    dx11: 37,
    dx12: 8,
    overallSpeed: 1965,
  },
  {
    id: 305,
    name: "GeForce 9500 GS",
    g2d: 70,
    dx9: 9,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 157,
  },
  {
    id: 306,
    name: "GeForce 9500 GT",
    g2d: 46,
    price: 85.99,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 135,
    pricePerG3D: 1.57,
  },
  {
    id: 308,
    name: "GeForce 9500M G",
    g2d: 172,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 122,
  },
  {
    id: 309,
    name: "GeForce 9500M GS",
    g2d: 74,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 104,
  },
  {
    id: 310,
    name: "GeForce 9600 GS",
    g2d: 140,
    dx9: 12,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 330,
  },
  {
    id: 311,
    name: "GeForce 9600 GSO",
    g2d: 134,
    price: 49.99,
    dx9: 15,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 353,
    pricePerG3D: 7.07,
  },
  {
    id: 312,
    name: "GeForce 9600 GSO 512",
    g2d: 111,
    dx9: 12,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 345,
  },
  {
    id: 313,
    name: "GeForce 9600 GT",
    g2d: 74,
    price: 149,
    dx9: 19,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 498,
    pricePerG3D: 3.34,
  },
  {
    id: 314,
    name: "GeForce 9600M GS",
    g2d: 81,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 119,
  },
  {
    id: 315,
    name: "GeForce 9600M GT",
    g2d: 48,
    price: 78.2,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 131,
    pricePerG3D: 1.68,
  },
  {
    id: 318,
    name: "GeForce 9650M GT",
    g2d: 97,
    price: 117.3,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 145,
    pricePerG3D: 1.24,
  },
  {
    id: 319,
    name: "GeForce 9700M GT",
    g2d: 156,
    dx9: 10,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 217,
  },
  {
    id: 320,
    name: "GeForce 9700M GTS",
    g2d: 106,
    dx9: 11,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 326,
  },
  {
    id: 321,
    name: "GeForce 9800 GT",
    g2d: 120,
    price: 99.99,
    dx9: 19,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 475,
    pricePerG3D: 4.75,
  },
  {
    id: 324,
    name: "GeForce 9800 GTX/9800 GTX",
    g2d: 145,
    price: 89.99,
    dx9: 22,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 631,
    pricePerG3D: 7.01,
  },
  {
    id: 325,
    name: "GeForce 9800 GTX",
    g2d: 156,
    dx9: 19,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 511,
  },
  {
    id: 328,
    name: "GeForce 9800M GS",
    g2d: 160,
    dx9: 15,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 458,
  },
  {
    id: 329,
    name: "GeForce 9800M GT",
    g2d: 130,
    dx9: 18,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 424,
  },
  {
    id: 330,
    name: "GeForce 9800M GTS",
    g2d: 135,
    dx9: 13,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 379,
  },
  {
    id: 331,
    name: "GeForce 9800M GTX",
    g2d: 117,
    price: 328.5,
    dx9: 18,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 462,
    pricePerG3D: 1.41,
  },
  {
    id: 356,
    name: "GeForce G 103M",
    g2d: 41,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 62,
  },
  {
    id: 357,
    name: "GeForce G 105M",
    g2d: 42,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 67,
  },
  {
    id: 358,
    name: "GeForce G100",
    g2d: 77,
    price: 19.99,
    dx9: 2,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 146,
    pricePerG3D: 7.32,
  },
  {
    id: 360,
    name: "GeForce G105M",
    g2d: 60,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 111,
  },
  {
    id: 361,
    name: "GeForce G200",
    g2d: 156,
    dx9: 3,
    dx10: 6,
    dx11: 0,
    dx12: 0,
    overallSpeed: 200,
  },
  {
    id: 363,
    name: "GeForce G210",
    g2d: 63,
    price: 122.12,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 104,
    pricePerG3D: 0.85,
  },
  {
    id: 364,
    name: "GeForce G210M",
    g2d: 44,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 125,
  },
  {
    id: 374,
    name: "GeForce Go 7300",
    g2d: 114,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 52,
  },
  {
    id: 375,
    name: "GeForce Go 7400",
    g2d: 112,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 66,
  },
  {
    id: 377,
    name: "GeForce Go 7600 GT",
    g2d: 125,
    dx9: 6,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 210,
  },
  {
    id: 384,
    name: "GeForce GPU",
    g2d: 166,
    dx9: 23,
    dx10: 14,
    dx11: 30,
    dx12: 4,
    overallSpeed: 1253,
  },
  {
    id: 385,
    name: "GeForce GT 1030",
    g2d: 451,
    price: 109.99,
    dx9: 38,
    dx10: 19,
    dx11: 49,
    dx12: 14,
    overallSpeed: 2602,
    pricePerG3D: 23.66,
  },
  {
    id: 386,
    name: "GeForce GT 120",
    g2d: 149,
    price: 29.99,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 182,
    pricePerG3D: 6.07,
  },
  {
    id: 389,
    name: "GeForce GT 130",
    g2d: 201,
    price: 151.34,
    dx9: 14,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 376,
    pricePerG3D: 2.49,
  },
  {
    id: 390,
    name: "GeForce GT 130M",
    g2d: 73,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 153,
  },
  {
    id: 391,
    name: "GeForce GT 140",
    g2d: 225,
    dx9: 23,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 658,
  },
  {
    id: 392,
    name: "GeForce GT 220",
    g2d: 73,
    price: 39.99,
    dx9: 9,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 205,
    pricePerG3D: 5.13,
  },
  {
    id: 393,
    name: "GeForce GT 220M",
    g2d: 92,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 121,
  },
  {
    id: 394,
    name: "GeForce GT 230",
    g2d: 90,
    price: 43.99,
    dx9: 14,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 313,
    pricePerG3D: 7.1,
  },
  {
    id: 395,
    name: "GeForce GT 230M",
    g2d: 55,
    dx9: 9,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 199,
  },
  {
    id: 396,
    name: "GeForce GT 240",
    g2d: 93,
    price: 139.35,
    dx9: 14,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 548,
    pricePerG3D: 3.93,
  },
  {
    id: 397,
    name: "GeForce GT 240M",
    g2d: 70,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 208,
  },
  {
    id: 398,
    name: "GeForce GT 320",
    g2d: 119,
    price: 32.69,
    dx9: 11,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 437,
    pricePerG3D: 13.37,
  },
  {
    id: 399,
    name: "GeForce GT 320M",
    g2d: 48,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 107,
  },
  {
    id: 400,
    name: "GeForce GT 325M",
    g2d: 56,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 170,
  },
  {
    id: 401,
    name: "GeForce GT 330",
    g2d: 169,
    price: 39.99,
    dx9: 17,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 391,
    pricePerG3D: 9.78,
  },
  {
    id: 402,
    name: "GeForce GT 330M",
    g2d: 70,
    dx9: 9,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 215,
  },
  {
    id: 403,
    name: "GeForce GT 335M",
    g2d: 58,
    dx9: 9,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 391,
  },
  {
    id: 405,
    name: "GeForce GT 415",
    g2d: 363,
    dx9: 7,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 248,
  },
  {
    id: 407,
    name: "GeForce GT 420",
    g2d: 183,
    price: 155,
    dx9: 10,
    dx10: 3,
    dx11: 9,
    dx12: 1,
    overallSpeed: 399,
    pricePerG3D: 2.57,
  },
  {
    id: 408,
    name: "GeForce GT 420M",
    g2d: 78,
    dx9: 8,
    dx10: 4,
    dx11: 5,
    dx12: 0,
    overallSpeed: 412,
  },
  {
    id: 409,
    name: "GeForce GT 425M",
    g2d: 186,
    dx9: 13,
    dx10: 4,
    dx11: 11,
    dx12: 1,
    overallSpeed: 524,
  },
  {
    id: 410,
    name: "GeForce GT 430",
    g2d: 180,
    price: 139.99,
    dx9: 14,
    dx10: 4,
    dx11: 12,
    dx12: 2,
    overallSpeed: 582,
    pricePerG3D: 4.16,
  },
  {
    id: 411,
    name: "GeForce GT 435M",
    g2d: 248,
    dx9: 14,
    dx10: 5,
    dx11: 15,
    dx12: 0,
    overallSpeed: 541,
  },
  {
    id: 412,
    name: "GeForce GT 440",
    g2d: 254,
    price: 218,
    dx9: 18,
    dx10: 5,
    dx11: 15,
    dx12: 3,
    overallSpeed: 776,
    pricePerG3D: 3.56,
  },
  {
    id: 413,
    name: "GeForce GT 445M",
    g2d: 250,
    dx9: 19,
    dx10: 6,
    dx11: 20,
    dx12: 3,
    overallSpeed: 881,
  },
  {
    id: 414,
    name: "GeForce GT 520",
    g2d: 128,
    price: 299,
    dx9: 7,
    dx10: 2,
    dx11: 6,
    dx12: 1,
    overallSpeed: 295,
    pricePerG3D: 0.99,
  },
  {
    id: 415,
    name: "GeForce GT 520M",
    g2d: 72,
    price: 29.95,
    dx9: 6,
    dx10: 2,
    dx11: 4,
    dx12: 0,
    overallSpeed: 279,
    pricePerG3D: 9.32,
  },
  {
    id: 416,
    name: "GeForce GT 520MX",
    g2d: 50,
    dx9: 6,
    dx10: 3,
    dx11: 3,
    dx12: 0,
    overallSpeed: 295,
  },
  {
    id: 417,
    name: "GeForce GT 525M",
    g2d: 94,
    dx9: 10,
    dx10: 4,
    dx11: 7,
    dx12: 0,
    overallSpeed: 456,
  },
  {
    id: 418,
    name: "GeForce GT 530",
    g2d: 249,
    price: 49,
    dx9: 17,
    dx10: 5,
    dx11: 14,
    dx12: 2,
    overallSpeed: 689,
    pricePerG3D: 14.06,
  },
  {
    id: 419,
    name: "GeForce GT 540M",
    g2d: 81,
    price: 87.95,
    dx9: 12,
    dx10: 5,
    dx11: 8,
    dx12: 0,
    overallSpeed: 489,
    pricePerG3D: 5.56,
  },
  {
    id: 420,
    name: "GeForce GT 545",
    g2d: 346,
    price: 55.59,
    dx9: 26,
    dx10: 7,
    dx11: 23,
    dx12: 5,
    overallSpeed: 1080,
    pricePerG3D: 19.43,
  },
  {
    id: 421,
    name: "GeForce GT 550M",
    g2d: 138,
    dx9: 16,
    dx10: 5,
    dx11: 13,
    dx12: 0,
    overallSpeed: 586,
  },
  {
    id: 422,
    name: "GeForce GT 555M",
    g2d: 129,
    price: 177.2,
    dx9: 20,
    dx10: 6,
    dx11: 14,
    dx12: 0,
    overallSpeed: 704,
    pricePerG3D: 3.97,
  },
  {
    id: 423,
    name: "GeForce GT 610",
    g2d: 126,
    price: 229.99,
    dx9: 7,
    dx10: 2,
    dx11: 6,
    dx12: 1,
    overallSpeed: 301,
    pricePerG3D: 1.31,
  },
  {
    id: 425,
    name: "GeForce GT 620",
    g2d: 158,
    price: 39.99,
    dx9: 9,
    dx10: 2,
    dx11: 8,
    dx12: 1,
    overallSpeed: 357,
    pricePerG3D: 8.93,
  },
  {
    id: 426,
    name: "GeForce GT 620M",
    g2d: 132,
    dx9: 11,
    dx10: 3,
    dx11: 10,
    dx12: 0,
    overallSpeed: 435,
  },
  {
    id: 427,
    name: "GeForce GT 625",
    g2d: 212,
    dx9: 8,
    dx10: 2,
    dx11: 8,
    dx12: 1,
    overallSpeed: 324,
  },
  {
    id: 428,
    name: "GeForce GT 625M",
    g2d: 210,
    dx9: 9,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 435,
  },
  {
    id: 429,
    name: "GeForce GT 630",
    g2d: 202,
    price: 123.49,
    dx9: 15,
    dx10: 4,
    dx11: 13,
    dx12: 3,
    overallSpeed: 677,
    pricePerG3D: 5.48,
  },
  {
    id: 430,
    name: "GeForce GT 630M",
    g2d: 149,
    dx9: 13,
    dx10: 5,
    dx11: 12,
    dx12: 0,
    overallSpeed: 546,
  },
  {
    id: 431,
    name: "GeForce GT 635",
    g2d: 248,
    price: 66.94,
    dx9: 18,
    dx10: 5,
    dx11: 16,
    dx12: 4,
    overallSpeed: 868,
    pricePerG3D: 12.97,
  },
  {
    id: 432,
    name: "GeForce GT 635M",
    g2d: 176,
    dx9: 13,
    dx10: 5,
    dx11: 13,
    dx12: 0,
    overallSpeed: 563,
  },
  {
    id: 433,
    name: "GeForce GT 640",
    g2d: 283,
    price: 109.99,
    dx9: 25,
    dx10: 8,
    dx11: 25,
    dx12: 5,
    overallSpeed: 1195,
    pricePerG3D: 10.86,
  },
  {
    id: 434,
    name: "GeForce GT 640M",
    g2d: 182,
    dx9: 19,
    dx10: 7,
    dx11: 19,
    dx12: 2,
    overallSpeed: 897,
  },
  {
    id: 435,
    name: "GeForce GT 640M LE",
    g2d: 167,
    price: 849.99,
    dx9: 16,
    dx10: 5,
    dx11: 13,
    dx12: 2,
    overallSpeed: 683,
    pricePerG3D: 0.8,
  },
  {
    id: 436,
    name: "GeForce GT 645",
    g2d: 443,
    dx9: 33,
    dx10: 13,
    dx11: 41,
    dx12: 11,
    overallSpeed: 2006,
  },
  {
    id: 437,
    name: "GeForce GT 645M",
    g2d: 175,
    dx9: 15,
    dx10: 6,
    dx11: 19,
    dx12: 5,
    overallSpeed: 958,
  },
  {
    id: 438,
    name: "GeForce GT 650M",
    g2d: 229,
    dx9: 25,
    dx10: 8,
    dx11: 26,
    dx12: 4,
    overallSpeed: 1185,
  },
  {
    id: 439,
    name: "GeForce GT 705",
    g2d: 180,
    dx9: 9,
    dx10: 2,
    dx11: 8,
    dx12: 1,
    overallSpeed: 349,
  },
  {
    id: 440,
    name: "GeForce GT 710",
    g2d: 214,
    price: 106.99,
    dx9: 14,
    dx10: 4,
    dx11: 13,
    dx12: 3,
    overallSpeed: 638,
    pricePerG3D: 5.97,
  },
  {
    id: 441,
    name: "GeForce GT 710M",
    g2d: 127,
    dx9: 10,
    dx10: 4,
    dx11: 10,
    dx12: 0,
    overallSpeed: 442,
  },
  {
    id: 442,
    name: "GeForce GT 720",
    g2d: 200,
    price: 99.99,
    dx9: 14,
    dx10: 3,
    dx11: 12,
    dx12: 3,
    overallSpeed: 599,
    pricePerG3D: 6,
  },
  {
    id: 443,
    name: "GeForce GT 720A",
    g2d: 221,
    dx9: 16,
    dx10: 3,
    dx11: 11,
    dx12: 3,
    overallSpeed: 601,
  },
  {
    id: 444,
    name: "GeForce GT 720M",
    g2d: 118,
    dx9: 10,
    dx10: 5,
    dx11: 11,
    dx12: 1,
    overallSpeed: 465,
  },
  {
    id: 445,
    name: "GeForce GT 730",
    g2d: 232,
    price: 102.43,
    dx9: 17,
    dx10: 5,
    dx11: 16,
    dx12: 4,
    overallSpeed: 803,
    pricePerG3D: 7.83,
  },
  {
    id: 447,
    name: "GeForce GT 730M",
    g2d: 181,
    dx9: 17,
    dx10: 5,
    dx11: 17,
    dx12: 3,
    overallSpeed: 838,
  },
  {
    id: 448,
    name: "GeForce GT 735M",
    g2d: 140,
    dx9: 15,
    dx10: 3,
    dx11: 12,
    dx12: 2,
    overallSpeed: 581,
  },
  {
    id: 449,
    name: "GeForce GT 740",
    g2d: 331,
    price: 149.99,
    dx9: 31,
    dx10: 10,
    dx11: 31,
    dx12: 6,
    overallSpeed: 1521,
    pricePerG3D: 10.14,
  },
  {
    id: 450,
    name: "GeForce GT 740A",
    g2d: 495,
    dx9: 16,
    dx10: 4,
    dx11: 12,
    dx12: 4,
    overallSpeed: 707,
  },
  {
    id: 451,
    name: "GeForce GT 740M",
    g2d: 142,
    dx9: 15,
    dx10: 5,
    dx11: 14,
    dx12: 4,
    overallSpeed: 782,
  },
  {
    id: 453,
    name: "GeForce GT 745M",
    g2d: 172,
    dx9: 20,
    dx10: 7,
    dx11: 22,
    dx12: 4,
    overallSpeed: 1016,
  },
  {
    id: 454,
    name: "GeForce GT 750M",
    g2d: 243,
    dx9: 29,
    dx10: 9,
    dx11: 30,
    dx12: 5,
    overallSpeed: 1349,
  },
  {
    id: 455,
    name: "GeForce GT 755M",
    g2d: 300,
    dx9: 35,
    dx10: 12,
    dx11: 37,
    dx12: 5,
    overallSpeed: 1572,
  },
  {
    id: 456,
    name: "GeForce GT 820M",
    g2d: 157,
    dx9: 14,
    dx10: 4,
    dx11: 14,
    dx12: 2,
    overallSpeed: 625,
  },
  {
    id: 457,
    name: "GeForce GT625M",
    g2d: 222,
    dx9: 10,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 507,
  },
  {
    id: 460,
    name: "GeForce GTS 240",
    g2d: 251,
    price: 64.99,
    dx9: 23,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 627,
    pricePerG3D: 9.65,
  },
  {
    id: 461,
    name: "GeForce GTS 250",
    g2d: 123,
    price: 54.99,
    dx9: 23,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 616,
    pricePerG3D: 11.19,
  },
  {
    id: 462,
    name: "GeForce GTS 250M",
    g2d: 98,
    dx9: 13,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 523,
  },
  {
    id: 463,
    name: "GeForce GTS 350M",
    g2d: 113,
    dx9: 8,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 408,
  },
  {
    id: 464,
    name: "GeForce GTS 360M",
    g2d: 75,
    dx9: 15,
    dx10: 7,
    dx11: 0,
    dx12: 0,
    overallSpeed: 651,
  },
  {
    id: 465,
    name: "GeForce GTS 450",
    g2d: 300,
    price: 199,
    dx9: 31,
    dx10: 9,
    dx11: 26,
    dx12: 5,
    overallSpeed: 1331,
    pricePerG3D: 6.69,
  },
  {
    id: 466,
    name: "GeForce GTX 1050",
    g2d: 478,
    price: 195.15,
    dx9: 86,
    dx10: 48,
    dx11: 98,
    dx12: 21,
    overallSpeed: 5170,
    pricePerG3D: 26.49,
  },
  {
    id: 467,
    name: "GeForce GTX 1050 (Mobile)",
    g2d: 292,
    dx9: 75,
    dx10: 39,
    dx11: 86,
    dx12: 19,
    overallSpeed: 4462,
  },
  {
    id: 468,
    name: "GeForce GTX 1050 Ti",
    g2d: 646,
    price: 261.2,
    dx9: 104,
    dx10: 60,
    dx11: 116,
    dx12: 25,
    overallSpeed: 6328,
    pricePerG3D: 24.23,
  },
  {
    id: 469,
    name: "GeForce GTX 1050 Ti (Mobile)",
    g2d: 323,
    dx9: 101,
    dx10: 60,
    dx11: 112,
    dx12: 24,
    overallSpeed: 5919,
  },
  {
    id: 470,
    name: "GeForce GTX 1050 Ti with Max-Q Design",
    g2d: 361,
    dx9: 95,
    dx10: 56,
    dx11: 103,
    dx12: 22,
    overallSpeed: 5568,
  },
  {
    id: 471,
    name: "GeForce GTX 1050 with Max-Q Design",
    g2d: 297,
    dx9: 56,
    dx10: 36,
    dx11: 84,
    dx12: 19,
    overallSpeed: 4048,
  },
  {
    id: 472,
    name: "GeForce GTX 1060",
    g2d: 710,
    price: 389.15,
    dx9: 163,
    dx10: 107,
    dx11: 181,
    dx12: 36,
    overallSpeed: 9852,
    pricePerG3D: 25.32,
  },
  {
    id: 473,
    name: "GeForce GTX 1060 (Mobile)",
    g2d: 444,
    dx9: 137,
    dx10: 97,
    dx11: 161,
    dx12: 29,
    overallSpeed: 8161,
  },
  {
    id: 474,
    name: "GeForce GTX 1060 3GB",
    g2d: 765,
    price: 359,
    dx9: 163,
    dx10: 108,
    dx11: 180,
    dx12: 33,
    overallSpeed: 9683,
    pricePerG3D: 26.97,
  },
  {
    id: 475,
    name: "GeForce GTX 1060 5GB",
    g2d: 666,
    price: 487.98,
    dx9: 137,
    dx10: 78,
    dx11: 134,
    dx12: 29,
    overallSpeed: 7550,
    pricePerG3D: 15.47,
  },
  {
    id: 476,
    name: "GeForce GTX 1060 with Max-Q Design",
    g2d: 432,
    dx9: 134,
    dx10: 90,
    dx11: 153,
    dx12: 28,
    overallSpeed: 7916,
  },
  {
    id: 477,
    name: "GeForce GTX 1070",
    g2d: 850,
    price: 489,
    dx9: 198,
    dx10: 171,
    dx11: 256,
    dx12: 45,
    overallSpeed: 13406,
    pricePerG3D: 27.42,
  },
  {
    id: 478,
    name: "GeForce GTX 1070 (Mobile)",
    g2d: 603,
    dx9: 153,
    dx10: 148,
    dx11: 229,
    dx12: 34,
    overallSpeed: 10465,
  },
  {
    id: 479,
    name: "GeForce GTX 1070 Ti",
    g2d: 871,
    price: 565.99,
    dx9: 206,
    dx10: 193,
    dx11: 272,
    dx12: 46,
    overallSpeed: 14331,
    pricePerG3D: 25.32,
  },
  {
    id: 480,
    name: "GeForce GTX 1070 with Max-Q Design",
    g2d: 476,
    dx9: 158,
    dx10: 139,
    dx11: 215,
    dx12: 36,
    overallSpeed: 10176,
  },
  {
    id: 481,
    name: "GeForce GTX 1080",
    g2d: 885,
    price: 598.48,
    dx9: 210,
    dx10: 197,
    dx11: 307,
    dx12: 49,
    overallSpeed: 15138,
    pricePerG3D: 25.29,
  },
  {
    id: 482,
    name: "GeForce GTX 1080 Ti",
    g2d: 931,
    price: 949,
    dx9: 227,
    dx10: 248,
    dx11: 375,
    dx12: 59,
    overallSpeed: 18051,
    pricePerG3D: 19.02,
  },
  {
    id: 483,
    name: "GeForce GTX 1080 with Max-Q Design",
    g2d: 719,
    dx9: 165,
    dx10: 131,
    dx11: 256,
    dx12: 38,
    overallSpeed: 11206,
  },
  {
    id: 484,
    name: "GeForce GTX 1650",
    g2d: 595,
    price: 153.55,
    dx9: 125,
    dx10: 77,
    dx11: 142,
    dx12: 32,
    overallSpeed: 7756,
    pricePerG3D: 50.51,
  },
  {
    id: 485,
    name: "GeForce GTX 1650 (Mobile)",
    g2d: 384,
    dx9: 116,
    dx10: 72,
    dx11: 125,
    dx12: 27,
    overallSpeed: 6969,
  },
  {
    id: 486,
    name: "GeForce GTX 1650 SUPER",
    g2d: 762,
    price: 436.99,
    dx9: 147,
    dx10: 97,
    dx11: 183,
    dx12: 41,
    overallSpeed: 9951,
    pricePerG3D: 22.77,
  },
  {
    id: 487,
    name: "GeForce GTX 1650 Ti",
    g2d: 396,
    dx9: 118,
    dx10: 80,
    dx11: 150,
    dx12: 30,
    overallSpeed: 7468,
  },
  {
    id: 488,
    name: "GeForce GTX 1650 Ti with Max-Q Design",
    g2d: 334,
    dx9: 99,
    dx10: 66,
    dx11: 131,
    dx12: 26,
    overallSpeed: 6245,
  },
  {
    id: 489,
    name: "GeForce GTX 1650 with Max-Q Design",
    g2d: 317,
    dx9: 89,
    dx10: 61,
    dx11: 111,
    dx12: 26,
    overallSpeed: 5823,
  },
  {
    id: 490,
    name: "GeForce GTX 1660",
    g2d: 795,
    price: 220.21,
    dx9: 177,
    dx10: 125,
    dx11: 201,
    dx12: 46,
    overallSpeed: 11617,
    pricePerG3D: 52.76,
  },
  {
    id: 491,
    name: "GeForce GTX 1660 SUPER",
    g2d: 828,
    price: 237.74,
    dx9: 193,
    dx10: 140,
    dx11: 254,
    dx12: 45,
    overallSpeed: 12696,
    pricePerG3D: 53.4,
  },
  {
    id: 492,
    name: "GeForce GTX 1660 Ti",
    g2d: 714,
    price: 599.99,
    dx9: 179,
    dx10: 136,
    dx11: 237,
    dx12: 42,
    overallSpeed: 11803,
    pricePerG3D: 19.67,
  },
  {
    id: 493,
    name: "GeForce GTX 1660 Ti (Mobile)",
    g2d: 507,
    dx9: 159,
    dx10: 128,
    dx11: 217,
    dx12: 35,
    overallSpeed: 10176,
  },
  {
    id: 494,
    name: "GeForce GTX 1660 Ti with Max-Q Design",
    g2d: 381,
    dx9: 130,
    dx10: 110,
    dx11: 182,
    dx12: 32,
    overallSpeed: 8662,
  },
  {
    id: 495,
    name: "GeForce GTX 260",
    g2d: 118,
    price: 69.99,
    dx9: 25,
    dx10: 13,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1205,
    pricePerG3D: 17.21,
  },
  {
    id: 496,
    name: "GeForce GTX 260M",
    g2d: 128,
    dx9: 20,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 486,
  },
  {
    id: 497,
    name: "GeForce GTX 275",
    g2d: 117,
    price: 431.72,
    dx9: 28,
    dx10: 16,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1408,
    pricePerG3D: 3.26,
  },
  {
    id: 498,
    name: "GeForce GTX 280",
    g2d: 182,
    price: 119.99,
    dx9: 20,
    dx10: 15,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1140,
    pricePerG3D: 9.5,
  },
  {
    id: 500,
    name: "GeForce GTX 285",
    g2d: 190,
    price: 239.99,
    dx9: 31,
    dx10: 18,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1561,
    pricePerG3D: 6.51,
  },
  {
    id: 501,
    name: "GeForce GTX 285M",
    g2d: 246,
    dx9: 23,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 676,
  },
  {
    id: 502,
    name: "GeForce GTX 295",
    g2d: 195,
    price: 159.99,
    dx9: 24,
    dx10: 13,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1148,
    pricePerG3D: 7.17,
  },
  {
    id: 503,
    name: "GeForce GTX 460",
    g2d: 387,
    price: 99.99,
    dx9: 51,
    dx10: 20,
    dx11: 41,
    dx12: 8,
    overallSpeed: 2276,
    pricePerG3D: 22.77,
  },
  {
    id: 504,
    name: "GeForce GTX 460 SE",
    g2d: 379,
    price: 159.99,
    dx9: 46,
    dx10: 15,
    dx11: 42,
    dx12: 6,
    overallSpeed: 1952,
    pricePerG3D: 12.2,
  },
  {
    id: 505,
    name: "GeForce GTX 460 v2",
    g2d: 410,
    price: 199.99,
    dx9: 47,
    dx10: 19,
    dx11: 34,
    dx12: 7,
    overallSpeed: 2091,
    pricePerG3D: 10.46,
  },
  {
    id: 506,
    name: "GeForce GTX 460M",
    g2d: 262,
    dx9: 32,
    dx10: 9,
    dx11: 23,
    dx12: 4,
    overallSpeed: 1197,
  },
  {
    id: 507,
    name: "GeForce GTX 465",
    g2d: 447,
    price: 195,
    dx9: 59,
    dx10: 21,
    dx11: 56,
    dx12: 10,
    overallSpeed: 2680,
    pricePerG3D: 13.74,
  },
  {
    id: 508,
    name: "GeForce GTX 470",
    g2d: 424,
    price: 59.99,
    dx9: 65,
    dx10: 27,
    dx11: 60,
    dx12: 11,
    overallSpeed: 3214,
    pricePerG3D: 53.57,
  },
  {
    id: 509,
    name: "GeForce GTX 470M",
    g2d: 413,
    dx9: 44,
    dx10: 13,
    dx11: 41,
    dx12: 8,
    overallSpeed: 1953,
  },
  {
    id: 510,
    name: "GeForce GTX 480",
    g2d: 430,
    price: 149.99,
    dx9: 81,
    dx10: 40,
    dx11: 84,
    dx12: 15,
    overallSpeed: 4068,
    pricePerG3D: 27.12,
  },
  {
    id: 512,
    name: "GeForce GTX 485M",
    g2d: 479,
    dx9: 51,
    dx10: 18,
    dx11: 46,
    dx12: 9,
    overallSpeed: 2360,
  },
  {
    id: 513,
    name: "GeForce GTX 550 Ti",
    g2d: 361,
    price: 229,
    dx9: 41,
    dx10: 14,
    dx11: 26,
    dx12: 6,
    overallSpeed: 1565,
    pricePerG3D: 6.83,
  },
  {
    id: 514,
    name: "GeForce GTX 555",
    g2d: 485,
    dx9: 47,
    dx10: 15,
    dx11: 39,
    dx12: 3,
    overallSpeed: 1807,
  },
  {
    id: 515,
    name: "GeForce GTX 560",
    g2d: 409,
    price: 220.99,
    dx9: 59,
    dx10: 23,
    dx11: 50,
    dx12: 10,
    overallSpeed: 2729,
    pricePerG3D: 12.35,
  },
  {
    id: 516,
    name: "GeForce GTX 560 SE",
    g2d: 484,
    price: 89.99,
    dx9: 51,
    dx10: 15,
    dx11: 38,
    dx12: 9,
    overallSpeed: 2089,
    pricePerG3D: 23.21,
  },
  {
    id: 517,
    name: "GeForce GTX 560 Ti",
    g2d: 414,
    price: 129.99,
    dx9: 65,
    dx10: 25,
    dx11: 62,
    dx12: 11,
    overallSpeed: 3070,
    pricePerG3D: 23.61,
  },
  {
    id: 518,
    name: "GeForce GTX 560M",
    g2d: 245,
    dx9: 32,
    dx10: 9,
    dx11: 22,
    dx12: 4,
    overallSpeed: 1217,
  },
  {
    id: 519,
    name: "GeForce GTX 570",
    g2d: 452,
    price: 129.99,
    dx9: 74,
    dx10: 38,
    dx11: 81,
    dx12: 13,
    overallSpeed: 3844,
    pricePerG3D: 29.57,
  },
  {
    id: 520,
    name: "GeForce GTX 570M",
    g2d: 350,
    dx9: 46,
    dx10: 14,
    dx11: 37,
    dx12: 7,
    overallSpeed: 1921,
  },
  {
    id: 521,
    name: "GeForce GTX 580",
    g2d: 426,
    price: 279.99,
    dx9: 87,
    dx10: 43,
    dx11: 88,
    dx12: 15,
    overallSpeed: 4478,
    pricePerG3D: 15.99,
  },
  {
    id: 522,
    name: "GeForce GTX 580M",
    g2d: 455,
    price: 248.68,
    dx9: 53,
    dx10: 19,
    dx11: 48,
    dx12: 9,
    overallSpeed: 2373,
    pricePerG3D: 9.54,
  },
  {
    id: 523,
    name: "GeForce GTX 590",
    g2d: 514,
    price: 295,
    dx9: 73,
    dx10: 35,
    dx11: 119,
    dx12: 0,
    overallSpeed: 3366,
    pricePerG3D: 11.41,
  },
  {
    id: 524,
    name: "GeForce GTX 645",
    g2d: 430,
    dx9: 36,
    dx10: 14,
    dx11: 36,
    dx12: 7,
    overallSpeed: 1895,
  },
  {
    id: 525,
    name: "GeForce GTX 650",
    g2d: 340,
    price: 69.96,
    dx9: 36,
    dx10: 13,
    dx11: 35,
    dx12: 7,
    overallSpeed: 1760,
    pricePerG3D: 25.16,
  },
  {
    id: 526,
    name: "GeForce GTX 650 Ti",
    g2d: 402,
    price: 102.03,
    dx9: 47,
    dx10: 19,
    dx11: 50,
    dx12: 10,
    overallSpeed: 2548,
    pricePerG3D: 24.97,
  },
  {
    id: 527,
    name: "GeForce GTX 650 Ti BOOST",
    g2d: 455,
    dx9: 62,
    dx10: 26,
    dx11: 69,
    dx12: 13,
    overallSpeed: 3371,
  },
  {
    id: 528,
    name: "GeForce GTX 660",
    g2d: 460,
    price: 169.99,
    dx9: 68,
    dx10: 33,
    dx11: 83,
    dx12: 15,
    overallSpeed: 3981,
    pricePerG3D: 23.42,
  },
  {
    id: 529,
    name: "GeForce GTX 660 Ti",
    g2d: 454,
    price: 229.99,
    dx9: 72,
    dx10: 33,
    dx11: 95,
    dx12: 16,
    overallSpeed: 4376,
    pricePerG3D: 19.03,
  },
  {
    id: 530,
    name: "GeForce GTX 660M",
    g2d: 269,
    price: 78.99,
    dx9: 30,
    dx10: 11,
    dx11: 29,
    dx12: 5,
    overallSpeed: 1415,
    pricePerG3D: 17.91,
  },
  {
    id: 531,
    name: "GeForce GTX 670",
    g2d: 518,
    price: 366,
    dx9: 86,
    dx10: 45,
    dx11: 114,
    dx12: 20,
    overallSpeed: 5336,
    pricePerG3D: 14.58,
  },
  {
    id: 532,
    name: "GeForce GTX 670M",
    g2d: 337,
    dx9: 43,
    dx10: 14,
    dx11: 37,
    dx12: 5,
    overallSpeed: 1803,
  },
  {
    id: 533,
    name: "GeForce GTX 670MX",
    g2d: 341,
    dx9: 36,
    dx10: 14,
    dx11: 40,
    dx12: 7,
    overallSpeed: 1938,
  },
  {
    id: 534,
    name: "GeForce GTX 675M",
    g2d: 350,
    dx9: 46,
    dx10: 17,
    dx11: 43,
    dx12: 4,
    overallSpeed: 1904,
  },
  {
    id: 535,
    name: "GeForce GTX 675MX",
    g2d: 403,
    dx9: 49,
    dx10: 24,
    dx11: 45,
    dx12: 7,
    overallSpeed: 2296,
  },
  {
    id: 536,
    name: "GeForce GTX 680",
    g2d: 513,
    price: 249.99,
    dx9: 87,
    dx10: 43,
    dx11: 122,
    dx12: 21,
    overallSpeed: 5503,
    pricePerG3D: 22.01,
  },
  {
    id: 537,
    name: "GeForce GTX 680M",
    g2d: 341,
    price: 135.99,
    dx9: 57,
    dx10: 23,
    dx11: 62,
    dx12: 11,
    overallSpeed: 3044,
    pricePerG3D: 22.39,
  },
  {
    id: 540,
    name: "GeForce GTX 690",
    g2d: 456,
    price: 283.25,
    dx9: 84,
    dx10: 42,
    dx11: 177,
    dx12: 21,
    overallSpeed: 5625,
    pricePerG3D: 19.86,
  },
  {
    id: 541,
    name: "GeForce GTX 745",
    g2d: 466,
    price: 280,
    dx9: 43,
    dx10: 20,
    dx11: 32,
    dx12: 9,
    overallSpeed: 2186,
    pricePerG3D: 7.81,
  },
  {
    id: 542,
    name: "GeForce GTX 750",
    g2d: 477,
    price: 531,
    dx9: 56,
    dx10: 31,
    dx11: 57,
    dx12: 15,
    overallSpeed: 3399,
    pricePerG3D: 6.4,
  },
  {
    id: 543,
    name: "GeForce GTX 750 Ti",
    g2d: 488,
    price: 146.79,
    dx9: 61,
    dx10: 34,
    dx11: 65,
    dx12: 18,
    overallSpeed: 3932,
    pricePerG3D: 26.78,
  },
  {
    id: 544,
    name: "GeForce GTX 760",
    g2d: 518,
    price: 184,
    dx9: 81,
    dx10: 38,
    dx11: 104,
    dx12: 18,
    overallSpeed: 4778,
    pricePerG3D: 25.97,
  },
  {
    id: 545,
    name: "GeForce GTX 760 Ti",
    g2d: 541,
    price: 297.5,
    dx9: 79,
    dx10: 43,
    dx11: 110,
    dx12: 20,
    overallSpeed: 5131,
    pricePerG3D: 17.25,
  },
  {
    id: 547,
    name: "GeForce GTX 760A",
    g2d: 476,
    dx9: 34,
    dx10: 12,
    dx11: 10,
    dx12: 3,
    overallSpeed: 1060,
  },
  {
    id: 548,
    name: "GeForce GTX 760M",
    g2d: 251,
    dx9: 34,
    dx10: 12,
    dx11: 37,
    dx12: 6,
    overallSpeed: 1710,
  },
  {
    id: 549,
    name: "GeForce GTX 765M",
    g2d: 283,
    price: 186.3,
    dx9: 39,
    dx10: 14,
    dx11: 44,
    dx12: 7,
    overallSpeed: 1948,
    pricePerG3D: 10.46,
  },
  {
    id: 550,
    name: "GeForce GTX 770",
    g2d: 552,
    price: 249.99,
    dx9: 96,
    dx10: 46,
    dx11: 130,
    dx12: 22,
    overallSpeed: 5874,
    pricePerG3D: 23.5,
  },
  {
    id: 551,
    name: "GeForce GTX 770M",
    g2d: 325,
    price: 138,
    dx9: 53,
    dx10: 23,
    dx11: 56,
    dx12: 10,
    overallSpeed: 2800,
    pricePerG3D: 20.29,
  },
  {
    id: 553,
    name: "GeForce GTX 780",
    g2d: 598,
    price: 295,
    dx9: 129,
    dx10: 74,
    dx11: 166,
    dx12: 30,
    overallSpeed: 8030,
    pricePerG3D: 27.22,
  },
  {
    id: 554,
    name: "GeForce GTX 780 Ti",
    g2d: 621,
    price: 325,
    dx9: 137,
    dx10: 96,
    dx11: 177,
    dx12: 35,
    overallSpeed: 9168,
    pricePerG3D: 28.21,
  },
  {
    id: 555,
    name: "GeForce GTX 780M",
    g2d: 377,
    price: 499,
    dx9: 70,
    dx10: 29,
    dx11: 81,
    dx12: 13,
    overallSpeed: 3667,
    pricePerG3D: 7.35,
  },
  {
    id: 557,
    name: "GeForce GTX 850M",
    g2d: 222,
    dx9: 44,
    dx10: 24,
    dx11: 36,
    dx12: 13,
    overallSpeed: 2597,
  },
  {
    id: 559,
    name: "GeForce GTX 860M",
    g2d: 228,
    price: 114,
    dx9: 57,
    dx10: 30,
    dx11: 56,
    dx12: 13,
    overallSpeed: 3062,
    pricePerG3D: 26.86,
  },
  {
    id: 560,
    name: "GeForce GTX 870M",
    g2d: 301,
    dx9: 68,
    dx10: 27,
    dx11: 77,
    dx12: 12,
    overallSpeed: 3427,
  },
  {
    id: 561,
    name: "GeForce GTX 880M",
    g2d: 333,
    dx9: 77,
    dx10: 34,
    dx11: 90,
    dx12: 15,
    overallSpeed: 4059,
  },
  {
    id: 562,
    name: "GeForce GTX 950",
    g2d: 625,
    price: 199,
    dx9: 94,
    dx10: 43,
    dx11: 100,
    dx12: 24,
    overallSpeed: 5406,
    pricePerG3D: 27.17,
  },
  {
    id: 563,
    name: "GeForce GTX 950A",
    g2d: 325,
    dx9: 50,
    dx10: 23,
    dx11: 39,
    dx12: 12,
    overallSpeed: 2539,
  },
  {
    id: 564,
    name: "GeForce GTX 950M",
    g2d: 218,
    price: 567,
    dx9: 44,
    dx10: 25,
    dx11: 41,
    dx12: 13,
    overallSpeed: 2626,
    pricePerG3D: 4.63,
  },
  {
    id: 565,
    name: "GeForce GTX 960",
    g2d: 658,
    price: 147.09,
    dx9: 99,
    dx10: 46,
    dx11: 105,
    dx12: 29,
    overallSpeed: 6036,
    pricePerG3D: 41.03,
  },
  {
    id: 567,
    name: "GeForce GTX 960M",
    g2d: 243,
    price: 1169,
    dx9: 60,
    dx10: 34,
    dx11: 60,
    dx12: 16,
    overallSpeed: 3466,
    pricePerG3D: 2.96,
  },
  {
    id: 568,
    name: "GeForce GTX 965M",
    g2d: 353,
    dx9: 68,
    dx10: 32,
    dx11: 75,
    dx12: 20,
    overallSpeed: 4017,
  },
  {
    id: 569,
    name: "GeForce GTX 970",
    g2d: 776,
    price: 303,
    dx9: 144,
    dx10: 91,
    dx11: 179,
    dx12: 43,
    overallSpeed: 9734,
    pricePerG3D: 32.13,
  },
  {
    id: 570,
    name: "GeForce GTX 970M",
    g2d: 407,
    price: 209.99,
    dx9: 101,
    dx10: 55,
    dx11: 108,
    dx12: 26,
    overallSpeed: 5908,
    pricePerG3D: 28.13,
  },
  {
    id: 572,
    name: "GeForce GTX 980",
    g2d: 815,
    price: 306.1,
    dx9: 166,
    dx10: 106,
    dx11: 213,
    dx12: 48,
    overallSpeed: 11267,
    pricePerG3D: 36.81,
  },
  {
    id: 573,
    name: "GeForce GTX 980 Ti",
    g2d: 853,
    price: 485.53,
    dx9: 191,
    dx10: 148,
    dx11: 267,
    dx12: 56,
    overallSpeed: 13900,
    pricePerG3D: 28.63,
  },
  {
    id: 574,
    name: "GeForce GTX 980M",
    g2d: 526,
    price: 289.99,
    dx9: 126,
    dx10: 69,
    dx11: 145,
    dx12: 31,
    overallSpeed: 7298,
    pricePerG3D: 25.17,
  },
  {
    id: 575,
    name: "GeForce GTX Titan",
    g2d: 662,
    price: 740,
    dx9: 128,
    dx10: 80,
    dx11: 177,
    dx12: 34,
    overallSpeed: 8506,
    pricePerG3D: 11.5,
  },
  {
    id: 576,
    name: "GeForce GTX TITAN Black",
    g2d: 623,
    price: 694.99,
    dx9: 139,
    dx10: 96,
    dx11: 163,
    dx12: 33,
    overallSpeed: 9194,
    pricePerG3D: 13.23,
  },
  {
    id: 577,
    name: "GeForce GTX TITAN X",
    g2d: 826,
    price: 999.99,
    dx9: 182,
    dx10: 143,
    dx11: 265,
    dx12: 51,
    overallSpeed: 13105,
    pricePerG3D: 13.11,
  },
  {
    id: 578,
    name: "GeForce GTX TITAN Z",
    g2d: 782,
    price: 1385,
    dx9: 145,
    dx10: 90,
    dx11: 235,
    dx12: 39,
    overallSpeed: 9133,
    pricePerG3D: 6.59,
  },
  {
    id: 579,
    name: "GeForce MX110",
    g2d: 198,
    dx9: 22,
    dx10: 12,
    dx11: 28,
    dx12: 7,
    overallSpeed: 1485,
  },
  {
    id: 580,
    name: "GeForce MX130",
    g2d: 193,
    dx9: 26,
    dx10: 19,
    dx11: 32,
    dx12: 10,
    overallSpeed: 1918,
  },
  {
    id: 581,
    name: "GeForce MX150",
    g2d: 220,
    price: 63.98,
    dx9: 36,
    dx10: 19,
    dx11: 45,
    dx12: 12,
    overallSpeed: 2347,
    pricePerG3D: 36.69,
  },
  {
    id: 582,
    name: "GeForce MX230",
    g2d: 220,
    dx9: 33,
    dx10: 13,
    dx11: 38,
    dx12: 10,
    overallSpeed: 1908,
  },
  {
    id: 583,
    name: "GeForce MX250",
    g2d: 253,
    dx9: 40,
    dx10: 20,
    dx11: 49,
    dx12: 13,
    overallSpeed: 2551,
  },
  {
    id: 584,
    name: "GeForce MX330",
    g2d: 232,
    dx9: 40,
    dx10: 21,
    dx11: 51,
    dx12: 13,
    overallSpeed: 2603,
  },
  {
    id: 585,
    name: "GeForce MX350",
    g2d: 244,
    dx9: 43,
    dx10: 21,
    dx11: 54,
    dx12: 16,
    overallSpeed: 2894,
  },
  {
    id: 586,
    name: "GeForce MX450",
    g2d: 289,
    dx9: 52,
    dx10: 25,
    dx11: 68,
    dx12: 23,
    overallSpeed: 3746,
  },
  {
    id: 590,
    name: "GeForce RTX 2060",
    g2d: 753,
    price: 646.3,
    dx9: 191,
    dx10: 206,
    dx11: 268,
    dx12: 48,
    overallSpeed: 13880,
    pricePerG3D: 21.48,
  },
  {
    id: 591,
    name: "GeForce RTX 2060 (Mobile)",
    g2d: 540,
    dx9: 164,
    dx10: 174,
    dx11: 240,
    dx12: 39,
    overallSpeed: 11355,
  },
  {
    id: 592,
    name: "GeForce RTX 2060 SUPER",
    g2d: 886,
    price: 419.99,
    dx9: 221,
    dx10: 238,
    dx11: 320,
    dx12: 56,
    overallSpeed: 16442,
    pricePerG3D: 39.15,
  },
  {
    id: 593,
    name: "GeForce RTX 2060 with Max-Q Design",
    g2d: 442,
    dx9: 135,
    dx10: 146,
    dx11: 187,
    dx12: 37,
    overallSpeed: 9781,
  },
  {
    id: 594,
    name: "GeForce RTX 2070",
    g2d: 843,
    price: 799.99,
    dx9: 214,
    dx10: 236,
    dx11: 319,
    dx12: 57,
    overallSpeed: 16110,
    pricePerG3D: 20.14,
  },
  {
    id: 595,
    name: "GeForce RTX 2070 (Mobile)",
    g2d: 601,
    dx9: 176,
    dx10: 190,
    dx11: 278,
    dx12: 41,
    overallSpeed: 12354,
  },
  {
    id: 596,
    name: "GeForce RTX 2070 SUPER",
    g2d: 902,
    price: 799.99,
    dx9: 225,
    dx10: 278,
    dx11: 363,
    dx12: 63,
    overallSpeed: 18146,
    pricePerG3D: 22.68,
  },
  {
    id: 597,
    name: "GeForce RTX 2070 Super with Max-Q Design",
    g2d: 721,
    dx9: 207,
    dx10: 226,
    dx11: 296,
    dx12: 50,
    overallSpeed: 14674,
  },
  {
    id: 598,
    name: "GeForce RTX 2070 with Max-Q Design",
    g2d: 523,
    dx9: 177,
    dx10: 187,
    dx11: 257,
    dx12: 44,
    overallSpeed: 12222,
  },
  {
    id: 599,
    name: "GeForce RTX 2080",
    g2d: 926,
    price: 943.03,
    dx9: 223,
    dx10: 289,
    dx11: 379,
    dx12: 68,
    overallSpeed: 18655,
    pricePerG3D: 19.78,
  },
  {
    id: 600,
    name: "GeForce RTX 2080 (Mobile)",
    g2d: 812,
    dx9: 194,
    dx10: 231,
    dx11: 349,
    dx12: 53,
    overallSpeed: 15107,
  },
  {
    id: 601,
    name: "GeForce RTX 2080 SUPER",
    g2d: 939,
    price: 999.99,
    dx9: 230,
    dx10: 298,
    dx11: 394,
    dx12: 71,
    overallSpeed: 19494,
    pricePerG3D: 19.49,
  },
  {
    id: 602,
    name: "GeForce RTX 2080 Super with Max-Q Design",
    g2d: 646,
    dx9: 190,
    dx10: 227,
    dx11: 299,
    dx12: 52,
    overallSpeed: 14149,
  },
  {
    id: 603,
    name: "GeForce RTX 2080 Ti",
    g2d: 944,
    price: 1154.74,
    dx9: 236,
    dx10: 323,
    dx11: 458,
    dx12: 81,
    overallSpeed: 21695,
    pricePerG3D: 18.79,
  },
  {
    id: 604,
    name: "GeForce RTX 2080 with Max-Q Design",
    g2d: 582,
    price: 2099.99,
    dx9: 180,
    dx10: 214,
    dx11: 293,
    dx12: 50,
    overallSpeed: 13698,
    pricePerG3D: 6.52,
  },
  {
    id: 605,
    name: "GeForce RTX 3050 Laptop GPU",
    g2d: 414,
    dx9: 112,
    dx10: 111,
    dx11: 182,
    dx12: 39,
    overallSpeed: 9256,
  },
  {
    id: 606,
    name: "GeForce RTX 3050 Ti Laptop GPU",
    g2d: 426,
    dx9: 113,
    dx10: 124,
    dx11: 181,
    dx12: 43,
    overallSpeed: 9626,
  },
  {
    id: 607,
    name: "GeForce RTX 3060",
    g2d: 938,
    price: 329,
    dx9: 190,
    dx10: 212,
    dx11: 315,
    dx12: 62,
    overallSpeed: 16607,
    pricePerG3D: 50.48,
  },
  {
    id: 608,
    name: "GeForce RTX 3060 Laptop GPU",
    g2d: 541,
    price: 793.87,
    dx9: 132,
    dx10: 184,
    dx11: 258,
    dx12: 49,
    overallSpeed: 12278,
    pricePerG3D: 15.47,
  },
  {
    id: 609,
    name: "GeForce RTX 3060 Ti",
    g2d: 938,
    price: 919.99,
    dx9: 218,
    dx10: 285,
    dx11: 389,
    dx12: 71,
    overallSpeed: 19651,
    pricePerG3D: 21.36,
  },
  {
    id: 610,
    name: "GeForce RTX 3070",
    g2d: 967,
    price: 1199.99,
    dx9: 235,
    dx10: 330,
    dx11: 447,
    dx12: 78,
    overallSpeed: 21869,
    pricePerG3D: 18.22,
  },
  {
    id: 611,
    name: "GeForce RTX 3070 Laptop GPU",
    g2d: 627,
    dx9: 145,
    dx10: 228,
    dx11: 323,
    dx12: 58,
    overallSpeed: 14507,
  },
  {
    id: 612,
    name: "GeForce RTX 3070 Ti",
    g2d: 973,
    price: 1478,
    dx9: 239,
    dx10: 340,
    dx11: 437,
    dx12: 83,
    overallSpeed: 22403,
    pricePerG3D: 15.16,
  },
  {
    id: 613,
    name: "GeForce RTX 3080",
    g2d: 1003,
    price: 1599,
    dx9: 241,
    dx10: 361,
    dx11: 505,
    dx12: 92,
    overallSpeed: 24440,
    pricePerG3D: 15.28,
  },
  {
    id: 614,
    name: "GeForce RTX 3080 Laptop GPU",
    g2d: 661,
    dx9: 164,
    dx10: 250,
    dx11: 351,
    dx12: 68,
    overallSpeed: 16331,
  },
  {
    id: 615,
    name: "GeForce RTX 3080 Ti",
    g2d: 1040,
    price: 2199.99,
    dx9: 262,
    dx10: 396,
    dx11: 562,
    dx12: 102,
    overallSpeed: 26762,
    pricePerG3D: 12.16,
  },
  {
    id: 616,
    name: "GeForce RTX 3090",
    g2d: 989,
    price: 2895.72,
    dx9: 248,
    dx10: 377,
    dx11: 538,
    dx12: 104,
    overallSpeed: 25869,
    pricePerG3D: 8.93,
  },
  {
    id: 652,
    name: "GRID GTX P40-6",
    g2d: 249,
    dx9: 49,
    dx10: 47,
    dx11: 70,
    dx12: 15,
    overallSpeed: 4044,
  },
  {
    id: 656,
    name: "GRID K160Q",
    g2d: 262,
    dx9: 20,
    dx10: 6,
    dx11: 13,
    dx12: 0,
    overallSpeed: 628,
  },
  {
    id: 657,
    name: "GRID K180Q",
    g2d: 113,
    dx9: 15,
    dx10: 5,
    dx11: 14,
    dx12: 0,
    overallSpeed: 534,
  },
  {
    id: 658,
    name: "GRID K2",
    g2d: 416,
    price: 4237.75,
    dx9: 32,
    dx10: 24,
    dx11: 80,
    dx12: 9,
    overallSpeed: 2774,
    pricePerG3D: 0.65,
  },
  {
    id: 660,
    name: "GRID K240Q",
    g2d: 256,
    dx9: 51,
    dx10: 29,
    dx11: 52,
    dx12: 14,
    overallSpeed: 2578,
  },
  {
    id: 663,
    name: "GRID K520",
    g2d: 163,
    price: 749.95,
    dx9: 70,
    dx10: 32,
    dx11: 0,
    dx12: 13,
    overallSpeed: 3177,
    pricePerG3D: 4.24,
  },
  {
    id: 667,
    name: "GRID M10-2B",
    g2d: 201,
    dx9: 44,
    dx10: 26,
    dx11: 36,
    dx12: 16,
    overallSpeed: 2333,
  },
  {
    id: 668,
    name: "GRID M10-2Q",
    g2d: 75,
    dx9: 61,
    dx10: 34,
    dx11: 47,
    dx12: 10,
    overallSpeed: 2654,
  },
  {
    id: 677,
    name: "GRID M60-1Q",
    g2d: 211,
    dx9: 65,
    dx10: 64,
    dx11: 17,
    dx12: 25,
    overallSpeed: 4251,
  },
  {
    id: 678,
    name: "GRID M60-2Q",
    g2d: 339,
    dx9: 59,
    dx10: 58,
    dx11: 45,
    dx12: 26,
    overallSpeed: 4316,
  },
  {
    id: 679,
    name: "GRID M60-4Q",
    g2d: 278,
    dx9: 66,
    dx10: 66,
    dx11: 32,
    dx12: 25,
    overallSpeed: 3831,
  },
  {
    id: 692,
    name: "GRID RTX6000P-4Q",
    g2d: 76,
    dx9: 61,
    dx10: 62,
    dx11: 55,
    dx12: 53,
    overallSpeed: 4283,
  },
  {
    id: 693,
    name: "GRID RTX6000P-6Q",
    g2d: 141,
    dx9: 68,
    dx10: 69,
    dx11: 76,
    dx12: 42,
    overallSpeed: 4777,
  },
  {
    id: 694,
    name: "GRID RTX8000-4Q",
    g2d: 81,
    dx9: 60,
    dx10: 60,
    dx11: 53,
    dx12: 32,
    overallSpeed: 3961,
  },
  {
    id: 695,
    name: "GRID RTX8000P-2Q",
    g2d: 84,
    dx9: 60,
    dx10: 60,
    dx11: 54,
    dx12: 24,
    overallSpeed: 3843,
  },
  {
    id: 696,
    name: "GRID T4-1Q",
    g2d: 84,
    dx9: 149,
    dx10: 60,
    dx11: 50,
    dx12: 6,
    overallSpeed: 2703,
  },
  {
    id: 697,
    name: "GRID T4-2Q",
    g2d: 85,
    dx9: 55,
    dx10: 28,
    dx11: 35,
    dx12: 5,
    overallSpeed: 1850,
  },
  {
    id: 698,
    name: "GRID T4-4Q",
    g2d: 85,
    dx9: 51,
    dx10: 49,
    dx11: 47,
    dx12: 31,
    overallSpeed: 3406,
  },
  {
    id: 699,
    name: "GRID T4-8Q",
    g2d: 89,
    dx9: 62,
    dx10: 62,
    dx11: 58,
    dx12: 44,
    overallSpeed: 4284,
  },
  {
    id: 707,
    name: "IncrediblE HD 3000",
    g2d: 18,
    dx9: 7,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 291,
  },
  {
    id: 732,
    name: "Intel B43 Express Chipset",
    g2d: 188,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 68,
  },
  {
    id: 735,
    name: "Intel G33/G31 Express",
    g2d: 28,
    dx9: 1,
    dx10: 1,
    dx11: 3,
    dx12: 0,
    overallSpeed: 104,
  },
  {
    id: 736,
    name: "Intel G35 Express",
    g2d: 384,
    dx9: 78,
    dx10: 89,
    dx11: 153,
    dx12: 15,
    overallSpeed: 3090,
  },
  {
    id: 738,
    name: "Intel G41 Express Chipset",
    g2d: 29,
    dx9: 2,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 73,
  },
  {
    id: 740,
    name: "Intel G45/G43 Express Chipset",
    g2d: 37,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 67,
  },
  {
    id: 746,
    name: "Intel HD 3000",
    g2d: 56,
    price: 945,
    dx9: 7,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 257,
    pricePerG3D: 0.27,
  },
  {
    id: 747,
    name: "Intel HD 4000",
    g2d: 187,
    price: 1592.95,
    dx9: 6,
    dx10: 3,
    dx11: 7,
    dx12: 0,
    overallSpeed: 333,
    pricePerG3D: 0.21,
  },
  {
    id: 748,
    name: "Intel HD 4400",
    g2d: 279,
    dx9: 10,
    dx10: 4,
    dx11: 10,
    dx12: 2,
    overallSpeed: 523,
  },
  {
    id: 749,
    name: "Intel HD 4600",
    g2d: 316,
    dx9: 11,
    dx10: 4,
    dx11: 11,
    dx12: 2,
    overallSpeed: 629,
  },
  {
    id: 750,
    name: "Intel HD 500",
    g2d: 82,
    dx9: 7,
    dx10: 2,
    dx11: 6,
    dx12: 1,
    overallSpeed: 299,
  },
  {
    id: 751,
    name: "Intel HD 5000",
    g2d: 237,
    price: 625,
    dx9: 9,
    dx10: 4,
    dx11: 9,
    dx12: 3,
    overallSpeed: 557,
    pricePerG3D: 0.89,
  },
  {
    id: 752,
    name: "Intel HD 505",
    g2d: 100,
    dx9: 7,
    dx10: 2,
    dx11: 7,
    dx12: 2,
    overallSpeed: 352,
  },
  {
    id: 753,
    name: "Intel HD 510",
    g2d: 163,
    dx9: 14,
    dx10: 5,
    dx11: 11,
    dx12: 3,
    overallSpeed: 623,
  },
  {
    id: 754,
    name: "Intel HD 515",
    g2d: 190,
    dx9: 13,
    dx10: 4,
    dx11: 11,
    dx12: 3,
    overallSpeed: 613,
  },
  {
    id: 755,
    name: "Intel HD 520",
    g2d: 209,
    dx9: 17,
    dx10: 6,
    dx11: 15,
    dx12: 4,
    overallSpeed: 861,
  },
  {
    id: 757,
    name: "Intel HD 530",
    g2d: 244,
    dx9: 21,
    dx10: 7,
    dx11: 17,
    dx12: 4,
    overallSpeed: 984,
  },
  {
    id: 758,
    name: "Intel HD 5300",
    g2d: 184,
    dx9: 8,
    dx10: 2,
    dx11: 7,
    dx12: 2,
    overallSpeed: 386,
  },
  {
    id: 759,
    name: "Intel HD 5500",
    g2d: 234,
    dx9: 9,
    dx10: 4,
    dx11: 9,
    dx12: 4,
    overallSpeed: 579,
  },
  {
    id: 760,
    name: "Intel HD 5600",
    g2d: 595,
    dx9: 13,
    dx10: 4,
    dx11: 13,
    dx12: 5,
    overallSpeed: 712,
  },
  {
    id: 761,
    name: "Intel HD 6000",
    g2d: 281,
    dx9: 12,
    dx10: 6,
    dx11: 13,
    dx12: 5,
    overallSpeed: 852,
  },
  {
    id: 762,
    name: "Intel HD 610",
    g2d: 158,
    dx9: 14,
    dx10: 5,
    dx11: 13,
    dx12: 3,
    overallSpeed: 672,
  },
  {
    id: 763,
    name: "Intel HD 615",
    g2d: 186,
    dx9: 16,
    dx10: 5,
    dx11: 14,
    dx12: 3,
    overallSpeed: 726,
  },
  {
    id: 764,
    name: "Intel HD 630",
    g2d: 270,
    dx9: 23,
    dx10: 8,
    dx11: 22,
    dx12: 5,
    overallSpeed: 1148,
  },
  {
    id: 765,
    name: "Intel HD Family",
    g2d: 189,
    dx9: 7,
    dx10: 3,
    dx11: 7,
    dx12: 2,
    overallSpeed: 452,
  },
  {
    id: 766,
    name: "Intel HD Graphics 620",
    g2d: 218,
    dx9: 17,
    dx10: 7,
    dx11: 16,
    dx12: 4,
    overallSpeed: 919,
  },
  {
    id: 770,
    name: "Intel HD P3000",
    g2d: 134,
    dx9: 11,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 294,
  },
  {
    id: 773,
    name: "Intel HD P4600/P4700",
    g2d: 383,
    dx9: 12,
    dx10: 4,
    dx11: 12,
    dx12: 2,
    overallSpeed: 639,
  },
  {
    id: 774,
    name: "Intel HD P530",
    g2d: 260,
    dx9: 28,
    dx10: 10,
    dx11: 24,
    dx12: 5,
    overallSpeed: 1311,
  },
  {
    id: 775,
    name: "Intel HD P630",
    g2d: 352,
    dx9: 24,
    dx10: 8,
    dx11: 23,
    dx12: 6,
    overallSpeed: 1250,
  },
  {
    id: 777,
    name: "Intel Iris 5100",
    g2d: 272,
    dx9: 12,
    dx10: 6,
    dx11: 12,
    dx12: 3,
    overallSpeed: 757,
  },
  {
    id: 778,
    name: "Intel Iris 540",
    g2d: 331,
    dx9: 26,
    dx10: 9,
    dx11: 23,
    dx12: 5,
    overallSpeed: 1240,
  },
  {
    id: 779,
    name: "Intel Iris 550",
    g2d: 300,
    dx9: 25,
    dx10: 11,
    dx11: 23,
    dx12: 5,
    overallSpeed: 1345,
  },
  {
    id: 780,
    name: "Intel Iris 6100",
    g2d: 306,
    dx9: 14,
    dx10: 6,
    dx11: 12,
    dx12: 4,
    overallSpeed: 864,
  },
  {
    id: 782,
    name: "Intel Iris Plus",
    g2d: 316,
    dx9: 34,
    dx10: 15,
    dx11: 29,
    dx12: 8,
    overallSpeed: 1865,
  },
  {
    id: 783,
    name: "Intel Iris Plus 640",
    g2d: 338,
    dx9: 26,
    dx10: 9,
    dx11: 26,
    dx12: 5,
    overallSpeed: 1318,
  },
  {
    id: 784,
    name: "Intel Iris Plus 645",
    g2d: 404,
    dx9: 37,
    dx10: 12,
    dx11: 34,
    dx12: 6,
    overallSpeed: 1751,
  },
  {
    id: 785,
    name: "Intel Iris Plus 650",
    g2d: 383,
    dx9: 32,
    dx10: 11,
    dx11: 33,
    dx12: 6,
    overallSpeed: 1605,
  },
  {
    id: 786,
    name: "Intel Iris Plus 655",
    g2d: 372,
    dx9: 38,
    dx10: 13,
    dx11: 35,
    dx12: 7,
    overallSpeed: 1782,
  },
  {
    id: 787,
    name: "Intel Iris Pro 5200",
    g2d: 409,
    dx9: 19,
    dx10: 7,
    dx11: 18,
    dx12: 3,
    overallSpeed: 1023,
  },
  {
    id: 788,
    name: "Intel Iris Pro 580",
    g2d: 383,
    dx9: 39,
    dx10: 16,
    dx11: 36,
    dx12: 8,
    overallSpeed: 2036,
  },
  {
    id: 790,
    name: "Intel Iris Pro Graphics 6200",
    g2d: 582,
    dx9: 26,
    dx10: 8,
    dx11: 24,
    dx12: 7,
    overallSpeed: 1451,
  },
  {
    id: 791,
    name: "Intel Iris Pro P580",
    g2d: 573,
    dx9: 43,
    dx10: 21,
    dx11: 39,
    dx12: 9,
    overallSpeed: 2169,
  },
  {
    id: 792,
    name: "Intel Iris Pro P6300",
    g2d: 565,
    dx9: 30,
    dx10: 11,
    dx11: 28,
    dx12: 7,
    overallSpeed: 1540,
  },
  {
    id: 793,
    name: "Intel Iris Xe",
    g2d: 343,
    dx9: 42,
    dx10: 27,
    dx11: 46,
    dx12: 13,
    overallSpeed: 2875,
  },
  {
    id: 798,
    name: "Intel Media Accelerator HD",
    g2d: 46,
    dx9: 4,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 96,
  },
  {
    id: 802,
    name: "Intel Q35 Express",
    g2d: 35,
    dx9: 2,
    dx10: 2,
    dx11: 4,
    dx12: 1,
    overallSpeed: 186,
  },
  {
    id: 804,
    name: "Intel Q45/Q43 Express Chipset",
    g2d: 33,
    dx9: 2,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 142,
  },
  {
    id: 805,
    name: "Intel Q965/Q963 Express",
    g2d: 49,
    dx9: 3,
    dx10: 2,
    dx11: 4,
    dx12: 1,
    overallSpeed: 191,
  },
  {
    id: 807,
    name: "Intel UHD",
    g2d: 277,
    dx9: 30,
    dx10: 18,
    dx11: 33,
    dx12: 7,
    overallSpeed: 1717,
  },
  {
    id: 808,
    name: "Intel UHD 600",
    g2d: 97,
    dx9: 7,
    dx10: 2,
    dx11: 8,
    dx12: 1,
    overallSpeed: 331,
  },
  {
    id: 809,
    name: "Intel UHD 605",
    g2d: 115,
    dx9: 7,
    dx10: 2,
    dx11: 8,
    dx12: 2,
    overallSpeed: 372,
  },
  {
    id: 810,
    name: "Intel UHD 610",
    g2d: 181,
    dx9: 16,
    dx10: 5,
    dx11: 15,
    dx12: 3,
    overallSpeed: 733,
  },
  {
    id: 811,
    name: "Intel UHD 615",
    g2d: 201,
    dx9: 16,
    dx10: 5,
    dx11: 15,
    dx12: 3,
    overallSpeed: 767,
  },
  {
    id: 812,
    name: "Intel UHD 617",
    g2d: 282,
    dx9: 19,
    dx10: 6,
    dx11: 18,
    dx12: 3,
    overallSpeed: 874,
  },
  {
    id: 814,
    name: "Intel UHD 630",
    g2d: 305,
    dx9: 28,
    dx10: 11,
    dx11: 28,
    dx12: 6,
    overallSpeed: 1372,
  },
  {
    id: 815,
    name: "Intel UHD 730",
    g2d: 296,
    dx9: 31,
    dx10: 18,
    dx11: 25,
    dx12: 4,
    overallSpeed: 1584,
  },
  {
    id: 816,
    name: "Intel UHD 750",
    g2d: 323,
    dx9: 31,
    dx10: 18,
    dx11: 27,
    dx12: 6,
    overallSpeed: 1706,
  },
  {
    id: 817,
    name: "Intel UHD Graphics 620",
    g2d: 247,
    dx9: 21,
    dx10: 7,
    dx11: 20,
    dx12: 5,
    overallSpeed: 1044,
  },
  {
    id: 818,
    name: "Intel UHD P630",
    g2d: 325,
    dx9: 52,
    dx10: 32,
    dx11: 63,
    dx12: 13,
    overallSpeed: 2919,
  },
  {
    id: 819,
    name: "Intel UHD P750",
    g2d: 657,
    dx9: 35,
    dx10: 21,
    dx11: 26,
    dx12: 8,
    overallSpeed: 1906,
  },
  {
    id: 821,
    name: "ION",
    g2d: 24,
    price: 229.99,
    dx9: 2,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 89,
    pricePerG3D: 0.39,
  },
  {
    id: 832,
    name: "Matrox C420 LP PCIe x16",
    g2d: 523,
    dx9: 10,
    dx10: 4,
    dx11: 11,
    dx12: 4,
    overallSpeed: 635,
  },
  {
    id: 833,
    name: "Matrox C680 PCIe x16",
    g2d: 700,
    dx9: 29,
    dx10: 14,
    dx11: 30,
    dx12: 10,
    overallSpeed: 1904,
  },
  {
    id: 841,
    name: "Matrox G200eR WDDM 1.2",
    g2d: 210,
    dx9: 0,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 45,
  },
  {
    id: 845,
    name: "Matrox G200eW3 WDDM 2.0",
    g2d: 316,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 94,
  },
  {
    id: 849,
    name: "Matrox M9128 LP PCIe x16",
    g2d: 47,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 29,
  },
  {
    id: 850,
    name: "Matrox M9138 LP PCIe x16",
    g2d: 160,
    dx9: 1,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 42,
  },
  {
    id: 854,
    name: "Matrox Millennium P690 PCIe x16",
    g2d: 295,
    dx9: 11,
    dx10: 3,
    dx11: 13,
    dx12: 2,
    overallSpeed: 367,
  },
  {
    id: 859,
    name: "MCT USB3.0 External Device",
    g2d: 129,
    dx9: 7,
    dx10: 2,
    dx11: 14,
    dx12: 5,
    overallSpeed: 520,
  },
  {
    id: 866,
    name: "Mobile Intel 45 Express",
    g2d: 43,
    dx9: 1,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 51,
  },
  {
    id: 872,
    name: "Mobile Intel 965 Express",
    g2d: 21,
    dx9: 1,
    dx10: 5,
    dx11: 1,
    dx12: 0,
    overallSpeed: 64,
  },
  {
    id: 874,
    name: "Mobile Intel HD",
    g2d: 164,
    price: 479.98,
    dx9: 7,
    dx10: 2,
    dx11: 2,
    dx12: 0,
    overallSpeed: 285,
    pricePerG3D: 0.59,
  },
  {
    id: 913,
    name: "Mobility Radeon HD 3650",
    g2d: 51,
    price: 73.53,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 127,
    pricePerG3D: 1.73,
  },
  {
    id: 917,
    name: "Mobility Radeon HD 3870 X2",
    g2d: 187,
    dx9: 14,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 478,
  },
  {
    id: 926,
    name: "Mobility Radeon HD 4570",
    g2d: 29,
    price: 75.9,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 133,
    pricePerG3D: 1.76,
  },
  {
    id: 942,
    name: "Mobility Radeon HD 5570",
    g2d: 248,
    dx9: 14,
    dx10: 4,
    dx11: 14,
    dx12: 0,
    overallSpeed: 547,
  },
  {
    id: 944,
    name: "Mobility Radeon HD 5650",
    g2d: 147,
    dx9: 10,
    dx10: 4,
    dx11: 11,
    dx12: 0,
    overallSpeed: 453,
  },
  {
    id: 946,
    name: "Mobility Radeon HD 5730",
    g2d: 145,
    dx9: 11,
    dx10: 4,
    dx11: 12,
    dx12: 0,
    overallSpeed: 489,
  },
  {
    id: 948,
    name: "Mobility Radeon HD 5870",
    g2d: 179,
    dx9: 25,
    dx10: 9,
    dx11: 16,
    dx12: 0,
    overallSpeed: 1012,
  },
  {
    id: 977,
    name: "NVIDIA TITAN Xp",
    g2d: 812,
    price: 1790,
    dx9: 215,
    dx10: 260,
    dx11: 372,
    dx12: 64,
    overallSpeed: 18280,
    pricePerG3D: 10.21,
  },
  {
    id: 978,
    name: "NVS 2100M",
    g2d: 221,
    dx9: 4,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 139,
  },
  {
    id: 979,
    name: "NVS 300",
    g2d: 67,
    price: 63,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 113,
    pricePerG3D: 1.8,
  },
  {
    id: 980,
    name: "NVS 310",
    g2d: 180,
    price: 69,
    dx9: 8,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 238,
    pricePerG3D: 3.44,
  },
  {
    id: 981,
    name: "NVS 3100M",
    g2d: 47,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 115,
  },
  {
    id: 982,
    name: "NVS 315",
    g2d: 208,
    price: 64,
    dx9: 8,
    dx10: 2,
    dx11: 7,
    dx12: 0,
    overallSpeed: 293,
    pricePerG3D: 4.57,
  },
  {
    id: 983,
    name: "NVS 4200M",
    g2d: 76,
    price: 399,
    dx9: 7,
    dx10: 2,
    dx11: 3,
    dx12: 0,
    overallSpeed: 252,
    pricePerG3D: 0.63,
  },
  {
    id: 984,
    name: "NVS 510",
    g2d: 272,
    price: 139.69,
    dx9: 17,
    dx10: 5,
    dx11: 15,
    dx12: 3,
    overallSpeed: 727,
    pricePerG3D: 5.2,
  },
  {
    id: 985,
    name: "NVS 5100M",
    g2d: 124,
    dx9: 8,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 197,
  },
  {
    id: 986,
    name: "NVS 5200M",
    g2d: 192,
    dx9: 12,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 533,
  },
  {
    id: 987,
    name: "NVS 5400M",
    g2d: 182,
    dx9: 16,
    dx10: 5,
    dx11: 15,
    dx12: 0,
    overallSpeed: 636,
  },
  {
    id: 988,
    name: "NVS 810",
    g2d: 390,
    price: 624.99,
    dx9: 22,
    dx10: 7,
    dx11: 14,
    dx12: 9,
    overallSpeed: 1094,
    pricePerG3D: 1.75,
  },
  {
    id: 991,
    name: "P104-100",
    g2d: 114,
    price: 299.99,
    dx9: 28,
    dx10: 90,
    dx11: 80,
    dx12: 24,
    overallSpeed: 4450,
    pricePerG3D: 14.83,
  },
  {
    id: 992,
    name: "P106-090",
    g2d: 104,
    dx9: 22,
    dx10: 42,
    dx11: 61,
    dx12: 14,
    overallSpeed: 2402,
  },
  {
    id: 993,
    name: "P106-100",
    g2d: 369,
    dx9: 61,
    dx10: 89,
    dx11: 140,
    dx12: 27,
    overallSpeed: 5023,
  },
  {
    id: 995,
    name: "PHDGD Ivy 5",
    g2d: 497,
    dx9: 9,
    dx10: 3,
    dx11: 9,
    dx12: 0,
    overallSpeed: 445,
  },
  {
    id: 1002,
    name: "Quadro 1000M",
    g2d: 196,
    price: 54.5,
    dx9: 16,
    dx10: 5,
    dx11: 14,
    dx12: 0,
    overallSpeed: 598,
    pricePerG3D: 10.97,
  },
  {
    id: 1004,
    name: "Quadro 2000",
    g2d: 294,
    price: 217.5,
    dx9: 27,
    dx10: 8,
    dx11: 23,
    dx12: 0,
    overallSpeed: 945,
    pricePerG3D: 4.35,
  },
  {
    id: 1006,
    name: "Quadro 2000D",
    g2d: 320,
    price: 140,
    dx9: 22,
    dx10: 7,
    dx11: 26,
    dx12: 0,
    overallSpeed: 965,
    pricePerG3D: 6.9,
  },
  {
    id: 1007,
    name: "Quadro 2000M",
    g2d: 273,
    price: 229.74,
    dx9: 21,
    dx10: 6,
    dx11: 19,
    dx12: 0,
    overallSpeed: 794,
    pricePerG3D: 3.45,
  },
  {
    id: 1010,
    name: "Quadro 3000M",
    g2d: 312,
    price: 69.99,
    dx9: 33,
    dx10: 9,
    dx11: 25,
    dx12: 0,
    overallSpeed: 1030,
    pricePerG3D: 14.72,
  },
  {
    id: 1011,
    name: "Quadro 400",
    g2d: 86,
    price: 242.5,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 150,
    pricePerG3D: 0.62,
  },
  {
    id: 1012,
    name: "Quadro 4000",
    g2d: 364,
    price: 209,
    dx9: 44,
    dx10: 14,
    dx11: 38,
    dx12: 0,
    overallSpeed: 1485,
    pricePerG3D: 7.1,
  },
  {
    id: 1013,
    name: "Quadro 4000M",
    g2d: 280,
    price: 209.65,
    dx9: 39,
    dx10: 13,
    dx11: 32,
    dx12: 0,
    overallSpeed: 1299,
    pricePerG3D: 6.2,
  },
  {
    id: 1014,
    name: "Quadro 410",
    g2d: 257,
    price: 129,
    dx9: 13,
    dx10: 2,
    dx11: 7,
    dx12: 2,
    overallSpeed: 430,
    pricePerG3D: 3.33,
  },
  {
    id: 1015,
    name: "Quadro 5000",
    g2d: 371,
    price: 219,
    dx9: 54,
    dx10: 20,
    dx11: 50,
    dx12: 0,
    overallSpeed: 2010,
    pricePerG3D: 9.18,
  },
  {
    id: 1018,
    name: "Quadro 5010M",
    g2d: 362,
    price: 235.95,
    dx9: 60,
    dx10: 21,
    dx11: 48,
    dx12: 0,
    overallSpeed: 1983,
    pricePerG3D: 8.4,
  },
  {
    id: 1019,
    name: "Quadro 600",
    g2d: 225,
    price: 76,
    dx9: 15,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 546,
    pricePerG3D: 7.18,
  },
  {
    id: 1020,
    name: "Quadro 6000",
    g2d: 420,
    price: 449,
    dx9: 63,
    dx10: 26,
    dx11: 69,
    dx12: 0,
    overallSpeed: 2657,
    pricePerG3D: 5.92,
  },
  {
    id: 1021,
    name: "Quadro 7000",
    g2d: 397,
    dx9: 66,
    dx10: 29,
    dx11: 75,
    dx12: 0,
    overallSpeed: 3505,
  },
  {
    id: 1026,
    name: "Quadro FX 1400",
    g2d: 152,
    price: 245.01,
    dx9: 4,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 124,
    pricePerG3D: 0.51,
  },
  {
    id: 1027,
    name: "Quadro FX 1500",
    g2d: 137,
    price: 115.01,
    dx9: 5,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 175,
    pricePerG3D: 1.52,
  },
  {
    id: 1029,
    name: "Quadro FX 1600M",
    g2d: 211,
    price: 149.9,
    dx9: 9,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 186,
    pricePerG3D: 1.24,
  },
  {
    id: 1030,
    name: "Quadro FX 1700",
    g2d: 50,
    price: 129,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 119,
    pricePerG3D: 0.92,
  },
  {
    id: 1031,
    name: "Quadro FX 1700M",
    g2d: 177,
    dx9: 11,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 180,
  },
  {
    id: 1032,
    name: "Quadro FX 1800",
    g2d: 110,
    price: 135,
    dx9: 17,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 404,
    pricePerG3D: 2.99,
  },
  {
    id: 1033,
    name: "Quadro FX 1800M",
    g2d: 112,
    dx9: 12,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 445,
  },
  {
    id: 1037,
    name: "Quadro FX 2700M",
    g2d: 96,
    price: 99.95,
    dx9: 17,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 376,
    pricePerG3D: 3.76,
  },
  {
    id: 1038,
    name: "Quadro FX 2800M",
    g2d: 88,
    price: 190,
    dx9: 17,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 415,
    pricePerG3D: 2.18,
  },
  {
    id: 1044,
    name: "Quadro FX 3500",
    g2d: 126,
    price: 68.98,
    dx9: 8,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 315,
    pricePerG3D: 4.57,
  },
  {
    id: 1046,
    name: "Quadro FX 350M",
    g2d: 132,
    dx9: 2,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 45,
  },
  {
    id: 1052,
    name: "Quadro FX 3700",
    g2d: 215,
    price: 282.87,
    dx9: 15,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 388,
    pricePerG3D: 1.37,
  },
  {
    id: 1053,
    name: "Quadro FX 3700M",
    g2d: 133,
    price: 925,
    dx9: 18,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 499,
    pricePerG3D: 0.54,
  },
  {
    id: 1055,
    name: "Quadro FX 380",
    g2d: 151,
    price: 72.5,
    dx9: 7,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 186,
    pricePerG3D: 2.56,
  },
  {
    id: 1056,
    name: "Quadro FX 380 LP",
    g2d: 169,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 138,
  },
  {
    id: 1057,
    name: "Quadro FX 3800",
    g2d: 112,
    price: 149,
    dx9: 19,
    dx10: 7,
    dx11: 0,
    dx12: 1,
    overallSpeed: 776,
    pricePerG3D: 5.21,
  },
  {
    id: 1058,
    name: "Quadro FX 3800M",
    g2d: 107,
    dx9: 21,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 584,
  },
  {
    id: 1059,
    name: "Quadro FX 380M",
    g2d: 124,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 124,
  },
  {
    id: 1061,
    name: "Quadro FX 4500",
    g2d: 180,
    price: 169,
    dx9: 6,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 241,
    pricePerG3D: 1.42,
  },
  {
    id: 1063,
    name: "Quadro FX 4600",
    g2d: 216,
    price: 333.25,
    dx9: 19,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 439,
    pricePerG3D: 1.32,
  },
  {
    id: 1065,
    name: "Quadro FX 4800",
    g2d: 128,
    price: 199,
    dx9: 23,
    dx10: 10,
    dx11: 0,
    dx12: 0,
    overallSpeed: 972,
    pricePerG3D: 4.88,
  },
  {
    id: 1072,
    name: "Quadro FX 5600",
    g2d: 168,
    price: 168.98,
    dx9: 18,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 562,
    pricePerG3D: 3.32,
  },
  {
    id: 1074,
    name: "Quadro FX 570M",
    g2d: 116,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 122,
  },
  {
    id: 1075,
    name: "Quadro FX 580",
    g2d: 75,
    price: 130,
    dx9: 10,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 142,
    pricePerG3D: 1.09,
  },
  {
    id: 1076,
    name: "Quadro FX 5800",
    g2d: 153,
    price: 269,
    dx9: 27,
    dx10: 13,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1254,
    pricePerG3D: 4.66,
  },
  {
    id: 1077,
    name: "Quadro FX 770M",
    g2d: 92,
    price: 527,
    dx9: 13,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 198,
    pricePerG3D: 0.38,
  },
  {
    id: 1078,
    name: "Quadro FX 880M",
    g2d: 96,
    dx9: 10,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 227,
  },
  {
    id: 1080,
    name: "Quadro GP100",
    g2d: 834,
    dx9: 195,
    dx10: 254,
    dx11: 444,
    dx12: 51,
    overallSpeed: 15549,
  },
  {
    id: 1082,
    name: "Quadro K1000M",
    g2d: 241,
    price: 69.95,
    dx9: 18,
    dx10: 6,
    dx11: 15,
    dx12: 2,
    overallSpeed: 770,
    pricePerG3D: 11.01,
  },
  {
    id: 1083,
    name: "Quadro K1100M",
    g2d: 253,
    price: 322.99,
    dx9: 23,
    dx10: 7,
    dx11: 24,
    dx12: 4,
    overallSpeed: 1107,
    pricePerG3D: 3.43,
  },
  {
    id: 1084,
    name: "Quadro K1200",
    g2d: 559,
    price: 268.55,
    dx9: 48,
    dx10: 27,
    dx11: 50,
    dx12: 12,
    overallSpeed: 2878,
    pricePerG3D: 10.72,
  },
  {
    id: 1085,
    name: "Quadro K2000",
    g2d: 377,
    price: 215.06,
    dx9: 32,
    dx10: 11,
    dx11: 35,
    dx12: 6,
    overallSpeed: 1569,
    pricePerG3D: 7.3,
  },
  {
    id: 1086,
    name: "Quadro K2000D",
    g2d: 416,
    price: 404,
    dx9: 34,
    dx10: 11,
    dx11: 36,
    dx12: 6,
    overallSpeed: 1627,
    pricePerG3D: 4.03,
  },
  {
    id: 1087,
    name: "Quadro K2000M",
    g2d: 266,
    price: 144.04,
    dx9: 21,
    dx10: 7,
    dx11: 22,
    dx12: 4,
    overallSpeed: 1033,
    pricePerG3D: 7.17,
  },
  {
    id: 1088,
    name: "Quadro K2100M",
    g2d: 275,
    price: 415.99,
    dx9: 27,
    dx10: 10,
    dx11: 30,
    dx12: 5,
    overallSpeed: 1371,
    pricePerG3D: 3.3,
  },
  {
    id: 1089,
    name: "Quadro K2200",
    g2d: 521,
    price: 284.82,
    dx9: 55,
    dx10: 30,
    dx11: 61,
    dx12: 17,
    overallSpeed: 3538,
    pricePerG3D: 12.42,
  },
  {
    id: 1090,
    name: "Quadro K2200M",
    g2d: 440,
    price: 124.95,
    dx9: 63,
    dx10: 35,
    dx11: 65,
    dx12: 19,
    overallSpeed: 3883,
    pricePerG3D: 31.08,
  },
  {
    id: 1091,
    name: "Quadro K3000M",
    g2d: 350,
    price: 407.56,
    dx9: 35,
    dx10: 15,
    dx11: 33,
    dx12: 5,
    overallSpeed: 1648,
    pricePerG3D: 4.04,
  },
  {
    id: 1092,
    name: "Quadro K3100M",
    g2d: 333,
    price: 399.95,
    dx9: 48,
    dx10: 18,
    dx11: 48,
    dx12: 8,
    overallSpeed: 2285,
    pricePerG3D: 5.71,
  },
  {
    id: 1093,
    name: "Quadro K4000",
    g2d: 422,
    price: 265,
    dx9: 49,
    dx10: 22,
    dx11: 58,
    dx12: 10,
    overallSpeed: 2697,
    pricePerG3D: 10.18,
  },
  {
    id: 1094,
    name: "Quadro K4000M",
    g2d: 386,
    price: 249,
    dx9: 39,
    dx10: 18,
    dx11: 42,
    dx12: 7,
    overallSpeed: 1992,
    pricePerG3D: 8,
  },
  {
    id: 1095,
    name: "Quadro K4100M",
    g2d: 349,
    price: 322,
    dx9: 55,
    dx10: 21,
    dx11: 53,
    dx12: 8,
    overallSpeed: 2584,
    pricePerG3D: 8.03,
  },
  {
    id: 1096,
    name: "Quadro K420",
    g2d: 275,
    price: 269,
    dx9: 18,
    dx10: 6,
    dx11: 15,
    dx12: 3,
    overallSpeed: 783,
    pricePerG3D: 2.91,
  },
  {
    id: 1097,
    name: "Quadro K4200",
    g2d: 505,
    price: 225,
    dx9: 73,
    dx10: 37,
    dx11: 98,
    dx12: 15,
    overallSpeed: 4328,
    pricePerG3D: 19.24,
  },
  {
    id: 1098,
    name: "Quadro K5000",
    g2d: 446,
    price: 352,
    dx9: 65,
    dx10: 31,
    dx11: 89,
    dx12: 15,
    overallSpeed: 3925,
    pricePerG3D: 11.15,
  },
  {
    id: 1099,
    name: "Quadro K5000M",
    g2d: 385,
    price: 330,
    dx9: 42,
    dx10: 22,
    dx11: 59,
    dx12: 10,
    overallSpeed: 2706,
    pricePerG3D: 8.2,
  },
  {
    id: 1100,
    name: "Quadro K500M",
    g2d: 184,
    dx9: 11,
    dx10: 2,
    dx11: 10,
    dx12: 2,
    overallSpeed: 480,
  },
  {
    id: 1101,
    name: "Quadro K5100M",
    g2d: 454,
    price: 1108.84,
    dx9: 70,
    dx10: 24,
    dx11: 74,
    dx12: 12,
    overallSpeed: 3317,
    pricePerG3D: 2.99,
  },
  {
    id: 1102,
    name: "Quadro K510M",
    g2d: 550,
    dx9: 15,
    dx10: 4,
    dx11: 14,
    dx12: 0,
    overallSpeed: 610,
  },
  {
    id: 1103,
    name: "Quadro K5200",
    g2d: 532,
    price: 580,
    dx9: 94,
    dx10: 54,
    dx11: 119,
    dx12: 21,
    overallSpeed: 5920,
    pricePerG3D: 10.21,
  },
  {
    id: 1104,
    name: "Quadro K600",
    g2d: 260,
    price: 60.24,
    dx9: 18,
    dx10: 6,
    dx11: 15,
    dx12: 3,
    overallSpeed: 767,
    pricePerG3D: 12.74,
  },
  {
    id: 1105,
    name: "Quadro K6000",
    g2d: 554,
    price: 459,
    dx9: 128,
    dx10: 81,
    dx11: 157,
    dx12: 30,
    overallSpeed: 8071,
    pricePerG3D: 17.58,
  },
  {
    id: 1106,
    name: "Quadro K610M",
    g2d: 244,
    price: 240,
    dx9: 16,
    dx10: 5,
    dx11: 14,
    dx12: 3,
    overallSpeed: 732,
    pricePerG3D: 3.05,
  },
  {
    id: 1107,
    name: "Quadro K620",
    g2d: 480,
    price: 2029.99,
    dx9: 44,
    dx10: 21,
    dx11: 33,
    dx12: 10,
    overallSpeed: 2269,
    pricePerG3D: 1.12,
  },
  {
    id: 1108,
    name: "Quadro K620M",
    g2d: 170,
    dx9: 21,
    dx10: 8,
    dx11: 17,
    dx12: 6,
    overallSpeed: 1158,
  },
  {
    id: 1109,
    name: "Quadro M1000M",
    g2d: 329,
    price: 85.99,
    dx9: 54,
    dx10: 29,
    dx11: 51,
    dx12: 13,
    overallSpeed: 3008,
    pricePerG3D: 34.98,
  },
  {
    id: 1110,
    name: "Quadro M1200",
    g2d: 318,
    dx9: 57,
    dx10: 31,
    dx11: 55,
    dx12: 16,
    overallSpeed: 3415,
  },
  {
    id: 1111,
    name: "Quadro M2000",
    g2d: 564,
    price: 289,
    dx9: 72,
    dx10: 27,
    dx11: 73,
    dx12: 19,
    overallSpeed: 3962,
    pricePerG3D: 13.71,
  },
  {
    id: 1112,
    name: "Quadro M2000M",
    g2d: 347,
    price: 279.95,
    dx9: 60,
    dx10: 32,
    dx11: 59,
    dx12: 17,
    overallSpeed: 3584,
    pricePerG3D: 12.8,
  },
  {
    id: 1113,
    name: "Quadro M2200",
    g2d: 428,
    price: 249.99,
    dx9: 79,
    dx10: 36,
    dx11: 77,
    dx12: 21,
    overallSpeed: 4414,
    pricePerG3D: 17.66,
  },
  {
    id: 1114,
    name: "Quadro M3000M",
    g2d: 460,
    price: 159.95,
    dx9: 106,
    dx10: 50,
    dx11: 107,
    dx12: 24,
    overallSpeed: 5635,
    pricePerG3D: 35.23,
  },
  {
    id: 1115,
    name: "Quadro M4000",
    g2d: 674,
    price: 399.99,
    dx9: 116,
    dx10: 63,
    dx11: 124,
    dx12: 26,
    overallSpeed: 6614,
    pricePerG3D: 16.54,
  },
  {
    id: 1116,
    name: "Quadro M4000M",
    g2d: 457,
    price: 420,
    dx9: 123,
    dx10: 64,
    dx11: 130,
    dx12: 27,
    overallSpeed: 6715,
    pricePerG3D: 15.99,
  },
  {
    id: 1117,
    name: "Quadro M5000",
    g2d: 687,
    price: 667.66,
    dx9: 151,
    dx10: 93,
    dx11: 172,
    dx12: 36,
    overallSpeed: 9432,
    pricePerG3D: 14.13,
  },
  {
    id: 1118,
    name: "Quadro M5000M",
    g2d: 514,
    price: 499.95,
    dx9: 120,
    dx10: 69,
    dx11: 135,
    dx12: 28,
    overallSpeed: 6881,
    pricePerG3D: 13.76,
  },
  {
    id: 1119,
    name: "Quadro M500M",
    g2d: 195,
    dx9: 19,
    dx10: 7,
    dx11: 14,
    dx12: 7,
    overallSpeed: 1113,
  },
  {
    id: 1120,
    name: "Quadro M520",
    g2d: 244,
    dx9: 30,
    dx10: 20,
    dx11: 34,
    dx12: 10,
    overallSpeed: 2034,
  },
  {
    id: 1122,
    name: "Quadro M6000",
    g2d: 756,
    price: 1595,
    dx9: 174,
    dx10: 121,
    dx11: 244,
    dx12: 48,
    overallSpeed: 11213,
    pricePerG3D: 7.03,
  },
  {
    id: 1123,
    name: "Quadro M6000 24GB",
    g2d: 880,
    dx9: 191,
    dx10: 140,
    dx11: 244,
    dx12: 51,
    overallSpeed: 12600,
  },
  {
    id: 1124,
    name: "Quadro M600M",
    g2d: 563,
    price: 39.99,
    dx9: 67,
    dx10: 15,
    dx11: 41,
    dx12: 10,
    overallSpeed: 2142,
    pricePerG3D: 53.57,
  },
  {
    id: 1125,
    name: "Quadro M620",
    g2d: 444,
    dx9: 48,
    dx10: 27,
    dx11: 48,
    dx12: 12,
    overallSpeed: 2801,
  },
  {
    id: 1128,
    name: "Quadro NVS 130M",
    g2d: 190,
    dx9: 1,
    dx10: 8,
    dx11: 0,
    dx12: 0,
    overallSpeed: 97,
  },
  {
    id: 1129,
    name: "Quadro NVS 135M",
    g2d: 74,
    dx9: 1,
    dx10: 7,
    dx11: 0,
    dx12: 0,
    overallSpeed: 67,
  },
  {
    id: 1130,
    name: "Quadro NVS 140M",
    g2d: 146,
    dx9: 0,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 69,
  },
  {
    id: 1132,
    name: "Quadro NVS 160M",
    g2d: 46,
    dx9: 3,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 76,
  },
  {
    id: 1139,
    name: "Quadro NVS 290",
    g2d: 89,
    price: 59,
    dx9: 3,
    dx10: 9,
    dx11: 0,
    dx12: 0,
    overallSpeed: 225,
    pricePerG3D: 3.82,
  },
  {
    id: 1140,
    name: "Quadro NVS 295",
    g2d: 80,
    price: 63,
    dx9: 3,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 76,
    pricePerG3D: 1.2,
  },
  {
    id: 1141,
    name: "Quadro NVS 320M",
    g2d: 159,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 160,
  },
  {
    id: 1142,
    name: "Quadro NVS 420",
    g2d: 271,
    price: 150,
    dx9: 3,
    dx10: 0,
    dx11: 0,
    dx12: 0,
    overallSpeed: 81,
    pricePerG3D: 0.54,
  },
  {
    id: 1144,
    name: "Quadro NVS 450",
    g2d: 187,
    price: 159,
    dx9: 2,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 65,
    pricePerG3D: 0.41,
  },
  {
    id: 1147,
    name: "Quadro P1000",
    g2d: 648,
    price: 347.94,
    dx9: 79,
    dx10: 39,
    dx11: 80,
    dx12: 19,
    overallSpeed: 4478,
    pricePerG3D: 12.87,
  },
  {
    id: 1148,
    name: "Quadro P2000",
    g2d: 696,
    price: 411.99,
    dx9: 124,
    dx10: 67,
    dx11: 126,
    dx12: 28,
    overallSpeed: 7027,
    pricePerG3D: 17.06,
  },
  {
    id: 1149,
    name: "Quadro P2000 with Max-Q Design",
    g2d: 591,
    dx9: 83,
    dx10: 45,
    dx11: 84,
    dx12: 20,
    overallSpeed: 4949,
  },
  {
    id: 1150,
    name: "Quadro P2200",
    g2d: 998,
    price: 486.14,
    dx9: 190,
    dx10: 92,
    dx11: 185,
    dx12: 33,
    overallSpeed: 9665,
    pricePerG3D: 19.88,
  },
  {
    id: 1151,
    name: "Quadro P3000",
    g2d: 461,
    dx9: 117,
    dx10: 72,
    dx11: 127,
    dx12: 22,
    overallSpeed: 6153,
  },
  {
    id: 1152,
    name: "Quadro P3200",
    g2d: 531,
    dx9: 146,
    dx10: 98,
    dx11: 162,
    dx12: 28,
    overallSpeed: 8359,
  },
  {
    id: 1153,
    name: "Quadro P3200 with Max-Q Design",
    g2d: 580,
    dx9: 167,
    dx10: 105,
    dx11: 179,
    dx12: 29,
    overallSpeed: 9237,
  },
  {
    id: 1154,
    name: "Quadro P400",
    g2d: 442,
    price: 214.17,
    dx9: 33,
    dx10: 10,
    dx11: 32,
    dx12: 8,
    overallSpeed: 1637,
    pricePerG3D: 7.65,
  },
  {
    id: 1155,
    name: "Quadro P4000",
    g2d: 815,
    price: 1120,
    dx9: 184,
    dx10: 144,
    dx11: 222,
    dx12: 38,
    overallSpeed: 11479,
    pricePerG3D: 10.25,
  },
  {
    id: 1157,
    name: "Quadro P4200",
    g2d: 642,
    dx9: 183,
    dx10: 150,
    dx11: 194,
    dx12: 31,
    overallSpeed: 10125,
  },
  {
    id: 1158,
    name: "Quadro P4200 with Max-Q Design",
    g2d: 583,
    dx9: 189,
    dx10: 161,
    dx11: 242,
    dx12: 43,
    overallSpeed: 11869,
  },
  {
    id: 1159,
    name: "Quadro P500",
    g2d: 275,
    dx9: 30,
    dx10: 10,
    dx11: 31,
    dx12: 8,
    overallSpeed: 1597,
  },
  {
    id: 1160,
    name: "Quadro P5000",
    g2d: 689,
    price: 1980,
    dx9: 160,
    dx10: 164,
    dx11: 239,
    dx12: 36,
    overallSpeed: 11836,
    pricePerG3D: 5.98,
  },
  {
    id: 1161,
    name: "Quadro P520",
    g2d: 257,
    price: 1499,
    dx9: 33,
    dx10: 17,
    dx11: 41,
    dx12: 12,
    overallSpeed: 2144,
    pricePerG3D: 1.43,
  },
  {
    id: 1162,
    name: "Quadro P5200",
    g2d: 716,
    dx9: 194,
    dx10: 154,
    dx11: 247,
    dx12: 34,
    overallSpeed: 11808,
  },
  {
    id: 1163,
    name: "Quadro P5200 with Max-Q Design",
    g2d: 568,
    dx9: 197,
    dx10: 174,
    dx11: 260,
    dx12: 34,
    overallSpeed: 10905,
  },
  {
    id: 1164,
    name: "Quadro P600",
    g2d: 480,
    price: 329,
    dx9: 56,
    dx10: 29,
    dx11: 61,
    dx12: 15,
    overallSpeed: 3343,
    pricePerG3D: 10.16,
  },
  {
    id: 1165,
    name: "Quadro P6000",
    g2d: 813,
    price: 3250,
    dx9: 212,
    dx10: 235,
    dx11: 323,
    dx12: 51,
    overallSpeed: 16449,
    pricePerG3D: 5.06,
  },
  {
    id: 1166,
    name: "Quadro P620",
    g2d: 571,
    price: 228.35,
    dx9: 70,
    dx10: 27,
    dx11: 70,
    dx12: 16,
    overallSpeed: 3673,
    pricePerG3D: 16.09,
  },
  {
    id: 1167,
    name: "Quadro RTX 3000",
    g2d: 524,
    dx9: 174,
    dx10: 164,
    dx11: 224,
    dx12: 40,
    overallSpeed: 11249,
  },
  {
    id: 1168,
    name: "Quadro RTX 3000 with Max-Q Design",
    g2d: 369,
    dx9: 119,
    dx10: 133,
    dx11: 192,
    dx12: 34,
    overallSpeed: 8639,
  },
  {
    id: 1169,
    name: "Quadro RTX 4000",
    g2d: 912,
    price: 899,
    dx9: 211,
    dx10: 236,
    dx11: 316,
    dx12: 51,
    overallSpeed: 15535,
    pricePerG3D: 17.28,
  },
  {
    id: 1170,
    name: "Quadro RTX 4000 (Mobile)",
    g2d: 580,
    dx9: 179,
    dx10: 204,
    dx11: 267,
    dx12: 46,
    overallSpeed: 12832,
  },
  {
    id: 1171,
    name: "Quadro RTX 4000 with Max-Q Design",
    g2d: 579,
    dx9: 194,
    dx10: 220,
    dx11: 288,
    dx12: 42,
    overallSpeed: 13199,
  },
  {
    id: 1172,
    name: "Quadro RTX 5000",
    g2d: 769,
    dx9: 203,
    dx10: 252,
    dx11: 331,
    dx12: 59,
    overallSpeed: 16398,
  },
  {
    id: 1173,
    name: "Quadro RTX 5000 (Mobile)",
    g2d: 705,
    dx9: 204,
    dx10: 221,
    dx11: 302,
    dx12: 56,
    overallSpeed: 14832,
  },
  {
    id: 1174,
    name: "Quadro RTX 5000 with Max-Q Design",
    g2d: 629,
    dx9: 193,
    dx10: 215,
    dx11: 284,
    dx12: 51,
    overallSpeed: 13978,
  },
  {
    id: 1175,
    name: "Quadro RTX 6000",
    g2d: 819,
    price: 6300,
    dx9: 210,
    dx10: 284,
    dx11: 409,
    dx12: 79,
    overallSpeed: 19904,
    pricePerG3D: 3.16,
  },
  {
    id: 1176,
    name: "Quadro RTX 8000",
    g2d: 784,
    price: 4741.49,
    dx9: 208,
    dx10: 285,
    dx11: 459,
    dx12: 81,
    overallSpeed: 19478,
    pricePerG3D: 4.11,
  },
  {
    id: 1177,
    name: "Quadro T1000",
    g2d: 443,
    price: 429.99,
    dx9: 109,
    dx10: 65,
    dx11: 118,
    dx12: 28,
    overallSpeed: 6491,
    pricePerG3D: 15.1,
  },
  {
    id: 1178,
    name: "Quadro T1000 with Max-Q Design",
    g2d: 438,
    dx9: 108,
    dx10: 67,
    dx11: 133,
    dx12: 23,
    overallSpeed: 6474,
  },
  {
    id: 1179,
    name: "Quadro T2000",
    g2d: 476,
    dx9: 122,
    dx10: 69,
    dx11: 129,
    dx12: 29,
    overallSpeed: 7117,
  },
  {
    id: 1180,
    name: "Quadro T2000 with Max-Q Design",
    g2d: 442,
    dx9: 120,
    dx10: 71,
    dx11: 138,
    dx12: 26,
    overallSpeed: 6928,
  },
  {
    id: 1186,
    name: "Qualcomm Adreno 540 GPU",
    g2d: 51,
    dx9: 0,
    dx10: 0,
    dx11: 5,
    dx12: 0,
    overallSpeed: 117,
  },
  {
    id: 1187,
    name: "Qualcomm Adreno 618 GPU",
    g2d: 51,
    dx9: 0,
    dx10: 0,
    dx11: 4,
    dx12: 0,
    overallSpeed: 122,
  },
  {
    id: 1188,
    name: "Qualcomm Adreno 630 GPU",
    g2d: 77,
    dx9: 0,
    dx10: 0,
    dx11: 6,
    dx12: 1,
    overallSpeed: 265,
  },
  {
    id: 1189,
    name: "Qualcomm Adreno 680 GPU",
    g2d: 80,
    dx9: 0,
    dx10: 0,
    dx11: 12,
    dx12: 1,
    overallSpeed: 338,
  },
  {
    id: 1195,
    name: "Radeon 520",
    g2d: 224,
    price: 89.99,
    dx9: 14,
    dx10: 5,
    dx11: 17,
    dx12: 5,
    overallSpeed: 833,
    pricePerG3D: 9.25,
  },
  {
    id: 1196,
    name: "Radeon 530",
    g2d: 184,
    dx9: 16,
    dx10: 6,
    dx11: 19,
    dx12: 5,
    overallSpeed: 942,
  },
  {
    id: 1197,
    name: "Radeon 535",
    g2d: 213,
    dx9: 19,
    dx10: 7,
    dx11: 21,
    dx12: 5,
    overallSpeed: 1060,
  },
  {
    id: 1198,
    name: "Radeon 535DX",
    g2d: 193,
    dx9: 11,
    dx10: 4,
    dx11: 14,
    dx12: 5,
    overallSpeed: 783,
  },
  {
    id: 1199,
    name: "Radeon 540",
    g2d: 282,
    dx9: 22,
    dx10: 9,
    dx11: 22,
    dx12: 6,
    overallSpeed: 1276,
  },
  {
    id: 1200,
    name: "Radeon 540X",
    g2d: 264,
    dx9: 26,
    dx10: 9,
    dx11: 24,
    dx12: 8,
    overallSpeed: 1398,
  },
  {
    id: 1201,
    name: "Radeon 550X",
    g2d: 277,
    dx9: 25,
    dx10: 8,
    dx11: 23,
    dx12: 8,
    overallSpeed: 1412,
  },
  {
    id: 1202,
    name: "Radeon 620",
    g2d: 223,
    dx9: 19,
    dx10: 6,
    dx11: 18,
    dx12: 4,
    overallSpeed: 902,
  },
  {
    id: 1203,
    name: "Radeon 625",
    g2d: 193,
    dx9: 17,
    dx10: 7,
    dx11: 25,
    dx12: 9,
    overallSpeed: 1201,
  },
  {
    id: 1204,
    name: "Radeon 630",
    g2d: 211,
    dx9: 30,
    dx10: 9,
    dx11: 20,
    dx12: 6,
    overallSpeed: 1281,
  },
  {
    id: 1205,
    name: "Radeon 6600M",
    g2d: 162,
    dx9: 13,
    dx10: 5,
    dx11: 12,
    dx12: 0,
    overallSpeed: 564,
  },
  {
    id: 1259,
    name: "Radeon HD 3450",
    g2d: 32,
    price: 89,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 96,
    pricePerG3D: 1.08,
  },
  {
    id: 1260,
    name: "Radeon HD 3470",
    g2d: 95,
    price: 60.38,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 90,
    pricePerG3D: 1.49,
  },
  {
    id: 1262,
    name: "Radeon HD 3670",
    g2d: 78,
    dx9: 6,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 151,
  },
  {
    id: 1263,
    name: "Radeon HD 3850",
    g2d: 52,
    dx9: 19,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 443,
  },
  {
    id: 1264,
    name: "Radeon HD 3850 AGP",
    g2d: 92,
    dx9: 19,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 432,
  },
  {
    id: 1266,
    name: "Radeon HD 3870",
    g2d: 118,
    price: 79.99,
    dx9: 22,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 576,
    pricePerG3D: 7.2,
  },
  {
    id: 1267,
    name: "Radeon HD 3870 X2",
    g2d: 224,
    dx9: 20,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 709,
  },
  {
    id: 1273,
    name: "Radeon HD 4330",
    g2d: 60,
    dx9: 5,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 110,
  },
  {
    id: 1274,
    name: "Radeon HD 4350",
    g2d: 39,
    price: 98.24,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 102,
    pricePerG3D: 1.04,
  },
  {
    id: 1276,
    name: "Radeon HD 4650",
    g2d: 46,
    price: 139.99,
    dx9: 10,
    dx10: 2,
    dx11: 0,
    dx12: 0,
    overallSpeed: 219,
    pricePerG3D: 1.56,
  },
  {
    id: 1278,
    name: "Radeon HD 4670",
    g2d: 62,
    price: 136.65,
    dx9: 16,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 380,
    pricePerG3D: 2.78,
  },
  {
    id: 1279,
    name: "Radeon HD 4770",
    g2d: 172,
    dx9: 30,
    dx10: 7,
    dx11: 0,
    dx12: 0,
    overallSpeed: 906,
  },
  {
    id: 1281,
    name: "Radeon HD 4830",
    g2d: 127,
    price: 59.99,
    dx9: 25,
    dx10: 8,
    dx11: 0,
    dx12: 0,
    overallSpeed: 874,
    pricePerG3D: 14.56,
  },
  {
    id: 1282,
    name: "Radeon HD 4850",
    g2d: 124,
    price: 378,
    dx9: 30,
    dx10: 8,
    dx11: 0,
    dx12: 0,
    overallSpeed: 948,
    pricePerG3D: 2.51,
  },
  {
    id: 1284,
    name: "Radeon HD 4870",
    g2d: 94,
    price: 89.99,
    dx9: 37,
    dx10: 13,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1361,
    pricePerG3D: 15.12,
  },
  {
    id: 1286,
    name: "Radeon HD 4890",
    g2d: 122,
    price: 89.99,
    dx9: 41,
    dx10: 14,
    dx11: 0,
    dx12: 0,
    overallSpeed: 1531,
    pricePerG3D: 17.01,
  },
  {
    id: 1287,
    name: "Radeon HD 5450",
    g2d: 149,
    price: 65.39,
    dx9: 7,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 138,
    pricePerG3D: 2.11,
  },
  {
    id: 1289,
    name: "Radeon HD 5550",
    g2d: 189,
    price: 54.99,
    dx9: 11,
    dx10: 3,
    dx11: 10,
    dx12: 0,
    overallSpeed: 384,
    pricePerG3D: 6.98,
  },
  {
    id: 1290,
    name: "Radeon HD 5570",
    g2d: 183,
    price: 163.99,
    dx9: 13,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 476,
    pricePerG3D: 2.9,
  },
  {
    id: 1291,
    name: "Radeon HD 5600/5700",
    g2d: 273,
    dx9: 13,
    dx10: 4,
    dx11: 15,
    dx12: 0,
    overallSpeed: 661,
  },
  {
    id: 1292,
    name: "Radeon HD 5670",
    g2d: 285,
    price: 59.99,
    dx9: 23,
    dx10: 8,
    dx11: 17,
    dx12: 0,
    overallSpeed: 781,
    pricePerG3D: 13.03,
  },
  {
    id: 1293,
    name: "Radeon HD 5750",
    g2d: 323,
    price: 74.99,
    dx9: 31,
    dx10: 11,
    dx11: 23,
    dx12: 0,
    overallSpeed: 1158,
    pricePerG3D: 15.44,
  },
  {
    id: 1294,
    name: "Radeon HD 5770",
    g2d: 325,
    price: 109.99,
    dx9: 36,
    dx10: 13,
    dx11: 29,
    dx12: 0,
    overallSpeed: 1350,
    pricePerG3D: 12.27,
  },
  {
    id: 1295,
    name: "Radeon HD 5830",
    g2d: 363,
    price: 89.99,
    dx9: 38,
    dx10: 21,
    dx11: 29,
    dx12: 0,
    overallSpeed: 1759,
    pricePerG3D: 19.55,
  },
  {
    id: 1296,
    name: "Radeon HD 5850",
    g2d: 397,
    price: 109.99,
    dx9: 46,
    dx10: 27,
    dx11: 33,
    dx12: 0,
    overallSpeed: 1975,
    pricePerG3D: 17.96,
  },
  {
    id: 1297,
    name: "Radeon HD 5870",
    g2d: 397,
    price: 109.99,
    dx9: 52,
    dx10: 31,
    dx11: 36,
    dx12: 0,
    overallSpeed: 2256,
    pricePerG3D: 20.51,
  },
  {
    id: 1298,
    name: "Radeon HD 5970",
    g2d: 343,
    price: 199.99,
    dx9: 53,
    dx10: 26,
    dx11: 39,
    dx12: 0,
    overallSpeed: 2220,
    pricePerG3D: 11.1,
  },
  {
    id: 1299,
    name: "Radeon HD 6230",
    g2d: 254,
    dx9: 6,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 179,
  },
  {
    id: 1300,
    name: "Radeon HD 6250",
    g2d: 32,
    dx9: 3,
    dx10: 1,
    dx11: 2,
    dx12: 0,
    overallSpeed: 94,
  },
  {
    id: 1301,
    name: "Radeon HD 6290",
    g2d: 32,
    dx9: 3,
    dx10: 1,
    dx11: 2,
    dx12: 0,
    overallSpeed: 111,
  },
  {
    id: 1303,
    name: "Radeon HD 6300M",
    g2d: 123,
    dx9: 6,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 147,
  },
  {
    id: 1304,
    name: "Radeon HD 6310",
    g2d: 38,
    dx9: 4,
    dx10: 1,
    dx11: 2,
    dx12: 0,
    overallSpeed: 123,
  },
  {
    id: 1305,
    name: "Radeon HD 6320",
    g2d: 44,
    price: 554.99,
    dx9: 5,
    dx10: 1,
    dx11: 3,
    dx12: 0,
    overallSpeed: 149,
    pricePerG3D: 0.27,
  },
  {
    id: 1308,
    name: "RADEON HD 6350",
    g2d: 171,
    price: 69.93,
    dx9: 6,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 141,
    pricePerG3D: 2.01,
  },
  {
    id: 1309,
    name: "Radeon HD 6370D",
    g2d: 163,
    dx9: 7,
    dx10: 2,
    dx11: 6,
    dx12: 0,
    overallSpeed: 270,
  },
  {
    id: 1311,
    name: "Radeon HD 6380G",
    g2d: 106,
    price: 399.99,
    dx9: 5,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 204,
    pricePerG3D: 0.51,
  },
  {
    id: 1312,
    name: "Radeon HD 6410D",
    g2d: 122,
    dx9: 6,
    dx10: 2,
    dx11: 6,
    dx12: 0,
    overallSpeed: 222,
  },
  {
    id: 1314,
    name: "Radeon HD 6450",
    g2d: 121,
    price: 89,
    dx9: 8,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 199,
    pricePerG3D: 2.24,
  },
  {
    id: 1317,
    name: "Radeon HD 6470M",
    g2d: 103,
    price: 569.99,
    dx9: 7,
    dx10: 2,
    dx11: 4,
    dx12: 0,
    overallSpeed: 222,
    pricePerG3D: 0.39,
  },
  {
    id: 1318,
    name: "Radeon HD 6480G",
    g2d: 76,
    dx9: 6,
    dx10: 2,
    dx11: 7,
    dx12: 0,
    overallSpeed: 251,
  },
  {
    id: 1321,
    name: "Radeon HD 6520G",
    g2d: 85,
    dx9: 8,
    dx10: 3,
    dx11: 7,
    dx12: 0,
    overallSpeed: 311,
  },
  {
    id: 1322,
    name: "Radeon HD 6530D",
    g2d: 139,
    dx9: 9,
    dx10: 2,
    dx11: 9,
    dx12: 0,
    overallSpeed: 317,
  },
  {
    id: 1324,
    name: "Radeon HD 6550D",
    g2d: 151,
    dx9: 11,
    dx10: 3,
    dx11: 11,
    dx12: 0,
    overallSpeed: 414,
  },
  {
    id: 1325,
    name: "Radeon HD 6570",
    g2d: 198,
    price: 69.99,
    dx9: 13,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 499,
    pricePerG3D: 7.13,
  },
  {
    id: 1327,
    name: "Radeon HD 6620G",
    g2d: 118,
    dx9: 9,
    dx10: 3,
    dx11: 8,
    dx12: 0,
    overallSpeed: 358,
  },
  {
    id: 1330,
    name: "Radeon HD 6650M",
    g2d: 239,
    dx9: 19,
    dx10: 8,
    dx11: 15,
    dx12: 0,
    overallSpeed: 750,
  },
  {
    id: 1331,
    name: "Radeon HD 6670",
    g2d: 232,
    price: 74.99,
    dx9: 19,
    dx10: 6,
    dx11: 17,
    dx12: 0,
    overallSpeed: 740,
    pricePerG3D: 9.87,
  },
  {
    id: 1336,
    name: "Radeon HD 6750",
    g2d: 299,
    price: 235,
    dx9: 27,
    dx10: 10,
    dx11: 23,
    dx12: 0,
    overallSpeed: 1002,
    pricePerG3D: 4.27,
  },
  {
    id: 1338,
    name: "Radeon HD 6770",
    g2d: 312,
    price: 225,
    dx9: 35,
    dx10: 11,
    dx11: 27,
    dx12: 0,
    overallSpeed: 1230,
    pricePerG3D: 5.47,
  },
  {
    id: 1340,
    name: "Radeon HD 6790",
    g2d: 354,
    price: 289,
    dx9: 34,
    dx10: 20,
    dx11: 26,
    dx12: 0,
    overallSpeed: 1581,
    pricePerG3D: 5.47,
  },
  {
    id: 1341,
    name: "Radeon HD 6800M",
    g2d: 230,
    dx9: 17,
    dx10: 5,
    dx11: 17,
    dx12: 0,
    overallSpeed: 728,
  },
  {
    id: 1342,
    name: "Radeon HD 6850",
    g2d: 425,
    price: 117.9,
    dx9: 50,
    dx10: 28,
    dx11: 34,
    dx12: 0,
    overallSpeed: 1986,
    pricePerG3D: 16.85,
  },
  {
    id: 1344,
    name: "Radeon HD 6870",
    g2d: 395,
    price: 299,
    dx9: 52,
    dx10: 29,
    dx11: 40,
    dx12: 0,
    overallSpeed: 2209,
    pricePerG3D: 7.39,
  },
  {
    id: 1345,
    name: "Radeon HD 6900M",
    g2d: 340,
    dx9: 45,
    dx10: 25,
    dx11: 31,
    dx12: 0,
    overallSpeed: 1732,
  },
  {
    id: 1346,
    name: "Radeon HD 6950",
    g2d: 427,
    price: 149.99,
    dx9: 68,
    dx10: 37,
    dx11: 47,
    dx12: 0,
    overallSpeed: 2686,
    pricePerG3D: 17.91,
  },
  {
    id: 1347,
    name: "Radeon HD 6970",
    g2d: 435,
    price: 159.99,
    dx9: 69,
    dx10: 39,
    dx11: 50,
    dx12: 0,
    overallSpeed: 2863,
    pricePerG3D: 17.9,
  },
  {
    id: 1350,
    name: "Radeon HD 7290",
    g2d: 51,
    dx9: 3,
    dx10: 1,
    dx11: 2,
    dx12: 0,
    overallSpeed: 115,
  },
  {
    id: 1352,
    name: "Radeon HD 7310",
    g2d: 46,
    dx9: 4,
    dx10: 1,
    dx11: 3,
    dx12: 0,
    overallSpeed: 129,
  },
  {
    id: 1356,
    name: "Radeon HD 7340",
    g2d: 58,
    price: 552.69,
    dx9: 5,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 160,
    pricePerG3D: 0.29,
  },
  {
    id: 1359,
    name: "Radeon HD 7350",
    g2d: 248,
    dx9: 8,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 193,
  },
  {
    id: 1360,
    name: "Radeon HD 7400G",
    g2d: 160,
    dx9: 6,
    dx10: 3,
    dx11: 6,
    dx12: 0,
    overallSpeed: 300,
  },
  {
    id: 1361,
    name: "Radeon HD 7420G",
    g2d: 122,
    dx9: 8,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 284,
  },
  {
    id: 1362,
    name: "Radeon HD 7450",
    g2d: 159,
    price: 49.99,
    dx9: 9,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 229,
    pricePerG3D: 4.58,
  },
  {
    id: 1365,
    name: "Radeon HD 7470",
    g2d: 177,
    price: 81.37,
    dx9: 12,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 316,
    pricePerG3D: 3.89,
  },
  {
    id: 1367,
    name: "Radeon HD 7480D",
    g2d: 122,
    dx9: 8,
    dx10: 2,
    dx11: 7,
    dx12: 0,
    overallSpeed: 289,
  },
  {
    id: 1368,
    name: "Radeon HD 7500G",
    g2d: 114,
    dx9: 7,
    dx10: 3,
    dx11: 8,
    dx12: 0,
    overallSpeed: 330,
  },
  {
    id: 1372,
    name: "Radeon HD 7520G",
    g2d: 125,
    dx9: 7,
    dx10: 3,
    dx11: 8,
    dx12: 0,
    overallSpeed: 316,
  },
  {
    id: 1385,
    name: "Radeon HD 7520G HD 7600M Dual",
    g2d: 150,
    dx9: 8,
    dx10: 3,
    dx11: 0,
    dx12: 0,
    overallSpeed: 447,
  },
  {
    id: 1392,
    name: "Radeon HD 7540D",
    g2d: 124,
    dx9: 9,
    dx10: 2,
    dx11: 8,
    dx12: 0,
    overallSpeed: 330,
  },
  {
    id: 1398,
    name: "Radeon HD 7560D",
    g2d: 170,
    dx9: 13,
    dx10: 4,
    dx11: 12,
    dx12: 0,
    overallSpeed: 470,
  },
  {
    id: 1414,
    name: "Radeon HD 7570",
    g2d: 282,
    price: 102.49,
    dx9: 15,
    dx10: 5,
    dx11: 15,
    dx12: 0,
    overallSpeed: 622,
    pricePerG3D: 6.07,
  },
  {
    id: 1415,
    name: "Radeon HD 7570M",
    g2d: 203,
    dx9: 10,
    dx10: 4,
    dx11: 11,
    dx12: 0,
    overallSpeed: 448,
  },
  {
    id: 1418,
    name: "Radeon HD 7600G",
    g2d: 101,
    dx9: 8,
    dx10: 3,
    dx11: 7,
    dx12: 0,
    overallSpeed: 323,
  },
  {
    id: 1428,
    name: "Radeon HD 7600G HD Dual",
    g2d: 158,
    dx9: 8,
    dx10: 4,
    dx11: 10,
    dx12: 0,
    overallSpeed: 435,
  },
  {
    id: 1432,
    name: "Radeon HD 7620G",
    g2d: 112,
    dx9: 10,
    dx10: 3,
    dx11: 8,
    dx12: 0,
    overallSpeed: 356,
  },
  {
    id: 1438,
    name: "Radeon HD 7640G",
    g2d: 125,
    dx9: 10,
    dx10: 4,
    dx11: 12,
    dx12: 0,
    overallSpeed: 441,
  },
  {
    id: 1461,
    name: "Radeon HD 7640G HD 7670M Dual",
    g2d: 97,
    dx9: 10,
    dx10: 5,
    dx11: 0,
    dx12: 0,
    overallSpeed: 519,
  },
  {
    id: 1466,
    name: "Radeon HD 7640G HD 8570M Dual",
    g2d: 196,
    dx9: 6,
    dx10: 1,
    dx11: 8,
    dx12: 0,
    overallSpeed: 475,
  },
  {
    id: 1471,
    name: "Radeon HD 7640G R5 M230 Dual",
    g2d: 75,
    dx9: 6,
    dx10: 1,
    dx11: 7,
    dx12: 0,
    overallSpeed: 239,
  },
  {
    id: 1475,
    name: "Radeon HD 7650A",
    g2d: 325,
    price: 262,
    dx9: 13,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 564,
    pricePerG3D: 2.15,
  },
  {
    id: 1476,
    name: "Radeon HD 7650M",
    g2d: 79,
    dx9: 10,
    dx10: 4,
    dx11: 8,
    dx12: 0,
    overallSpeed: 454,
  },
  {
    id: 1477,
    name: "Radeon HD 7660D",
    g2d: 186,
    dx9: 14,
    dx10: 4,
    dx11: 13,
    dx12: 0,
    overallSpeed: 527,
  },
  {
    id: 1490,
    name: "Radeon HD 7660G",
    g2d: 129,
    dx9: 10,
    dx10: 4,
    dx11: 11,
    dx12: 0,
    overallSpeed: 475,
  },
  {
    id: 1503,
    name: "Radeon HD 7660G HD 7600M Dual",
    g2d: 169,
    dx9: 11,
    dx10: 5,
    dx11: 14,
    dx12: 0,
    overallSpeed: 659,
  },
  {
    id: 1506,
    name: "Radeon HD 7660G HD 7700M Dual",
    g2d: 168,
    dx9: 21,
    dx10: 6,
    dx11: 21,
    dx12: 0,
    overallSpeed: 777,
  },
  {
    id: 1515,
    name: "Radeon HD 7670",
    g2d: 325,
    dx9: 19,
    dx10: 8,
    dx11: 16,
    dx12: 0,
    overallSpeed: 798,
  },
  {
    id: 1517,
    name: "Radeon HD 7670M",
    g2d: 143,
    price: 629.99,
    dx9: 12,
    dx10: 5,
    dx11: 12,
    dx12: 0,
    overallSpeed: 510,
    pricePerG3D: 0.81,
  },
  {
    id: 1522,
    name: "Radeon HD 7730",
    g2d: 400,
    price: 232.7,
    dx9: 20,
    dx10: 8,
    dx11: 21,
    dx12: 7,
    overallSpeed: 1208,
    pricePerG3D: 5.19,
  },
  {
    id: 1523,
    name: "Radeon HD 7730M",
    g2d: 217,
    dx9: 17,
    dx10: 7,
    dx11: 10,
    dx12: 1,
    overallSpeed: 657,
  },
  {
    id: 1524,
    name: "Radeon HD 7750",
    g2d: 379,
    price: 119.99,
    dx9: 32,
    dx10: 13,
    dx11: 25,
    dx12: 8,
    overallSpeed: 1676,
    pricePerG3D: 13.97,
  },
  {
    id: 1526,
    name: "Radeon HD 7770",
    g2d: 462,
    price: 109.99,
    dx9: 41,
    dx10: 14,
    dx11: 34,
    dx12: 12,
    overallSpeed: 2184,
    pricePerG3D: 19.86,
  },
  {
    id: 1527,
    name: "Radeon HD 7790",
    g2d: 459,
    price: 139.99,
    dx9: 57,
    dx10: 21,
    dx11: 46,
    dx12: 20,
    overallSpeed: 3090,
    pricePerG3D: 22.07,
  },
  {
    id: 1529,
    name: "Radeon HD 7850",
    g2d: 538,
    price: 159.99,
    dx9: 73,
    dx10: 32,
    dx11: 57,
    dx12: 17,
    overallSpeed: 3768,
    pricePerG3D: 23.55,
  },
  {
    id: 1531,
    name: "Radeon HD 7870",
    g2d: 584,
    price: 199.99,
    dx9: 82,
    dx10: 35,
    dx11: 75,
    dx12: 23,
    overallSpeed: 4672,
    pricePerG3D: 23.36,
  },
  {
    id: 1536,
    name: "Radeon HD 7970M",
    g2d: 531,
    dx9: 54,
    dx10: 30,
    dx11: 62,
    dx12: 18,
    overallSpeed: 3619,
  },
  {
    id: 1538,
    name: "Radeon HD 8180",
    g2d: 55,
    dx9: 3,
    dx10: 1,
    dx11: 3,
    dx12: 0,
    overallSpeed: 152,
  },
  {
    id: 1539,
    name: "Radeon HD 8210",
    g2d: 54,
    dx9: 4,
    dx10: 1,
    dx11: 5,
    dx12: 1,
    overallSpeed: 196,
  },
  {
    id: 1541,
    name: "Radeon HD 8240",
    g2d: 61,
    dx9: 4,
    dx10: 1,
    dx11: 6,
    dx12: 1,
    overallSpeed: 241,
  },
  {
    id: 1542,
    name: "Radeon HD 8250",
    g2d: 65,
    dx9: 4,
    dx10: 1,
    dx11: 3,
    dx12: 1,
    overallSpeed: 203,
  },
  {
    id: 1544,
    name: "Radeon HD 8280E",
    g2d: 108,
    dx9: 5,
    dx10: 1,
    dx11: 4,
    dx12: 1,
    overallSpeed: 260,
  },
  {
    id: 1547,
    name: "Radeon HD 8330",
    g2d: 69,
    dx9: 5,
    dx10: 1,
    dx11: 6,
    dx12: 1,
    overallSpeed: 252,
  },
  {
    id: 1548,
    name: "Radeon HD 8330E",
    g2d: 104,
    dx9: 5,
    dx10: 1,
    dx11: 4,
    dx12: 1,
    overallSpeed: 241,
  },
  {
    id: 1549,
    name: "Radeon HD 8350",
    g2d: 248,
    price: 65.99,
    dx9: 8,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 167,
    pricePerG3D: 2.52,
  },
  {
    id: 1551,
    name: "Radeon HD 8370D",
    g2d: 145,
    dx9: 8,
    dx10: 2,
    dx11: 7,
    dx12: 0,
    overallSpeed: 293,
  },
  {
    id: 1552,
    name: "Radeon HD 8400",
    g2d: 79,
    dx9: 5,
    dx10: 1,
    dx11: 6,
    dx12: 1,
    overallSpeed: 253,
  },
  {
    id: 1555,
    name: "Radeon HD 8450G",
    g2d: 149,
    dx9: 8,
    dx10: 3,
    dx11: 9,
    dx12: 0,
    overallSpeed: 352,
  },
  {
    id: 1564,
    name: "Radeon HD 8470",
    g2d: 176,
    dx9: 10,
    dx10: 2,
    dx11: 5,
    dx12: 0,
    overallSpeed: 259,
  },
  {
    id: 1565,
    name: "Radeon HD 8470D",
    g2d: 142,
    dx9: 10,
    dx10: 3,
    dx11: 8,
    dx12: 0,
    overallSpeed: 364,
  },
  {
    id: 1571,
    name: "Radeon HD 8490",
    g2d: 189,
    price: 59.68,
    dx9: 11,
    dx10: 2,
    dx11: 6,
    dx12: 0,
    overallSpeed: 273,
    pricePerG3D: 4.58,
  },
  {
    id: 1572,
    name: "Radeon HD 8500M",
    g2d: 118,
    dx9: 6,
    dx10: 2,
    dx11: 9,
    dx12: 3,
    overallSpeed: 394,
  },
  {
    id: 1574,
    name: "Radeon HD 8510G",
    g2d: 110,
    dx9: 9,
    dx10: 3,
    dx11: 9,
    dx12: 0,
    overallSpeed: 372,
  },
  {
    id: 1578,
    name: "Radeon HD 8550G",
    g2d: 119,
    dx9: 9,
    dx10: 3,
    dx11: 10,
    dx12: 0,
    overallSpeed: 404,
  },
  {
    id: 1590,
    name: "Radeon HD 8550G HD 8600/8700M Dual",
    g2d: 170,
    dx9: 14,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 655,
  },
  {
    id: 1595,
    name: "Radeon HD 8550G R5 M230 Dual",
    g2d: 211,
    dx9: 6,
    dx10: 2,
    dx11: 8,
    dx12: 0,
    overallSpeed: 488,
  },
  {
    id: 1597,
    name: "Radeon HD 8570",
    g2d: 294,
    price: 98.68,
    dx9: 18,
    dx10: 6,
    dx11: 17,
    dx12: 6,
    overallSpeed: 965,
    pricePerG3D: 9.78,
  },
  {
    id: 1600,
    name: "Radeon HD 8570D",
    g2d: 153,
    dx9: 12,
    dx10: 3,
    dx11: 11,
    dx12: 0,
    overallSpeed: 445,
  },
  {
    id: 1613,
    name: "Radeon HD 8570M",
    g2d: 176,
    dx9: 7,
    dx10: 2,
    dx11: 11,
    dx12: 3,
    overallSpeed: 432,
  },
  {
    id: 1615,
    name: "Radeon HD 8610G",
    g2d: 126,
    dx9: 9,
    dx10: 3,
    dx11: 10,
    dx12: 0,
    overallSpeed: 403,
  },
  {
    id: 1620,
    name: "Radeon HD 8610G HD 8600M Dual",
    g2d: 156,
    dx9: 9,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 481,
  },
  {
    id: 1624,
    name: "Radeon HD 8650G",
    g2d: 138,
    dx9: 11,
    dx10: 4,
    dx11: 12,
    dx12: 0,
    overallSpeed: 498,
  },
  {
    id: 1648,
    name: "Radeon HD 8670D",
    g2d: 185,
    dx9: 15,
    dx10: 4,
    dx11: 12,
    dx12: 0,
    overallSpeed: 538,
  },
  {
    id: 1663,
    name: "Radeon HD 8690A",
    g2d: 131,
    dx9: 8,
    dx10: 2,
    dx11: 12,
    dx12: 4,
    overallSpeed: 469,
  },
  {
    id: 1665,
    name: "Radeon HD 8730M",
    g2d: 186,
    dx9: 15,
    dx10: 6,
    dx11: 10,
    dx12: 2,
    overallSpeed: 655,
  },
  {
    id: 1666,
    name: "Radeon HD 8750M",
    g2d: 211,
    dx9: 19,
    dx10: 7,
    dx11: 15,
    dx12: 3,
    overallSpeed: 874,
  },
  {
    id: 1673,
    name: "Radeon HD 8950",
    g2d: 423,
    dx9: 55,
    dx10: 20,
    dx11: 33,
    dx12: 12,
    overallSpeed: 2267,
  },
  {
    id: 1675,
    name: "Radeon HD 8990",
    g2d: 658,
    dx9: 76,
    dx10: 66,
    dx11: 115,
    dx12: 18,
    overallSpeed: 5214,
  },
  {
    id: 1695,
    name: "Radeon Pro",
    g2d: 661,
    price: 699.99,
    dx9: 30,
    dx10: 14,
    dx11: 30,
    dx12: 10,
    overallSpeed: 1958,
    pricePerG3D: 2.8,
  },
  {
    id: 1700,
    name: "Radeon Pro 5300",
    g2d: 653,
    dx9: 100,
    dx10: 84,
    dx11: 132,
    dx12: 27,
    overallSpeed: 7520,
  },
  {
    id: 1701,
    name: "Radeon Pro 5300M",
    g2d: 635,
    dx9: 76,
    dx10: 61,
    dx11: 97,
    dx12: 25,
    overallSpeed: 5714,
  },
  {
    id: 1702,
    name: "Radeon Pro 5500 XT",
    g2d: 619,
    dx9: 93,
    dx10: 86,
    dx11: 136,
    dx12: 39,
    overallSpeed: 8289,
  },
  {
    id: 1703,
    name: "Radeon Pro 5500M",
    g2d: 691,
    dx9: 93,
    dx10: 66,
    dx11: 111,
    dx12: 29,
    overallSpeed: 6633,
  },
  {
    id: 1706,
    name: "Radeon Pro 5600M",
    g2d: 749,
    dx9: 114,
    dx10: 160,
    dx11: 171,
    dx12: 45,
    overallSpeed: 10484,
  },
  {
    id: 1709,
    name: "Radeon Pro 5700",
    g2d: 829,
    dx9: 144,
    dx10: 148,
    dx11: 200,
    dx12: 49,
    overallSpeed: 11844,
  },
  {
    id: 1710,
    name: "Radeon Pro 5700 XT",
    g2d: 839,
    dx9: 150,
    dx10: 140,
    dx11: 221,
    dx12: 58,
    overallSpeed: 12076,
  },
  {
    id: 1713,
    name: "Radeon Pro Duo",
    g2d: 674,
    price: 968.55,
    dx9: 136,
    dx10: 100,
    dx11: 166,
    dx12: 38,
    overallSpeed: 9162,
    pricePerG3D: 9.46,
  },
  {
    id: 1716,
    name: "Radeon Pro V520 MxGPU",
    g2d: 546,
    dx9: 140,
    dx10: 166,
    dx11: 228,
    dx12: 56,
    overallSpeed: 12853,
  },
  {
    id: 1718,
    name: "Radeon Pro Vega 20",
    g2d: 605,
    dx9: 106,
    dx10: 47,
    dx11: 121,
    dx12: 23,
    overallSpeed: 5942,
  },
  {
    id: 1719,
    name: "Radeon Pro Vega 48",
    g2d: 824,
    dx9: 171,
    dx10: 129,
    dx11: 172,
    dx12: 52,
    overallSpeed: 11384,
  },
  {
    id: 1720,
    name: "Radeon Pro Vega 56",
    g2d: 826,
    dx9: 176,
    dx10: 141,
    dx11: 194,
    dx12: 64,
    overallSpeed: 12209,
  },
  {
    id: 1722,
    name: "Radeon Pro Vega 64X",
    g2d: 948,
    dx9: 190,
    dx10: 166,
    dx11: 199,
    dx12: 77,
    overallSpeed: 14630,
  },
  {
    id: 1723,
    name: "Radeon Pro Vega II",
    g2d: 827,
    dx9: 216,
    dx10: 213,
    dx11: 281,
    dx12: 90,
    overallSpeed: 14738,
  },
  {
    id: 1724,
    name: "Radeon Pro VII",
    g2d: 759,
    dx9: 223,
    dx10: 215,
    dx11: 276,
    dx12: 81,
    overallSpeed: 17405,
  },
  {
    id: 1725,
    name: "Radeon Pro W5500",
    g2d: 892,
    price: 679.49,
    dx9: 120,
    dx10: 90,
    dx11: 151,
    dx12: 40,
    overallSpeed: 9247,
    pricePerG3D: 13.61,
  },
  {
    id: 1726,
    name: "Radeon Pro W5500M",
    g2d: 791,
    dx9: 76,
    dx10: 38,
    dx11: 61,
    dx12: 11,
    overallSpeed: 2822,
  },
  {
    id: 1727,
    name: "Radeon Pro W5700",
    g2d: 913,
    price: 1109.99,
    dx9: 180,
    dx10: 198,
    dx11: 286,
    dx12: 62,
    overallSpeed: 15157,
    pricePerG3D: 13.66,
  },
  {
    id: 1728,
    name: "Radeon PRO W6600",
    g2d: 987,
    dx9: 121,
    dx10: 220,
    dx11: 368,
    dx12: 61,
    overallSpeed: 14833,
  },
  {
    id: 1729,
    name: "Radeon PRO W6800",
    g2d: 975,
    price: 2198.99,
    dx9: 136,
    dx10: 280,
    dx11: 463,
    dx12: 99,
    overallSpeed: 19035,
    pricePerG3D: 8.66,
  },
  {
    id: 1730,
    name: "Radeon Pro WX 2100",
    g2d: 414,
    dx9: 33,
    dx10: 10,
    dx11: 34,
    dx12: 11,
    overallSpeed: 1743,
  },
  {
    id: 1731,
    name: "Radeon Pro WX 3100",
    g2d: 492,
    dx9: 48,
    dx10: 21,
    dx11: 50,
    dx12: 12,
    overallSpeed: 2618,
  },
  {
    id: 1732,
    name: "Radeon Pro WX 3200",
    g2d: 483,
    price: 319.43,
    dx9: 47,
    dx10: 21,
    dx11: 45,
    dx12: 14,
    overallSpeed: 2534,
    pricePerG3D: 7.93,
  },
  {
    id: 1733,
    name: "Radeon Pro WX 4100",
    g2d: 721,
    price: 409.99,
    dx9: 58,
    dx10: 30,
    dx11: 62,
    dx12: 22,
    overallSpeed: 3798,
    pricePerG3D: 9.26,
  },
  {
    id: 1734,
    name: "Radeon Pro WX 4130",
    g2d: 375,
    dx9: 26,
    dx10: 21,
    dx11: 27,
    dx12: 9,
    overallSpeed: 1693,
  },
  {
    id: 1735,
    name: "Radeon Pro WX 4150",
    g2d: 373,
    dx9: 43,
    dx10: 23,
    dx11: 26,
    dx12: 6,
    overallSpeed: 1785,
  },
  {
    id: 1737,
    name: "Radeon Pro WX 5100",
    g2d: 822,
    price: 980,
    dx9: 88,
    dx10: 55,
    dx11: 91,
    dx12: 24,
    overallSpeed: 5528,
    pricePerG3D: 5.64,
  },
  {
    id: 1738,
    name: "Radeon Pro WX 7100",
    g2d: 791,
    price: 1250,
    dx9: 115,
    dx10: 75,
    dx11: 127,
    dx12: 39,
    overallSpeed: 7787,
    pricePerG3D: 6.23,
  },
  {
    id: 1739,
    name: "Radeon Pro WX 7130",
    g2d: 695,
    dx9: 120,
    dx10: 84,
    dx11: 101,
    dx12: 49,
    overallSpeed: 5722,
  },
  {
    id: 1740,
    name: "Radeon Pro WX 8200",
    g2d: 759,
    price: 1598.03,
    dx9: 185,
    dx10: 161,
    dx11: 218,
    dx12: 69,
    overallSpeed: 14039,
    pricePerG3D: 8.79,
  },
  {
    id: 1741,
    name: "Radeon Pro WX 9100",
    g2d: 802,
    dx9: 189,
    dx10: 161,
    dx11: 211,
    dx12: 61,
    overallSpeed: 13437,
  },
  {
    id: 1744,
    name: "Radeon R2",
    g2d: 68,
    dx9: 5,
    dx10: 1,
    dx11: 6,
    dx12: 1,
    overallSpeed: 238,
  },
  {
    id: 1745,
    name: "Radeon R2E",
    g2d: 100,
    dx9: 5,
    dx10: 1,
    dx11: 4,
    dx12: 1,
    overallSpeed: 229,
  },
  {
    id: 1746,
    name: "Radeon R3",
    g2d: 97,
    dx9: 5,
    dx10: 2,
    dx11: 7,
    dx12: 2,
    overallSpeed: 305,
  },
  {
    id: 1747,
    name: "Radeon R3E",
    g2d: 90,
    dx9: 6,
    dx10: 1,
    dx11: 4,
    dx12: 1,
    overallSpeed: 206,
  },
  {
    id: 1748,
    name: "Radeon R4",
    g2d: 102,
    price: 396.99,
    dx9: 6,
    dx10: 2,
    dx11: 8,
    dx12: 2,
    overallSpeed: 331,
    pricePerG3D: 0.83,
  },
  {
    id: 1750,
    name: "Radeon R5 220",
    g2d: 111,
    price: 85.26,
    dx9: 7,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 135,
    pricePerG3D: 1.58,
  },
  {
    id: 1751,
    name: "Radeon R5 230",
    g2d: 255,
    price: 81.1,
    dx9: 7,
    dx10: 1,
    dx11: 4,
    dx12: 0,
    overallSpeed: 222,
    pricePerG3D: 2.74,
  },
  {
    id: 1752,
    name: "Radeon R5 235",
    g2d: 178,
    price: 60.13,
    dx9: 12,
    dx10: 2,
    dx11: 7,
    dx12: 0,
    overallSpeed: 302,
    pricePerG3D: 5.02,
  },
  {
    id: 1755,
    name: "Radeon R5 235X",
    g2d: 240,
    dx9: 11,
    dx10: 2,
    dx11: 6,
    dx12: 0,
    overallSpeed: 295,
  },
  {
    id: 1756,
    name: "Radeon R5 240",
    g2d: 200,
    price: 85,
    dx9: 11,
    dx10: 2,
    dx11: 12,
    dx12: 5,
    overallSpeed: 516,
    pricePerG3D: 6.07,
  },
  {
    id: 1758,
    name: "Radeon R5 330",
    g2d: 211,
    price: 339.99,
    dx9: 11,
    dx10: 2,
    dx11: 15,
    dx12: 4,
    overallSpeed: 572,
    pricePerG3D: 1.68,
  },
  {
    id: 1759,
    name: "Radeon R5 340",
    g2d: 427,
    dx9: 21,
    dx10: 6,
    dx11: 15,
    dx12: 6,
    overallSpeed: 1002,
  },
  {
    id: 1760,
    name: "Radeon R5 420",
    g2d: 230,
    price: 39.95,
    dx9: 13,
    dx10: 4,
    dx11: 0,
    dx12: 0,
    overallSpeed: 575,
    pricePerG3D: 14.39,
  },
  {
    id: 1761,
    name: "Radeon R5 430",
    g2d: 321,
    price: 59,
    dx9: 17,
    dx10: 5,
    dx11: 17,
    dx12: 6,
    overallSpeed: 924,
    pricePerG3D: 15.66,
  },
  {
    id: 1762,
    name: "Radeon R5 435",
    g2d: 235,
    dx9: 13,
    dx10: 4,
    dx11: 17,
    dx12: 5,
    overallSpeed: 841,
  },
  {
    id: 1763,
    name: "Radeon R5 A10-9600P 4C 6G",
    g2d: 146,
    dx9: 9,
    dx10: 4,
    dx11: 10,
    dx12: 4,
    overallSpeed: 619,
  },
  {
    id: 1764,
    name: "Radeon R5 A10-9600P RADEON R5, 10 COMPUTE CORES 4C",
    g2d: 151,
    dx9: 9,
    dx10: 4,
    dx11: 12,
    dx12: 5,
    overallSpeed: 692,
  },
  {
    id: 1765,
    name: "Radeon R5 A10-9620P 4C 6G",
    g2d: 196,
    dx9: 11,
    dx10: 5,
    dx11: 12,
    dx12: 5,
    overallSpeed: 732,
  },
  {
    id: 1766,
    name: "Radeon R5 A10-9620P RADEON R5, 10 COMPUTE CORES 4C",
    g2d: 180,
    dx9: 11,
    dx10: 4,
    dx11: 13,
    dx12: 4,
    overallSpeed: 682,
  },
  {
    id: 1767,
    name: "Radeon R5 A10-9630P 4C 6G",
    g2d: 270,
    dx9: 10,
    dx10: 3,
    dx11: 12,
    dx12: 5,
    overallSpeed: 977,
  },
  {
    id: 1769,
    name: "Radeon R5 A6-7480",
    g2d: 215,
    dx9: 12,
    dx10: 4,
    dx11: 16,
    dx12: 6,
    overallSpeed: 806,
  },
  {
    id: 1770,
    name: "Radeon R5 A6-8500P",
    g2d: 220,
    dx9: 6,
    dx10: 4,
    dx11: 10,
    dx12: 4,
    overallSpeed: 625,
  },
  {
    id: 1771,
    name: "Radeon R5 A6-9400 RADEON R5, 6 COMPUTE CORES 2C 4G",
    g2d: 271,
    dx9: 8,
    dx10: 2,
    dx11: 11,
    dx12: 4,
    overallSpeed: 605,
  },
  {
    id: 1772,
    name: "Radeon R5 A6-9500 2C 6G",
    g2d: 249,
    dx9: 12,
    dx10: 4,
    dx11: 17,
    dx12: 7,
    overallSpeed: 853,
  },
  {
    id: 1773,
    name: "Radeon R5 A6-9500 RADEON R5, 8 COMPUTE CORES 2C 6G",
    g2d: 202,
    dx9: 14,
    dx10: 5,
    dx11: 18,
    dx12: 6,
    overallSpeed: 920,
  },
  {
    id: 1775,
    name: "Radeon R5 M230",
    g2d: 148,
    dx9: 6,
    dx10: 2,
    dx11: 9,
    dx12: 3,
    overallSpeed: 389,
  },
  {
    id: 1776,
    name: "Radeon R5 M240",
    g2d: 247,
    dx9: 6,
    dx10: 2,
    dx11: 9,
    dx12: 3,
    overallSpeed: 432,
  },
  {
    id: 1777,
    name: "Radeon R5 M255",
    g2d: 143,
    dx9: 9,
    dx10: 3,
    dx11: 10,
    dx12: 3,
    overallSpeed: 513,
  },
  {
    id: 1778,
    name: "Radeon R5 M315",
    g2d: 214,
    dx9: 5,
    dx10: 2,
    dx11: 13,
    dx12: 5,
    overallSpeed: 462,
  },
  {
    id: 1779,
    name: "Radeon R5 M320",
    g2d: 140,
    dx9: 7,
    dx10: 2,
    dx11: 9,
    dx12: 3,
    overallSpeed: 421,
  },
  {
    id: 1782,
    name: "Radeon R5 M420",
    g2d: 191,
    dx9: 8,
    dx10: 2,
    dx11: 16,
    dx12: 3,
    overallSpeed: 482,
  },
  {
    id: 1784,
    name: "Radeon R5 M435",
    g2d: 178,
    dx9: 14,
    dx10: 5,
    dx11: 15,
    dx12: 4,
    overallSpeed: 797,
  },
  {
    id: 1786,
    name: "Radeon R5 PRO A10-8730B 4C 6G",
    g2d: 201,
    dx9: 8,
    dx10: 4,
    dx11: 11,
    dx12: 5,
    overallSpeed: 695,
  },
  {
    id: 1787,
    name: "Radeon R5 PRO A10-8730B R5, 10 COMPUTE CORES 4C 6G",
    g2d: 139,
    dx9: 9,
    dx10: 3,
    dx11: 11,
    dx12: 4,
    overallSpeed: 589,
  },
  {
    id: 1790,
    name: "Radeon R5 PRO A6-8570 2C 6G",
    g2d: 292,
    dx9: 11,
    dx10: 3,
    dx11: 11,
    dx12: 6,
    overallSpeed: 847,
  },
  {
    id: 1791,
    name: "Radeon R5 PRO A6-8570 R5, 8 COMPUTE CORES 2C 6G",
    g2d: 275,
    dx9: 19,
    dx10: 7,
    dx11: 24,
    dx12: 8,
    overallSpeed: 1238,
  },
  {
    id: 1792,
    name: "Radeon R5 PRO A6-8570E 2C 4G",
    g2d: 268,
    dx9: 7,
    dx10: 2,
    dx11: 9,
    dx12: 4,
    overallSpeed: 638,
  },
  {
    id: 1793,
    name: "Radeon R5 PRO A6-8570E R5, 6 COMPUTE CORES 2C 4G",
    g2d: 210,
    dx9: 12,
    dx10: 6,
    dx11: 16,
    dx12: 6,
    overallSpeed: 866,
  },
  {
    id: 1794,
    name: "Radeon R5 PRO A6-9500 2C 6G",
    g2d: 353,
    dx9: 21,
    dx10: 7,
    dx11: 25,
    dx12: 8,
    overallSpeed: 1096,
  },
  {
    id: 1795,
    name: "Radeon R5 PRO A6-9500 R5, 8 COMPUTE CORES 2C 6G",
    g2d: 231,
    dx9: 16,
    dx10: 6,
    dx11: 17,
    dx12: 7,
    overallSpeed: 1000,
  },
  {
    id: 1797,
    name: "Radeon R5 PRO A6-9500B R5, 6 COMPUTE CORES 2C 4G",
    g2d: 131,
    dx9: 6,
    dx10: 3,
    dx11: 10,
    dx12: 4,
    overallSpeed: 507,
  },
  {
    id: 1798,
    name: "Radeon R5 PRO A6-9500E 2C 4G",
    g2d: 288,
    dx9: 10,
    dx10: 4,
    dx11: 15,
    dx12: 4,
    overallSpeed: 771,
  },
  {
    id: 1799,
    name: "Radeon R5 PRO A8-9600B 4C 6G",
    g2d: 224,
    dx9: 11,
    dx10: 4,
    dx11: 7,
    dx12: 4,
    overallSpeed: 659,
  },
  {
    id: 1800,
    name: "Radeon R5 PRO A8-9600B R5, 10 COMPUTE CORES 4C 6G",
    g2d: 202,
    dx9: 13,
    dx10: 5,
    dx11: 14,
    dx12: 4,
    overallSpeed: 788,
  },
  {
    id: 1801,
    name: "Radeon R5E",
    g2d: 115,
    dx9: 6,
    dx10: 1,
    dx11: 6,
    dx12: 2,
    overallSpeed: 305,
  },
  {
    id: 1802,
    name: "Radeon R6",
    g2d: 147,
    dx9: 10,
    dx10: 4,
    dx11: 11,
    dx12: 4,
    overallSpeed: 640,
  },
  {
    id: 1804,
    name: "Radeon R6 A10-8700P",
    g2d: 134,
    dx9: 8,
    dx10: 3,
    dx11: 9,
    dx12: 4,
    overallSpeed: 491,
  },
  {
    id: 1807,
    name: "Radeon R6 M255DX",
    g2d: 124,
    dx9: 8,
    dx10: 3,
    dx11: 10,
    dx12: 3,
    overallSpeed: 532,
  },
  {
    id: 1809,
    name: "Radeon R6 PRO A10-8700B 4C 6G",
    g2d: 146,
    dx9: 8,
    dx10: 3,
    dx11: 10,
    dx12: 4,
    overallSpeed: 538,
  },
  {
    id: 1810,
    name: "Radeon R6 PRO A10-8700B R6, 10 Compute Cores 4C 6G",
    g2d: 149,
    dx9: 9,
    dx10: 3,
    dx11: 10,
    dx12: 4,
    overallSpeed: 539,
  },
  {
    id: 1811,
    name: "Radeon R6 PRO A8-8600B 4C 6G",
    g2d: 158,
    dx9: 8,
    dx10: 3,
    dx11: 9,
    dx12: 4,
    overallSpeed: 532,
  },
  {
    id: 1812,
    name: "Radeon R6 PRO A8-8600B R6, 10 Compute Cores 4C 6G",
    g2d: 147,
    dx9: 9,
    dx10: 3,
    dx11: 9,
    dx12: 3,
    overallSpeed: 524,
  },
  {
    id: 1818,
    name: "Radeon R7 R7 200 Dual",
    g2d: 310,
    dx9: 18,
    dx10: 5,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1129,
  },
  {
    id: 1823,
    name: "Radeon R7 240",
    g2d: 252,
    price: 199,
    dx9: 16,
    dx10: 5,
    dx11: 15,
    dx12: 5,
    overallSpeed: 853,
    pricePerG3D: 4.29,
  },
  {
    id: 1826,
    name: "Radeon R7 250",
    g2d: 293,
    price: 119.99,
    dx9: 22,
    dx10: 8,
    dx11: 20,
    dx12: 7,
    overallSpeed: 1210,
    pricePerG3D: 10.09,
  },
  {
    id: 1829,
    name: "Radeon R7 260X",
    g2d: 503,
    price: 139.99,
    dx9: 56,
    dx10: 20,
    dx11: 55,
    dx12: 19,
    overallSpeed: 3135,
    pricePerG3D: 22.39,
  },
  {
    id: 1830,
    name: "Radeon R7 340",
    g2d: 357,
    dx9: 14,
    dx10: 5,
    dx11: 16,
    dx12: 6,
    overallSpeed: 931,
  },
  {
    id: 1831,
    name: "Radeon R7 360",
    g2d: 473,
    price: 125,
    dx9: 55,
    dx10: 20,
    dx11: 55,
    dx12: 18,
    overallSpeed: 3076,
    pricePerG3D: 24.61,
  },
  {
    id: 1832,
    name: "Radeon R7 370",
    g2d: 582,
    dx9: 78,
    dx10: 37,
    dx11: 69,
    dx12: 21,
    overallSpeed: 4459,
  },
  {
    id: 1833,
    name: "Radeon R7 430",
    g2d: 438,
    price: 199.99,
    dx9: 21,
    dx10: 8,
    dx11: 20,
    dx12: 6,
    overallSpeed: 1167,
    pricePerG3D: 5.84,
  },
  {
    id: 1834,
    name: "Radeon R7 450",
    g2d: 572,
    price: 79.99,
    dx9: 39,
    dx10: 14,
    dx11: 30,
    dx12: 9,
    overallSpeed: 1969,
    pricePerG3D: 24.61,
  },
  {
    id: 1836,
    name: "Radeon R7 A10-7700K",
    g2d: 254,
    dx9: 13,
    dx10: 4,
    dx11: 13,
    dx12: 5,
    overallSpeed: 737,
  },
  {
    id: 1837,
    name: "Radeon R7 A10-7800",
    g2d: 199,
    dx9: 12,
    dx10: 4,
    dx11: 13,
    dx12: 5,
    overallSpeed: 734,
  },
  {
    id: 1838,
    name: "Radeon R7 A10-7850K",
    g2d: 288,
    dx9: 15,
    dx10: 5,
    dx11: 19,
    dx12: 7,
    overallSpeed: 974,
  },
  {
    id: 1839,
    name: "Radeon R7 A10-7860K",
    g2d: 222,
    dx9: 15,
    dx10: 5,
    dx11: 16,
    dx12: 6,
    overallSpeed: 898,
  },
  {
    id: 1840,
    name: "Radeon R7 A10-7870K",
    g2d: 280,
    dx9: 21,
    dx10: 12,
    dx11: 27,
    dx12: 8,
    overallSpeed: 1443,
  },
  {
    id: 1841,
    name: "Radeon R7 A10-7890K",
    g2d: 241,
    dx9: 13,
    dx10: 4,
    dx11: 12,
    dx12: 4,
    overallSpeed: 768,
  },
  {
    id: 1842,
    name: "Radeon R7 A10-8750",
    g2d: 241,
    dx9: 13,
    dx10: 5,
    dx11: 16,
    dx12: 6,
    overallSpeed: 884,
  },
  {
    id: 1844,
    name: "Radeon R7 A10-9700 RADEON",
    g2d: 245,
    dx9: 15,
    dx10: 5,
    dx11: 19,
    dx12: 7,
    overallSpeed: 1000,
  },
  {
    id: 1846,
    name: "Radeon R7 A10 Extreme Edition",
    g2d: 286,
    dx9: 14,
    dx10: 6,
    dx11: 13,
    dx12: 5,
    overallSpeed: 816,
  },
  {
    id: 1847,
    name: "Radeon R7 A10 PRO-7800B",
    g2d: 289,
    dx9: 6,
    dx10: 1,
    dx11: 7,
    dx12: 3,
    overallSpeed: 562,
  },
  {
    id: 1848,
    name: "Radeon R7 A10 PRO-7850B",
    g2d: 403,
    dx9: 15,
    dx10: 5,
    dx11: 18,
    dx12: 7,
    overallSpeed: 958,
  },
  {
    id: 1849,
    name: "Radeon R7 A12-9700P RADEON",
    g2d: 164,
    price: 435.92,
    dx9: 9,
    dx10: 4,
    dx11: 12,
    dx12: 5,
    overallSpeed: 673,
    pricePerG3D: 1.54,
  },
  {
    id: 1850,
    name: "Radeon R7 A12-9720P RADEON",
    g2d: 190,
    price: 365.48,
    dx9: 10,
    dx10: 4,
    dx11: 14,
    dx12: 6,
    overallSpeed: 764,
    pricePerG3D: 2.09,
  },
  {
    id: 1851,
    name: "Radeon R7 A12-9730P RADEON",
    g2d: 283,
    dx9: 17,
    dx10: 6,
    dx11: 20,
    dx12: 7,
    overallSpeed: 1047,
  },
  {
    id: 1852,
    name: "Radeon R7 A12-9800 RADEON",
    g2d: 298,
    dx9: 12,
    dx10: 5,
    dx11: 14,
    dx12: 7,
    overallSpeed: 993,
  },
  {
    id: 1853,
    name: "Radeon R7 A12-9800E RADEON",
    g2d: 273,
    price: 139.19,
    dx9: 16,
    dx10: 6,
    dx11: 19,
    dx12: 7,
    overallSpeed: 1037,
    pricePerG3D: 7.45,
  },
  {
    id: 1855,
    name: "Radeon R7 A360",
    g2d: 346,
    dx9: 10,
    dx10: 4,
    dx11: 13,
    dx12: 4,
    overallSpeed: 676,
  },
  {
    id: 1858,
    name: "Radeon R7 A8-7500",
    g2d: 336,
    dx9: 13,
    dx10: 5,
    dx11: 17,
    dx12: 6,
    overallSpeed: 948,
  },
  {
    id: 1860,
    name: "Radeon R7 A8-7600",
    g2d: 204,
    dx9: 13,
    dx10: 4,
    dx11: 14,
    dx12: 5,
    overallSpeed: 755,
  },
  {
    id: 1861,
    name: "Radeon R7 A8-7650K",
    g2d: 187,
    dx9: 10,
    dx10: 3,
    dx11: 11,
    dx12: 5,
    overallSpeed: 614,
  },
  {
    id: 1862,
    name: "Radeon R7 A8-7670K",
    g2d: 355,
    dx9: 16,
    dx10: 5,
    dx11: 18,
    dx12: 6,
    overallSpeed: 941,
  },
  {
    id: 1863,
    name: "Radeon R7 A8-7680",
    g2d: 210,
    dx9: 10,
    dx10: 4,
    dx11: 15,
    dx12: 7,
    overallSpeed: 740,
  },
  {
    id: 1865,
    name: "Radeon R7 A8-9600 RADEON",
    g2d: 192,
    dx9: 13,
    dx10: 5,
    dx11: 15,
    dx12: 5,
    overallSpeed: 811,
  },
  {
    id: 1866,
    name: "Radeon R7 A8 PRO-7600B",
    g2d: 167,
    dx9: 11,
    dx10: 3,
    dx11: 11,
    dx12: 4,
    overallSpeed: 607,
  },
  {
    id: 1867,
    name: "Radeon R7 FX-8800P",
    g2d: 195,
    dx9: 12,
    dx10: 5,
    dx11: 15,
    dx12: 6,
    overallSpeed: 813,
  },
  {
    id: 1868,
    name: "Radeon R7 FX-9800P RADEON",
    g2d: 197,
    price: 530,
    dx9: 11,
    dx10: 4,
    dx11: 13,
    dx12: 5,
    overallSpeed: 727,
    pricePerG3D: 1.37,
  },
  {
    id: 1869,
    name: "Radeon R7 FX-9830P RADEON",
    g2d: 255,
    dx9: 17,
    dx10: 5,
    dx11: 18,
    dx12: 7,
    overallSpeed: 1063,
  },
  {
    id: 1871,
    name: "Radeon R7 M260",
    g2d: 119,
    price: 799,
    dx9: 8,
    dx10: 3,
    dx11: 9,
    dx12: 3,
    overallSpeed: 447,
    pricePerG3D: 0.56,
  },
  {
    id: 1872,
    name: "Radeon R7 M260DX",
    g2d: 210,
    dx9: 14,
    dx10: 5,
    dx11: 15,
    dx12: 5,
    overallSpeed: 822,
  },
  {
    id: 1873,
    name: "Radeon R7 M260X",
    g2d: 216,
    dx9: 15,
    dx10: 8,
    dx11: 13,
    dx12: 5,
    overallSpeed: 949,
  },
  {
    id: 1874,
    name: "Radeon R7 M265",
    g2d: 220,
    dx9: 8,
    dx10: 4,
    dx11: 10,
    dx12: 4,
    overallSpeed: 607,
  },
  {
    id: 1875,
    name: "Radeon R7 M265DX",
    g2d: 136,
    dx9: 10,
    dx10: 3,
    dx11: 10,
    dx12: 4,
    overallSpeed: 540,
  },
  {
    id: 1876,
    name: "Radeon R7 M270",
    g2d: 202,
    dx9: 15,
    dx10: 5,
    dx11: 12,
    dx12: 3,
    overallSpeed: 746,
  },
  {
    id: 1877,
    name: "Radeon R7 M270DX",
    g2d: 233,
    dx9: 15,
    dx10: 5,
    dx11: 17,
    dx12: 6,
    overallSpeed: 962,
  },
  {
    id: 1878,
    name: "Radeon R7 M340",
    g2d: 148,
    dx9: 10,
    dx10: 3,
    dx11: 14,
    dx12: 5,
    overallSpeed: 646,
  },
  {
    id: 1879,
    name: "Radeon R7 M350",
    g2d: 252,
    dx9: 21,
    dx10: 8,
    dx11: 17,
    dx12: 4,
    overallSpeed: 1065,
  },
  {
    id: 1880,
    name: "Radeon R7 M360",
    g2d: 153,
    dx9: 10,
    dx10: 2,
    dx11: 14,
    dx12: 4,
    overallSpeed: 559,
  },
  {
    id: 1881,
    name: "Radeon R7 M365X",
    g2d: 265,
    dx9: 18,
    dx10: 6,
    dx11: 16,
    dx12: 4,
    overallSpeed: 902,
  },
  {
    id: 1883,
    name: "Radeon R7 M380",
    g2d: 534,
    dx9: 34,
    dx10: 14,
    dx11: 30,
    dx12: 10,
    overallSpeed: 1669,
  },
  {
    id: 1884,
    name: "Radeon R7 M440",
    g2d: 188,
    dx9: 14,
    dx10: 6,
    dx11: 17,
    dx12: 5,
    overallSpeed: 870,
  },
  {
    id: 1885,
    name: "Radeon R7 M445",
    g2d: 190,
    price: 744,
    dx9: 16,
    dx10: 6,
    dx11: 17,
    dx12: 4,
    overallSpeed: 911,
    pricePerG3D: 1.22,
  },
  {
    id: 1886,
    name: "Radeon R7 M460",
    g2d: 239,
    dx9: 20,
    dx10: 7,
    dx11: 20,
    dx12: 5,
    overallSpeed: 1047,
  },
  {
    id: 1888,
    name: "Radeon R7 M465X",
    g2d: 472,
    dx9: 39,
    dx10: 13,
    dx11: 24,
    dx12: 5,
    overallSpeed: 1598,
  },
  {
    id: 1890,
    name: "Radeon R7 PRO A10-8750B",
    g2d: 230,
    dx9: 13,
    dx10: 5,
    dx11: 14,
    dx12: 5,
    overallSpeed: 817,
  },
  {
    id: 1891,
    name: "Radeon R7 PRO A10-8770",
    g2d: 273,
    dx9: 14,
    dx10: 5,
    dx11: 17,
    dx12: 7,
    overallSpeed: 955,
  },
  {
    id: 1892,
    name: "Radeon R7 PRO A10-8770E",
    g2d: 247,
    dx9: 14,
    dx10: 5,
    dx11: 17,
    dx12: 5,
    overallSpeed: 887,
  },
  {
    id: 1894,
    name: "Radeon R7 PRO A10-9700",
    g2d: 233,
    dx9: 12,
    dx10: 4,
    dx11: 15,
    dx12: 6,
    overallSpeed: 899,
  },
  {
    id: 1895,
    name: "Radeon R7 PRO A10-9700B",
    g2d: 259,
    dx9: 6,
    dx10: 2,
    dx11: 10,
    dx12: 4,
    overallSpeed: 758,
  },
  {
    id: 1896,
    name: "Radeon R7 PRO A10-9700E",
    g2d: 241,
    price: 529,
    dx9: 15,
    dx10: 6,
    dx11: 18,
    dx12: 5,
    overallSpeed: 936,
    pricePerG3D: 1.77,
  },
  {
    id: 1897,
    name: "Radeon R7 PRO A12-8800B",
    g2d: 247,
    dx9: 12,
    dx10: 4,
    dx11: 15,
    dx12: 6,
    overallSpeed: 798,
  },
  {
    id: 1900,
    name: "Radeon R7 PRO A12-8870E",
    g2d: 367,
    dx9: 16,
    dx10: 6,
    dx11: 21,
    dx12: 8,
    overallSpeed: 1127,
  },
  {
    id: 1901,
    name: "Radeon R7 PRO A12-9800",
    g2d: 334,
    dx9: 14,
    dx10: 6,
    dx11: 18,
    dx12: 8,
    overallSpeed: 1117,
  },
  {
    id: 1902,
    name: "Radeon R7 PRO A12-9800B",
    g2d: 219,
    dx9: 12,
    dx10: 5,
    dx11: 14,
    dx12: 5,
    overallSpeed: 779,
  },
  {
    id: 1903,
    name: "Radeon R7 PRO A12-9800E",
    g2d: 266,
    dx9: 14,
    dx10: 5,
    dx11: 18,
    dx12: 8,
    overallSpeed: 989,
  },
  {
    id: 1905,
    name: "Radeon R7 PRO A8-8650B",
    g2d: 213,
    dx9: 11,
    dx10: 4,
    dx11: 13,
    dx12: 5,
    overallSpeed: 693,
  },
  {
    id: 1910,
    name: "Radeon R8 M445DX",
    g2d: 167,
    dx9: 11,
    dx10: 5,
    dx11: 14,
    dx12: 5,
    overallSpeed: 784,
  },
  {
    id: 1911,
    name: "Radeon R8 M535DX",
    g2d: 183,
    dx9: 11,
    dx10: 5,
    dx11: 12,
    dx12: 4,
    overallSpeed: 699,
  },
  {
    id: 1912,
    name: "Radeon R9 255",
    g2d: 341,
    price: 344.16,
    dx9: 19,
    dx10: 7,
    dx11: 21,
    dx12: 7,
    overallSpeed: 1251,
    pricePerG3D: 3.64,
  },
  {
    id: 1914,
    name: "Radeon R9 270",
    g2d: 567,
    dx9: 74,
    dx10: 39,
    dx11: 67,
    dx12: 22,
    overallSpeed: 4306,
  },
  {
    id: 1916,
    name: "Radeon R9 270X",
    g2d: 600,
    price: 330,
    dx9: 83,
    dx10: 39,
    dx11: 76,
    dx12: 24,
    overallSpeed: 4895,
    pricePerG3D: 14.83,
  },
  {
    id: 1917,
    name: "Radeon R9 280",
    g2d: 654,
    dx9: 85,
    dx10: 58,
    dx11: 78,
    dx12: 26,
    overallSpeed: 5603,
  },
  {
    id: 1918,
    name: "Radeon R9 280X",
    g2d: 678,
    dx9: 93,
    dx10: 63,
    dx11: 89,
    dx12: 30,
    overallSpeed: 6249,
  },
  {
    id: 1919,
    name: "Radeon R9 285",
    g2d: 597,
    dx9: 99,
    dx10: 60,
    dx11: 108,
    dx12: 38,
    overallSpeed: 6680,
  },
  {
    id: 1921,
    name: "Radeon R9 290",
    g2d: 774,
    dx9: 127,
    dx10: 92,
    dx11: 136,
    dx12: 39,
    overallSpeed: 8422,
  },
  {
    id: 1922,
    name: "Radeon R9 290 / 390",
    g2d: 695,
    price: 489,
    dx9: 127,
    dx10: 88,
    dx11: 134,
    dx12: 36,
    overallSpeed: 8150,
    pricePerG3D: 16.67,
  },
  {
    id: 1923,
    name: "Radeon R9 290X",
    g2d: 782,
    dx9: 130,
    dx10: 95,
    dx11: 142,
    dx12: 39,
    overallSpeed: 8758,
  },
  {
    id: 1924,
    name: "Radeon R9 290X / 390X",
    g2d: 699,
    price: 579,
    dx9: 127,
    dx10: 89,
    dx11: 138,
    dx12: 36,
    overallSpeed: 8389,
    pricePerG3D: 14.49,
  },
  {
    id: 1925,
    name: "Radeon R9 295X2",
    g2d: 706,
    price: 499.1,
    dx9: 117,
    dx10: 82,
    dx11: 189,
    dx12: 39,
    overallSpeed: 8168,
    pricePerG3D: 16.37,
  },
  {
    id: 1926,
    name: "Radeon R9 350",
    g2d: 514,
    price: 299,
    dx9: 37,
    dx10: 13,
    dx11: 32,
    dx12: 9,
    overallSpeed: 1964,
    pricePerG3D: 6.57,
  },
  {
    id: 1929,
    name: "Radeon R9 380",
    g2d: 664,
    price: 89.99,
    dx9: 94,
    dx10: 57,
    dx11: 102,
    dx12: 32,
    overallSpeed: 6232,
    pricePerG3D: 69.25,
  },
  {
    id: 1930,
    name: "Radeon R9 380X",
    g2d: 670,
    price: 519,
    dx9: 91,
    dx10: 57,
    dx11: 107,
    dx12: 32,
    overallSpeed: 6094,
    pricePerG3D: 11.74,
  },
  {
    id: 1931,
    name: "Radeon R9 390",
    g2d: 798,
    dx9: 137,
    dx10: 101,
    dx11: 145,
    dx12: 40,
    overallSpeed: 8969,
  },
  {
    id: 1932,
    name: "Radeon R9 390X",
    g2d: 846,
    dx9: 145,
    dx10: 106,
    dx11: 150,
    dx12: 42,
    overallSpeed: 9523,
  },
  {
    id: 1933,
    name: "Radeon R9 A375",
    g2d: 232,
    dx9: 24,
    dx10: 7,
    dx11: 20,
    dx12: 4,
    overallSpeed: 1024,
  },
  {
    id: 1934,
    name: "Radeon R9 Fury",
    g2d: 794,
    price: 443.1,
    dx9: 136,
    dx10: 118,
    dx11: 147,
    dx12: 42,
    overallSpeed: 9674,
    pricePerG3D: 21.83,
  },
  {
    id: 1935,
    name: "Radeon R9 Fury Fury X",
    g2d: 811,
    price: 479.99,
    dx9: 135,
    dx10: 115,
    dx11: 149,
    dx12: 48,
    overallSpeed: 9741,
    pricePerG3D: 20.29,
  },
  {
    id: 1936,
    name: "Radeon R9 Fury X",
    g2d: 861,
    dx9: 133,
    dx10: 118,
    dx11: 161,
    dx12: 47,
    overallSpeed: 10045,
  },
  {
    id: 1937,
    name: "Radeon R9 M265X",
    g2d: 204,
    dx9: 24,
    dx10: 11,
    dx11: 11,
    dx12: 4,
    overallSpeed: 947,
  },
  {
    id: 1938,
    name: "Radeon R9 M270X",
    g2d: 306,
    dx9: 16,
    dx10: 6,
    dx11: 10,
    dx12: 9,
    overallSpeed: 1204,
  },
  {
    id: 1940,
    name: "Radeon R9 M275X",
    g2d: 345,
    dx9: 32,
    dx10: 12,
    dx11: 31,
    dx12: 10,
    overallSpeed: 1802,
  },
  {
    id: 1941,
    name: "Radeon R9 M275X / M375",
    g2d: 467,
    dx9: 32,
    dx10: 11,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1575,
  },
  {
    id: 1942,
    name: "Radeon R9 M280X",
    g2d: 272,
    dx9: 12,
    dx10: 4,
    dx11: 12,
    dx12: 5,
    overallSpeed: 922,
  },
  {
    id: 1943,
    name: "Radeon R9 M290X",
    g2d: 452,
    dx9: 70,
    dx10: 30,
    dx11: 59,
    dx12: 15,
    overallSpeed: 3320,
  },
  {
    id: 1945,
    name: "Radeon R9 M360",
    g2d: 484,
    dx9: 39,
    dx10: 13,
    dx11: 29,
    dx12: 8,
    overallSpeed: 1796,
  },
  {
    id: 1947,
    name: "Radeon R9 M370X",
    g2d: 342,
    price: 889,
    dx9: 31,
    dx10: 13,
    dx11: 20,
    dx12: 6,
    overallSpeed: 1372,
    pricePerG3D: 1.54,
  },
  {
    id: 1948,
    name: "Radeon R9 M375",
    g2d: 188,
    dx9: 18,
    dx10: 6,
    dx11: 10,
    dx12: 3,
    overallSpeed: 773,
  },
  {
    id: 1949,
    name: "Radeon R9 M375X",
    g2d: 403,
    dx9: 39,
    dx10: 15,
    dx11: 27,
    dx12: 9,
    overallSpeed: 1835,
  },
  {
    id: 1950,
    name: "Radeon R9 M380",
    g2d: 629,
    dx9: 60,
    dx10: 21,
    dx11: 55,
    dx12: 11,
    overallSpeed: 2947,
  },
  {
    id: 1951,
    name: "Radeon R9 M385",
    g2d: 223,
    dx9: 34,
    dx10: 14,
    dx11: 36,
    dx12: 7,
    overallSpeed: 1827,
  },
  {
    id: 1952,
    name: "Radeon R9 M385X",
    g2d: 285,
    dx9: 46,
    dx10: 19,
    dx11: 48,
    dx12: 7,
    overallSpeed: 1929,
  },
  {
    id: 1954,
    name: "Radeon R9 M395",
    g2d: 717,
    dx9: 87,
    dx10: 49,
    dx11: 87,
    dx12: 19,
    overallSpeed: 5023,
  },
  {
    id: 1955,
    name: "Radeon R9 M395X",
    g2d: 762,
    dx9: 72,
    dx10: 41,
    dx11: 75,
    dx12: 20,
    overallSpeed: 4775,
  },
  {
    id: 1956,
    name: "Radeon R9 M470",
    g2d: 445,
    dx9: 49,
    dx10: 16,
    dx11: 24,
    dx12: 6,
    overallSpeed: 2023,
  },
  {
    id: 1957,
    name: "Radeon R9 M470X",
    g2d: 552,
    dx9: 56,
    dx10: 18,
    dx11: 56,
    dx12: 24,
    overallSpeed: 3400,
  },
  {
    id: 1959,
    name: "Radeon RX 460",
    g2d: 566,
    price: 592,
    dx9: 61,
    dx10: 35,
    dx11: 69,
    dx12: 22,
    overallSpeed: 4095,
    pricePerG3D: 6.92,
  },
  {
    id: 1960,
    name: "Radeon RX 470/570",
    g2d: 721,
    price: 399.99,
    dx9: 116,
    dx10: 81,
    dx11: 138,
    dx12: 38,
    overallSpeed: 8022,
    pricePerG3D: 20.06,
  },
  {
    id: 1961,
    name: "Radeon RX 480",
    g2d: 779,
    price: 469,
    dx9: 121,
    dx10: 85,
    dx11: 146,
    dx12: 42,
    overallSpeed: 8649,
    pricePerG3D: 18.44,
  },
  {
    id: 1962,
    name: "Radeon RX 5300",
    g2d: 831,
    dx9: 85,
    dx10: 67,
    dx11: 133,
    dx12: 32,
    overallSpeed: 7350,
  },
  {
    id: 1963,
    name: "Radeon RX 5300M",
    g2d: 321,
    dx9: 77,
    dx10: 58,
    dx11: 41,
    dx12: 14,
    overallSpeed: 3357,
  },
  {
    id: 1964,
    name: "Radeon RX 540",
    g2d: 433,
    dx9: 33,
    dx10: 9,
    dx11: 38,
    dx12: 11,
    overallSpeed: 1844,
  },
  {
    id: 1965,
    name: "Radeon RX 550",
    g2d: 488,
    price: 156.6,
    dx9: 51,
    dx10: 21,
    dx11: 52,
    dx12: 13,
    overallSpeed: 2754,
    pricePerG3D: 17.59,
  },
  {
    id: 1966,
    name: "Radeon RX 5500",
    g2d: 887,
    dx9: 110,
    dx10: 90,
    dx11: 150,
    dx12: 39,
    overallSpeed: 8796,
  },
  {
    id: 1967,
    name: "Radeon RX 5500 XT",
    g2d: 821,
    price: 178.38,
    dx9: 124,
    dx10: 88,
    dx11: 147,
    dx12: 41,
    overallSpeed: 9144,
    pricePerG3D: 51.26,
  },
  {
    id: 1968,
    name: "Radeon RX 5500M",
    g2d: 403,
    dx9: 93,
    dx10: 75,
    dx11: 52,
    dx12: 16,
    overallSpeed: 3927,
  },
  {
    id: 1969,
    name: "Radeon RX 550X",
    g2d: 493,
    dx9: 46,
    dx10: 17,
    dx11: 43,
    dx12: 11,
    overallSpeed: 2242,
  },
  {
    id: 1970,
    name: "Radeon RX 560",
    g2d: 504,
    price: 235.38,
    dx9: 57,
    dx10: 32,
    dx11: 59,
    dx12: 20,
    overallSpeed: 3620,
    pricePerG3D: 15.38,
  },
  {
    id: 1971,
    name: "Radeon RX 5600",
    g2d: 917,
    dx9: 148,
    dx10: 122,
    dx11: 206,
    dx12: 44,
    overallSpeed: 10879,
  },
  {
    id: 1972,
    name: "Radeon RX 5600 XT",
    g2d: 913,
    price: 749.99,
    dx9: 192,
    dx10: 150,
    dx11: 247,
    dx12: 54,
    overallSpeed: 13778,
    pricePerG3D: 18.37,
  },
  {
    id: 1973,
    name: "Radeon RX 5600M",
    g2d: 568,
    dx9: 129,
    dx10: 117,
    dx11: 141,
    dx12: 32,
    overallSpeed: 7619,
  },
  {
    id: 1974,
    name: "Radeon RX 560X",
    g2d: 537,
    dx9: 68,
    dx10: 38,
    dx11: 76,
    dx12: 29,
    overallSpeed: 4124,
  },
  {
    id: 1975,
    name: "Radeon RX 5700",
    g2d: 926,
    price: 309.99,
    dx9: 193,
    dx10: 187,
    dx11: 269,
    dx12: 56,
    overallSpeed: 14726,
    pricePerG3D: 47.51,
  },
  {
    id: 1976,
    name: "Radeon RX 5700 XT",
    g2d: 954,
    price: 1124,
    dx9: 209,
    dx10: 207,
    dx11: 304,
    dx12: 69,
    overallSpeed: 16840,
    pricePerG3D: 14.98,
  },
  {
    id: 1977,
    name: "Radeon RX 5700 XT 50th Anniversary",
    g2d: 975,
    dx9: 207,
    dx10: 209,
    dx11: 300,
    dx12: 67,
    overallSpeed: 16675,
  },
  {
    id: 1979,
    name: "Radeon RX 580",
    g2d: 766,
    price: 512.24,
    dx9: 125,
    dx10: 88,
    dx11: 152,
    dx12: 42,
    overallSpeed: 8868,
    pricePerG3D: 17.31,
  },
  {
    id: 1980,
    name: "Radeon RX 580 2048SP",
    g2d: 662,
    dx9: 112,
    dx10: 81,
    dx11: 139,
    dx12: 37,
    overallSpeed: 7825,
  },
  {
    id: 1982,
    name: "Radeon RX 590",
    g2d: 806,
    price: 835.97,
    dx9: 130,
    dx10: 94,
    dx11: 167,
    dx12: 47,
    overallSpeed: 9618,
    pricePerG3D: 11.5,
  },
  {
    id: 1983,
    name: "Radeon RX 640",
    g2d: 251,
    dx9: 32,
    dx10: 10,
    dx11: 24,
    dx12: 7,
    overallSpeed: 1415,
  },
  {
    id: 1984,
    name: "Radeon RX 6600 XT",
    g2d: 1021,
    price: 769.99,
    dx9: 138,
    dx10: 235,
    dx11: 401,
    dx12: 63,
    overallSpeed: 15454,
    pricePerG3D: 20.07,
  },
  {
    id: 1985,
    name: "Radeon RX 6700 XT",
    g2d: 1027,
    price: 833.12,
    dx9: 190,
    dx10: 266,
    dx11: 443,
    dx12: 79,
    overallSpeed: 19054,
    pricePerG3D: 22.87,
  },
  {
    id: 1986,
    name: "Radeon RX 6800",
    g2d: 1042,
    price: 1449,
    dx9: 189,
    dx10: 277,
    dx11: 506,
    dx12: 93,
    overallSpeed: 20741,
    pricePerG3D: 14.31,
  },
  {
    id: 1987,
    name: "Radeon RX 6800 XT",
    g2d: 1092,
    price: 1413.79,
    dx9: 207,
    dx10: 341,
    dx11: 563,
    dx12: 102,
    overallSpeed: 23290,
    pricePerG3D: 16.47,
  },
  {
    id: 1988,
    name: "Radeon RX 6800M",
    g2d: 704,
    dx9: 125,
    dx10: 205,
    dx11: 195,
    dx12: 39,
    overallSpeed: 8295,
  },
  {
    id: 1989,
    name: "Radeon RX 6900 XT",
    g2d: 1149,
    price: 1799.99,
    dx9: 231,
    dx10: 367,
    dx11: 614,
    dx12: 133,
    overallSpeed: 26949,
    pricePerG3D: 14.97,
  },
  {
    id: 1990,
    name: "Radeon RX Vega 10",
    g2d: 389,
    dx9: 26,
    dx10: 14,
    dx11: 29,
    dx12: 9,
    overallSpeed: 1732,
  },
  {
    id: 1991,
    name: "Radeon RX Vega 11",
    g2d: 536,
    price: 1002,
    dx9: 30,
    dx10: 15,
    dx11: 33,
    dx12: 12,
    overallSpeed: 2138,
    pricePerG3D: 2.13,
  },
  {
    id: 1993,
    name: "Radeon RX Vega 11 Processor",
    g2d: 498,
    dx9: 27,
    dx10: 12,
    dx11: 29,
    dx12: 10,
    overallSpeed: 1843,
  },
  {
    id: 1994,
    name: "Radeon RX Vega 56",
    g2d: 781,
    price: 1059,
    dx9: 184,
    dx10: 168,
    dx11: 218,
    dx12: 60,
    overallSpeed: 13616,
    pricePerG3D: 12.86,
  },
  {
    id: 1995,
    name: "Radeon RX Vega 64",
    g2d: 808,
    price: 1249.1,
    dx9: 190,
    dx10: 177,
    dx11: 231,
    dx12: 70,
    overallSpeed: 14625,
    pricePerG3D: 11.71,
  },
  {
    id: 1996,
    name: "Radeon RX Vega 8",
    g2d: 379,
    dx9: 24,
    dx10: 11,
    dx11: 27,
    dx12: 7,
    overallSpeed: 1586,
  },
  {
    id: 1997,
    name: "Radeon RX Vega M GH",
    g2d: 841,
    dx9: 107,
    dx10: 61,
    dx11: 119,
    dx12: 33,
    overallSpeed: 6760,
  },
  {
    id: 1998,
    name: "Radeon RX Vega M GL",
    g2d: 522,
    dx9: 68,
    dx10: 44,
    dx11: 57,
    dx12: 15,
    overallSpeed: 3420,
  },
  {
    id: 1999,
    name: "Radeon RX Vega11",
    g2d: 436,
    dx9: 25,
    dx10: 12,
    dx11: 27,
    dx12: 8,
    overallSpeed: 1689,
  },
  {
    id: 2000,
    name: "Radeon RX590 GME",
    g2d: 704,
    dx9: 115,
    dx10: 89,
    dx11: 158,
    dx12: 37,
    overallSpeed: 8628,
  },
  {
    id: 2001,
    name: "Radeon Ryzen 3 4300G",
    g2d: 577,
    dx9: 21,
    dx10: 9,
    dx11: 24,
    dx12: 9,
    overallSpeed: 1435,
  },
  {
    id: 2002,
    name: "Radeon Ryzen 3 4300GE",
    g2d: 682,
    dx9: 37,
    dx10: 18,
    dx11: 38,
    dx12: 10,
    overallSpeed: 2322,
  },
  {
    id: 2003,
    name: "Radeon Ryzen 3 4300U",
    g2d: 594,
    dx9: 24,
    dx10: 12,
    dx11: 30,
    dx12: 7,
    overallSpeed: 1593,
  },
  {
    id: 2004,
    name: "Radeon Ryzen 3 PRO 4350G",
    g2d: 659,
    dx9: 35,
    dx10: 17,
    dx11: 37,
    dx12: 10,
    overallSpeed: 2228,
  },
  {
    id: 2005,
    name: "Radeon Ryzen 3 PRO 4350GE",
    g2d: 660,
    dx9: 27,
    dx10: 13,
    dx11: 29,
    dx12: 9,
    overallSpeed: 1792,
  },
  {
    id: 2006,
    name: "Radeon Ryzen 3 PRO 4450U",
    g2d: 533,
    dx9: 21,
    dx10: 10,
    dx11: 26,
    dx12: 7,
    overallSpeed: 1409,
  },
  {
    id: 2007,
    name: "Radeon Ryzen 5 4500U",
    g2d: 555,
    dx9: 28,
    dx10: 13,
    dx11: 30,
    dx12: 8,
    overallSpeed: 1802,
  },
  {
    id: 2008,
    name: "Radeon Ryzen 5 4600G",
    g2d: 670,
    dx9: 35,
    dx10: 18,
    dx11: 40,
    dx12: 11,
    overallSpeed: 2394,
  },
  {
    id: 2009,
    name: "Radeon Ryzen 5 4600H",
    g2d: 548,
    dx9: 53,
    dx10: 34,
    dx11: 62,
    dx12: 13,
    overallSpeed: 3355,
  },
  {
    id: 2010,
    name: "Radeon Ryzen 5 4600HS",
    g2d: 447,
    dx9: 122,
    dx10: 80,
    dx11: 153,
    dx12: 30,
    overallSpeed: 7942,
  },
  {
    id: 2011,
    name: "Radeon Ryzen 5 4600U",
    g2d: 521,
    dx9: 29,
    dx10: 13,
    dx11: 31,
    dx12: 9,
    overallSpeed: 1825,
  },
  {
    id: 2012,
    name: "Radeon Ryzen 5 Microsoft Surface Edition",
    g2d: 512,
    dx9: 31,
    dx10: 17,
    dx11: 34,
    dx12: 9,
    overallSpeed: 2028,
  },
  {
    id: 2013,
    name: "Radeon Ryzen 5 PRO 4650G",
    g2d: 712,
    dx9: 37,
    dx10: 18,
    dx11: 40,
    dx12: 11,
    overallSpeed: 2439,
  },
  {
    id: 2014,
    name: "Radeon Ryzen 5 PRO 4650GE",
    g2d: 639,
    dx9: 25,
    dx10: 12,
    dx11: 29,
    dx12: 10,
    overallSpeed: 1760,
  },
  {
    id: 2015,
    name: "Radeon Ryzen 5 PRO 4650U",
    g2d: 553,
    dx9: 28,
    dx10: 13,
    dx11: 30,
    dx12: 8,
    overallSpeed: 1783,
  },
  {
    id: 2016,
    name: "Radeon Ryzen 7 4700G",
    g2d: 699,
    dx9: 35,
    dx10: 17,
    dx11: 38,
    dx12: 11,
    overallSpeed: 2307,
  },
  {
    id: 2017,
    name: "Radeon Ryzen 7 4700GE",
    g2d: 787,
    dx9: 43,
    dx10: 22,
    dx11: 45,
    dx12: 9,
    overallSpeed: 2662,
  },
  {
    id: 2018,
    name: "Radeon Ryzen 7 4700U",
    g2d: 568,
    dx9: 31,
    dx10: 16,
    dx11: 34,
    dx12: 10,
    overallSpeed: 2055,
  },
  {
    id: 2019,
    name: "Radeon Ryzen 7 4800H",
    g2d: 462,
    dx9: 94,
    dx10: 85,
    dx11: 124,
    dx12: 27,
    overallSpeed: 6638,
  },
  {
    id: 2020,
    name: "Radeon Ryzen 7 4800HS",
    g2d: 426,
    dx9: 127,
    dx10: 114,
    dx11: 165,
    dx12: 35,
    overallSpeed: 8842,
  },
  {
    id: 2021,
    name: "Radeon Ryzen 7 4800U",
    g2d: 609,
    dx9: 33,
    dx10: 17,
    dx11: 37,
    dx12: 11,
    overallSpeed: 2275,
  },
  {
    id: 2022,
    name: "Radeon Ryzen 7 Microsoft Surface Edition",
    g2d: 588,
    dx9: 33,
    dx10: 19,
    dx11: 39,
    dx12: 11,
    overallSpeed: 2349,
  },
  {
    id: 2023,
    name: "Radeon Ryzen 7 PRO 4750G",
    g2d: 703,
    dx9: 39,
    dx10: 19,
    dx11: 42,
    dx12: 13,
    overallSpeed: 2624,
  },
  {
    id: 2024,
    name: "Radeon Ryzen 7 PRO 4750GE",
    g2d: 651,
    dx9: 30,
    dx10: 14,
    dx11: 32,
    dx12: 10,
    overallSpeed: 2020,
  },
  {
    id: 2025,
    name: "Radeon Ryzen 7 PRO 4750U",
    g2d: 568,
    dx9: 31,
    dx10: 15,
    dx11: 33,
    dx12: 10,
    overallSpeed: 2015,
  },
  {
    id: 2026,
    name: "Radeon Ryzen 9 4900HS",
    g2d: 378,
    dx9: 115,
    dx10: 123,
    dx11: 134,
    dx12: 43,
    overallSpeed: 8572,
  },
  {
    id: 2027,
    name: "Radeon Ryzen 9 4900HSS",
    g2d: 417,
    dx9: 134,
    dx10: 154,
    dx11: 157,
    dx12: 31,
    overallSpeed: 9461,
  },
  {
    id: 2028,
    name: "Radeon Ryzen Embedded V2718",
    g2d: 580,
    dx9: 34,
    dx10: 19,
    dx11: 33,
    dx12: 10,
    overallSpeed: 2190,
  },
  {
    id: 2029,
    name: "Radeon Ryzen Embedded V2748",
    g2d: 503,
    dx9: 19,
    dx10: 8,
    dx11: 20,
    dx12: 8,
    overallSpeed: 1296,
  },
  {
    id: 2030,
    name: "Radeon Sky 500",
    g2d: 551,
    dx9: 77,
    dx10: 38,
    dx11: 72,
    dx12: 24,
    overallSpeed: 4736,
  },
  {
    id: 2031,
    name: "Radeon TM R9 A360",
    g2d: 718,
    dx9: 42,
    dx10: 13,
    dx11: 37,
    dx12: 10,
    overallSpeed: 2105,
  },
  {
    id: 2033,
    name: "Radeon Vega 10",
    g2d: 392,
    dx9: 24,
    dx10: 11,
    dx11: 25,
    dx12: 8,
    overallSpeed: 1548,
  },
  {
    id: 2034,
    name: "Radeon Vega 10 Mobile",
    g2d: 332,
    dx9: 22,
    dx10: 11,
    dx11: 23,
    dx12: 8,
    overallSpeed: 1471,
  },
  {
    id: 2035,
    name: "Radeon Vega 11",
    g2d: 515,
    dx9: 27,
    dx10: 13,
    dx11: 29,
    dx12: 10,
    overallSpeed: 1845,
  },
  {
    id: 2036,
    name: "Radeon Vega 2",
    g2d: 240,
    dx9: 11,
    dx10: 3,
    dx11: 12,
    dx12: 1,
    overallSpeed: 455,
  },
  {
    id: 2037,
    name: "Radeon Vega 3",
    g2d: 325,
    price: 2624.43,
    dx9: 17,
    dx10: 6,
    dx11: 19,
    dx12: 4,
    overallSpeed: 900,
    pricePerG3D: 0.34,
  },
  {
    id: 2038,
    name: "Radeon Vega 3 Mobile",
    g2d: 307,
    dx9: 16,
    dx10: 10,
    dx11: 20,
    dx12: 4,
    overallSpeed: 1071,
  },
  {
    id: 2039,
    name: "Radeon Vega 6",
    g2d: 343,
    price: 1799.99,
    dx9: 19,
    dx10: 10,
    dx11: 21,
    dx12: 6,
    overallSpeed: 1279,
    pricePerG3D: 0.71,
  },
  {
    id: 2040,
    name: "Radeon Vega 8",
    g2d: 450,
    price: 126.86,
    dx9: 26,
    dx10: 13,
    dx11: 28,
    dx12: 8,
    overallSpeed: 1699,
    pricePerG3D: 13.39,
  },
  {
    id: 2041,
    name: "Radeon Vega 8 Mobile",
    g2d: 352,
    dx9: 22,
    dx10: 11,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1452,
  },
  {
    id: 2042,
    name: "Radeon Vega 9",
    g2d: 441,
    dx9: 26,
    dx10: 12,
    dx11: 29,
    dx12: 8,
    overallSpeed: 1662,
  },
  {
    id: 2043,
    name: "Radeon Vega Frontier Edition",
    g2d: 756,
    price: 1680,
    dx9: 180,
    dx10: 169,
    dx11: 225,
    dx12: 64,
    overallSpeed: 13929,
    pricePerG3D: 8.29,
  },
  {
    id: 2044,
    name: "Radeon VII",
    g2d: 791,
    price: 2699.99,
    dx9: 213,
    dx10: 216,
    dx11: 278,
    dx12: 81,
    overallSpeed: 16999,
    pricePerG3D: 6.3,
  },
  {
    id: 2098,
    name: "RadeonT 540X",
    g2d: 436,
    dx9: 34,
    dx10: 9,
    dx11: 39,
    dx12: 12,
    overallSpeed: 1802,
  },
  {
    id: 2099,
    name: "RadeonT R5 430",
    g2d: 579,
    dx9: 19,
    dx10: 6,
    dx11: 17,
    dx12: 5,
    overallSpeed: 1012,
  },
  {
    id: 2101,
    name: "RadeonT RX 5300",
    g2d: 809,
    dx9: 92,
    dx10: 64,
    dx11: 129,
    dx12: 37,
    overallSpeed: 7321,
  },
  {
    id: 2102,
    name: "RadeonT RX 5500M",
    g2d: 336,
    dx9: 85,
    dx10: 78,
    dx11: 17,
    dx12: 7,
    overallSpeed: 3166,
  },
  {
    id: 2104,
    name: "RadeonT RX 640",
    g2d: 281,
    dx9: 25,
    dx10: 8,
    dx11: 21,
    dx12: 7,
    overallSpeed: 1363,
  },
  {
    id: 2105,
    name: "RadeonT Vega 3",
    g2d: 391,
    dx9: 13,
    dx10: 6,
    dx11: 14,
    dx12: 3,
    overallSpeed: 775,
  },
  {
    id: 2113,
    name: "RTX A2000 Laptop GPU",
    g2d: 577,
    dx9: 131,
    dx10: 139,
    dx11: 219,
    dx12: 52,
    overallSpeed: 11795,
  },
  {
    id: 2114,
    name: "RTX A3000 Laptop GPU",
    g2d: 429,
    dx9: 158,
    dx10: 190,
    dx11: 295,
    dx12: 61,
    overallSpeed: 14577,
  },
  {
    id: 2115,
    name: "RTX A4000",
    g2d: 960,
    price: 1272,
    dx9: 232,
    dx10: 287,
    dx11: 378,
    dx12: 74,
    overallSpeed: 20528,
    pricePerG3D: 16.14,
  },
  {
    id: 2116,
    name: "RTX A4000 Laptop GPU",
    g2d: 709,
    dx9: 174,
    dx10: 223,
    dx11: 300,
    dx12: 66,
    overallSpeed: 15202,
  },
  {
    id: 2117,
    name: "RTX A5000",
    g2d: 910,
    dx9: 241,
    dx10: 334,
    dx11: 416,
    dx12: 111,
    overallSpeed: 24277,
  },
  {
    id: 2118,
    name: "RTX A5000 Laptop GPU",
    g2d: 809,
    dx9: 195,
    dx10: 289,
    dx11: 410,
    dx12: 91,
    overallSpeed: 20142,
  },
  {
    id: 2119,
    name: "RTX A6000",
    g2d: 842,
    price: 4999,
    dx9: 218,
    dx10: 337,
    dx11: 454,
    dx12: 103,
    overallSpeed: 23382,
    pricePerG3D: 4.68,
  },
  {
    id: 2121,
    name: "Ryzen 3 4300G with Radeon Graphics",
    g2d: 650,
    dx9: 30,
    dx10: 12,
    dx11: 33,
    dx12: 9,
    overallSpeed: 1903,
  },
  {
    id: 2122,
    name: "Ryzen 3 4300GE with Radeon Graphics",
    g2d: 687,
    dx9: 40,
    dx10: 16,
    dx11: 43,
    dx12: 11,
    overallSpeed: 2402,
  },
  {
    id: 2123,
    name: "Ryzen 3 4300U with Radeon Graphics",
    g2d: 493,
    dx9: 21,
    dx10: 9,
    dx11: 25,
    dx12: 7,
    overallSpeed: 1354,
  },
  {
    id: 2124,
    name: "Ryzen 3 5400U with Radeon Graphics",
    g2d: 662,
    dx9: 24,
    dx10: 12,
    dx11: 30,
    dx12: 9,
    overallSpeed: 1719,
  },
  {
    id: 2125,
    name: "Ryzen 3 PRO 4200G with Radeon Graphics",
    g2d: 705,
    dx9: 31,
    dx10: 14,
    dx11: 33,
    dx12: 6,
    overallSpeed: 1799,
  },
  {
    id: 2126,
    name: "Ryzen 3 PRO 4200GE with Radeon Graphics",
    g2d: 587,
    dx9: 28,
    dx10: 12,
    dx11: 29,
    dx12: 9,
    overallSpeed: 1784,
  },
  {
    id: 2127,
    name: "Ryzen 3 PRO 4300U with Radeon Graphics",
    g2d: 539,
    dx9: 24,
    dx10: 11,
    dx11: 29,
    dx12: 7,
    overallSpeed: 1543,
  },
  {
    id: 2128,
    name: "Ryzen 3 Pro 4350G with Radeon Graphics",
    g2d: 663,
    dx9: 35,
    dx10: 17,
    dx11: 37,
    dx12: 9,
    overallSpeed: 2190,
  },
  {
    id: 2129,
    name: "Ryzen 3 PRO 4350GE with Radeon Graphics",
    g2d: 700,
    dx9: 36,
    dx10: 15,
    dx11: 39,
    dx12: 10,
    overallSpeed: 2210,
  },
  {
    id: 2130,
    name: "Ryzen 3 PRO 4450U with Radeon Graphics",
    g2d: 562,
    dx9: 23,
    dx10: 11,
    dx11: 29,
    dx12: 7,
    overallSpeed: 1538,
  },
  {
    id: 2132,
    name: "Ryzen 5 4500U with Radeon Graphics",
    g2d: 540,
    dx9: 29,
    dx10: 14,
    dx11: 31,
    dx12: 8,
    overallSpeed: 1819,
  },
  {
    id: 2133,
    name: "Ryzen 5 4600G with Radeon Graphics",
    g2d: 679,
    dx9: 30,
    dx10: 14,
    dx11: 34,
    dx12: 10,
    overallSpeed: 2062,
  },
  {
    id: 2134,
    name: "Ryzen 5 4600H with Radeon Graphics",
    g2d: 573,
    dx9: 32,
    dx10: 15,
    dx11: 33,
    dx12: 8,
    overallSpeed: 1937,
  },
  {
    id: 2135,
    name: "Ryzen 5 4600U with Radeon Graphics",
    g2d: 577,
    dx9: 32,
    dx10: 15,
    dx11: 33,
    dx12: 9,
    overallSpeed: 1951,
  },
  {
    id: 2136,
    name: "Ryzen 5 5600G with Radeon Graphics",
    g2d: 956,
    dx9: 45,
    dx10: 22,
    dx11: 49,
    dx12: 13,
    overallSpeed: 2925,
  },
  {
    id: 2137,
    name: "Ryzen 5 5600U with Radeon Graphics",
    g2d: 629,
    dx9: 24,
    dx10: 12,
    dx11: 26,
    dx12: 9,
    overallSpeed: 1641,
  },
  {
    id: 2138,
    name: "Ryzen 5 PRO 4400G with Radeon Graphics",
    g2d: 599,
    dx9: 31,
    dx10: 17,
    dx11: 35,
    dx12: 13,
    overallSpeed: 2306,
  },
  {
    id: 2139,
    name: "Ryzen 5 PRO 4400GE with Radeon Graphics",
    g2d: 563,
    dx9: 22,
    dx10: 8,
    dx11: 23,
    dx12: 9,
    overallSpeed: 1442,
  },
  {
    id: 2140,
    name: "Ryzen 5 PRO 4500U with Radeon Graphics",
    g2d: 564,
    dx9: 32,
    dx10: 15,
    dx11: 34,
    dx12: 9,
    overallSpeed: 2008,
  },
  {
    id: 2141,
    name: "Ryzen 5 Pro 4650G with Radeon Graphics",
    g2d: 675,
    dx9: 37,
    dx10: 18,
    dx11: 39,
    dx12: 11,
    overallSpeed: 2395,
  },
  {
    id: 2142,
    name: "Ryzen 5 PRO 4650GE with Radeon Graphics",
    g2d: 661,
    dx9: 31,
    dx10: 13,
    dx11: 33,
    dx12: 11,
    overallSpeed: 2034,
  },
  {
    id: 2143,
    name: "Ryzen 5 PRO 4650U with Radeon Graphics",
    g2d: 525,
    dx9: 27,
    dx10: 12,
    dx11: 29,
    dx12: 8,
    overallSpeed: 1690,
  },
  {
    id: 2144,
    name: "Ryzen 5 PRO 5650U with Radeon Graphics",
    g2d: 766,
    dx9: 33,
    dx10: 14,
    dx11: 39,
    dx12: 12,
    overallSpeed: 2232,
  },
  {
    id: 2146,
    name: "Ryzen 7 4700G with Radeon Graphics",
    g2d: 671,
    dx9: 32,
    dx10: 15,
    dx11: 34,
    dx12: 11,
    overallSpeed: 2187,
  },
  {
    id: 2147,
    name: "Ryzen 7 4700GE with Radeon Graphics",
    g2d: 761,
    dx9: 38,
    dx10: 15,
    dx11: 41,
    dx12: 14,
    overallSpeed: 2496,
  },
  {
    id: 2148,
    name: "Ryzen 7 4700U with Radeon Graphics",
    g2d: 552,
    dx9: 31,
    dx10: 15,
    dx11: 33,
    dx12: 10,
    overallSpeed: 2032,
  },
  {
    id: 2149,
    name: "Ryzen 7 4800H with Radeon Graphics",
    g2d: 585,
    dx9: 33,
    dx10: 16,
    dx11: 35,
    dx12: 10,
    overallSpeed: 2113,
  },
  {
    id: 2150,
    name: "Ryzen 7 4800HS with Radeon Graphics",
    g2d: 355,
    dx9: 112,
    dx10: 81,
    dx11: 151,
    dx12: 22,
    overallSpeed: 6999,
  },
  {
    id: 2151,
    name: "Ryzen 7 4800U with Radeon Graphics",
    g2d: 570,
    dx9: 35,
    dx10: 18,
    dx11: 38,
    dx12: 12,
    overallSpeed: 2344,
  },
  {
    id: 2152,
    name: "Ryzen 7 5700G with Radeon Graphics",
    g2d: 793,
    dx9: 31,
    dx10: 14,
    dx11: 32,
    dx12: 11,
    overallSpeed: 2064,
  },
  {
    id: 2153,
    name: "Ryzen 7 5800H with Radeon Graphics",
    g2d: 823,
    dx9: 35,
    dx10: 19,
    dx11: 42,
    dx12: 13,
    overallSpeed: 2595,
  },
  {
    id: 2154,
    name: "Ryzen 7 5800HS with Radeon Graphics",
    g2d: 522,
    dx9: 112,
    dx10: 69,
    dx11: 144,
    dx12: 37,
    overallSpeed: 7391,
  },
  {
    id: 2155,
    name: "Ryzen 7 5800U with Radeon Graphics",
    g2d: 760,
    dx9: 40,
    dx10: 18,
    dx11: 42,
    dx12: 13,
    overallSpeed: 2601,
  },
  {
    id: 2156,
    name: "Ryzen 7 Extreme Edition",
    g2d: 566,
    dx9: 34,
    dx10: 17,
    dx11: 36,
    dx12: 12,
    overallSpeed: 2339,
  },
  {
    id: 2157,
    name: "Ryzen 7 PRO 4700G with Radeon Graphics",
    g2d: 712,
    dx9: 42,
    dx10: 21,
    dx11: 45,
    dx12: 14,
    overallSpeed: 2880,
  },
  {
    id: 2158,
    name: "Ryzen 7 Pro 4750G with Radeon Graphics",
    g2d: 701,
    dx9: 40,
    dx10: 20,
    dx11: 43,
    dx12: 13,
    overallSpeed: 2678,
  },
  {
    id: 2159,
    name: "Ryzen 7 PRO 4750GE with Radeon Graphics",
    g2d: 683,
    dx9: 37,
    dx10: 17,
    dx11: 41,
    dx12: 14,
    overallSpeed: 2550,
  },
  {
    id: 2160,
    name: "Ryzen 7 PRO 4750U with Radeon Graphics",
    g2d: 548,
    dx9: 32,
    dx10: 15,
    dx11: 33,
    dx12: 10,
    overallSpeed: 2028,
  },
  {
    id: 2161,
    name: "Ryzen 7 PRO 5850U with Radeon Graphics",
    g2d: 788,
    dx9: 40,
    dx10: 16,
    dx11: 44,
    dx12: 14,
    overallSpeed: 2583,
  },
  {
    id: 2162,
    name: "Ryzen 9 4900H with Radeon Graphics",
    g2d: 691,
    dx9: 41,
    dx10: 21,
    dx11: 43,
    dx12: 13,
    overallSpeed: 2714,
  },
  {
    id: 2163,
    name: "Ryzen 9 5900HS with Radeon Graphics",
    g2d: 566,
    dx9: 35,
    dx10: 18,
    dx11: 39,
    dx12: 11,
    overallSpeed: 2413,
  },
  {
    id: 2164,
    name: "Ryzen 9 5900HX with Radeon Graphics",
    g2d: 694,
    dx9: 77,
    dx10: 95,
    dx11: 125,
    dx12: 29,
    overallSpeed: 6973,
  },
  {
    id: 2165,
    name: "Ryzen 9 5980HS with Radeon Graphics",
    g2d: 830,
    dx9: 36,
    dx10: 20,
    dx11: 45,
    dx12: 10,
    overallSpeed: 2534,
  },
  {
    id: 2166,
    name: "S3 5400EW",
    g2d: 11,
    dx9: 7,
    dx10: 1,
    dx11: 0,
    dx12: 0,
    overallSpeed: 144,
  },
  {
    id: 2181,
    name: "T1000",
    g2d: 773,
    price: 396.99,
    dx9: 126,
    dx10: 74,
    dx11: 148,
    dx12: 26,
    overallSpeed: 7613,
    pricePerG3D: 19.18,
  },
  {
    id: 2182,
    name: "T1200 Laptop GPU",
    g2d: 238,
    dx9: 105,
    dx10: 69,
    dx11: 120,
    dx12: 39,
    overallSpeed: 7365,
  },
  {
    id: 2183,
    name: "T400",
    g2d: 652,
    dx9: 65,
    dx10: 28,
    dx11: 75,
    dx12: 12,
    overallSpeed: 3500,
  },
  {
    id: 2184,
    name: "T500",
    g2d: 302,
    dx9: 53,
    dx10: 24,
    dx11: 69,
    dx12: 24,
    overallSpeed: 3755,
  },
  {
    id: 2185,
    name: "T600",
    g2d: 755,
    price: 297,
    dx9: 113,
    dx10: 65,
    dx11: 128,
    dx12: 31,
    overallSpeed: 7061,
    pricePerG3D: 23.78,
  },
  {
    id: 2186,
    name: "T600 Laptop GPU",
    g2d: 314,
    dx9: 120,
    dx10: 67,
    dx11: 143,
    dx12: 31,
    overallSpeed: 7456,
  },
  {
    id: 2190,
    name: "Tesla C2070",
    g2d: 494,
    price: 599,
    dx9: 57,
    dx10: 23,
    dx11: 57,
    dx12: 12,
    overallSpeed: 3101,
    pricePerG3D: 5.18,
  },
  {
    id: 2191,
    name: "Tesla C2075",
    g2d: 589,
    price: 646,
    dx9: 75,
    dx10: 29,
    dx11: 70,
    dx12: 0,
    overallSpeed: 3118,
    pricePerG3D: 4.83,
  },
  {
    id: 2192,
    name: "Tesla M10",
    g2d: 522,
    price: 2690,
    dx9: 55,
    dx10: 31,
    dx11: 61,
    dx12: 18,
    overallSpeed: 3490,
    pricePerG3D: 1.3,
  },
  {
    id: 2194,
    name: "Tesla M40",
    g2d: 302,
    price: 595,
    dx9: 95,
    dx10: 95,
    dx11: 178,
    dx12: 36,
    overallSpeed: 7950,
    pricePerG3D: 13.36,
  },
  {
    id: 2195,
    name: "Tesla M6",
    g2d: 441,
    price: 229,
    dx9: 123,
    dx10: 83,
    dx11: 139,
    dx12: 23,
    overallSpeed: 7509,
    pricePerG3D: 32.79,
  },
  {
    id: 2196,
    name: "Tesla M60",
    g2d: 569,
    price: 1395,
    dx9: 134,
    dx10: 84,
    dx11: 86,
    dx12: 33,
    overallSpeed: 7692,
    pricePerG3D: 5.51,
  },
  {
    id: 2198,
    name: "Tesla T10",
    g2d: 624,
    dx9: 149,
    dx10: 221,
    dx11: 319,
    dx12: 35,
    overallSpeed: 13264,
  },
  {
    id: 2199,
    name: "Tesla T4",
    g2d: 580,
    price: 2352.99,
    dx9: 123,
    dx10: 163,
    dx11: 208,
    dx12: 43,
    overallSpeed: 11397,
    pricePerG3D: 4.84,
  },
  {
    id: 2200,
    name: "Tesla V100-SXM2-16GB",
    g2d: 406,
    dx9: 167,
    dx10: 236,
    dx11: 270,
    dx12: 70,
    overallSpeed: 16235,
  },
  {
    id: 2201,
    name: "TITAN RTX",
    g2d: 843,
    price: 4748.37,
    dx9: 220,
    dx10: 296,
    dx11: 433,
    dx12: 85,
    overallSpeed: 19874,
    pricePerG3D: 4.19,
  },
  {
    id: 2202,
    name: "TITAN V",
    g2d: 855,
    price: 2599.99,
    dx9: 215,
    dx10: 333,
    dx11: 393,
    dx12: 63,
    overallSpeed: 18991,
    pricePerG3D: 7.3,
  },
  {
    id: 2204,
    name: "TITAN Xp",
    g2d: 949,
    dx9: 237,
    dx10: 260,
    dx11: 394,
    dx12: 59,
    overallSpeed: 18875,
  },
  {
    id: 2205,
    name: "TITAN Xp COLLECTORS EDITION",
    g2d: 891,
    dx9: 207,
    dx10: 259,
    dx11: 428,
    dx12: 64,
    overallSpeed: 18344,
  },
  {
    id: 2210,
    name: "VIA/S3G C-645/640 GPU",
    g2d: 122,
    dx9: 5,
    dx10: 1,
    dx11: 3,
    dx12: 0,
    overallSpeed: 163,
  },
  {
    id: 2233,
    name: "zxcvIntel HD 620",
    g2d: 208,
    dx9: 13,
    dx10: 7,
    dx11: 19,
    dx12: 5,
    overallSpeed: 944,
  },
];
